import type { PlantMaterialGeoJSONPropertiesAdHoc } from '../src/gql/plant-materials';
import type { FileUpload } from '../src/gql/graphql-upload';
import type { DocumentNode } from 'graphql';
import * as Operations from './graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  GeoJSONGeometry: { input: GeoJSON.Geometry; output: GeoJSON.Geometry; }
  JSON: { input: any; output: any; }
  JSONObject: { input: Record<string, any>; output: Record<string, any>; }
  PlantMaterialGeoJSONPropertiesAdHoc: { input: PlantMaterialGeoJSONPropertiesAdHoc; output: PlantMaterialGeoJSONPropertiesAdHoc; }
  Upload: { input: FileUpload; output: FileUpload; }
};

export enum AccessRole {
  Admin = 'ADMIN',
  Editor = 'EDITOR',
  ReadOnly = 'READ_ONLY'
}

/** Individual (or group of) plant material belonging to a single taxon (unique scientific name) with identical parentage */
export type Accession = {
  __typename?: 'Accession';
  accessionDate?: Maybe<Scalars['Date']['output']>;
  accessionNumber: Scalars['String']['output'];
  accessionNumberFormat?: Maybe<AccessionNumberFormat>;
  accessionNumberPrefix?: Maybe<Scalars['Int']['output']>;
  accessionNumberSuffix?: Maybe<Scalars['Int']['output']>;
  archived: Scalars['Boolean']['output'];
  collectionAssociatedTaxa?: Maybe<Scalars['String']['output']>;
  collectionCollectors?: Maybe<Scalars['String']['output']>;
  collectionCollectorsFieldNumber?: Maybe<Scalars['String']['output']>;
  collectionCoordinateUncertainty?: Maybe<Scalars['Int']['output']>;
  collectionCountry?: Maybe<Country>;
  collectionCountryCode?: Maybe<Scalars['String']['output']>;
  collectionDate?: Maybe<Scalars['Date']['output']>;
  collectionElevation?: Maybe<Scalars['String']['output']>;
  collectionHabitat?: Maybe<Scalars['String']['output']>;
  collectionLatitude?: Maybe<Scalars['String']['output']>;
  collectionLocality?: Maybe<Scalars['String']['output']>;
  collectionLocation?: Maybe<Scalars['String']['output']>;
  collectionLongitude?: Maybe<Scalars['String']['output']>;
  collectionRemarks?: Maybe<Scalars['String']['output']>;
  collectionSite?: Maybe<CollectionSite>;
  collectionSiteId: Scalars['ID']['output'];
  collectionStateProvince?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['ID']['output']>;
  createdByInitials?: Maybe<Scalars['String']['output']>;
  dateIdentified?: Maybe<Scalars['Date']['output']>;
  deaccessionDate?: Maybe<Scalars['Date']['output']>;
  donor?: Maybe<Scalars['String']['output']>;
  exogenousAccessionNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use historyConnection instead */
  history?: Maybe<Array<AccessionHistory>>;
  historyConnection?: Maybe<AccessionHistoryConnection>;
  id: Scalars['ID']['output'];
  identificationQualifier?: Maybe<Scalars['String']['output']>;
  identificationRemarks?: Maybe<Scalars['String']['output']>;
  identificationVerificationStatus?: Maybe<Scalars['String']['output']>;
  identifiedBy?: Maybe<Scalars['String']['output']>;
  ipenNumber?: Maybe<Scalars['String']['output']>;
  materialReceived?: Maybe<MaterialType>;
  materialReceivedCode?: Maybe<Scalars['String']['output']>;
  materialType?: Maybe<MaterialType>;
  materialTypeId?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notesData?: Maybe<Scalars['JSON']['output']>;
  parentageNotes?: Maybe<Scalars['String']['output']>;
  parentageNotesData?: Maybe<Scalars['JSON']['output']>;
  plantMaterial?: Maybe<Array<PlantMaterial>>;
  propagationHistoryCode?: Maybe<PropagationHistoryCode>;
  provenanceCategory?: Maybe<ProvenanceCategory>;
  provenanceCategoryCode: ProvenanceCategoryCode;
  scientificName?: Maybe<Scalars['String']['output']>;
  /** Additional supplemental data associated with the taxon. */
  supplementalData?: Maybe<Scalars['JSONObject']['output']>;
  /** @deprecated Use tagsConnection instead */
  tags?: Maybe<Array<RecordTag>>;
  tagsConnection?: Maybe<RecordTagConnection>;
  taxon?: Maybe<Taxon>;
  taxonId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['ID']['output']>;
  wasManualImport: Scalars['Boolean']['output'];
};


/** Individual (or group of) plant material belonging to a single taxon (unique scientific name) with identical parentage */
export type AccessionPlantMaterialArgs = {
  filters?: InputMaybe<PlantMaterialFilter>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Page for `Accession` */
export type AccessionConnection = {
  __typename?: 'AccessionConnection';
  edges: Array<AccessionEdge>;
  nodes: Array<Accession>;
  pageInfo: PageInfo;
};

export type AccessionDataUpdates = {
  accessionDate?: InputMaybe<Scalars['Date']['input']>;
  accessionNumberFormat?: InputMaybe<AccessionNumberFormat>;
  accessionNumberPrefix?: InputMaybe<Scalars['Int']['input']>;
  accessionNumberSuffix?: InputMaybe<Scalars['Int']['input']>;
  dateIdentified?: InputMaybe<Scalars['Date']['input']>;
  donor?: InputMaybe<Scalars['String']['input']>;
  exogenousAccessionNumber?: InputMaybe<Scalars['String']['input']>;
  identificationQualifier?: InputMaybe<Scalars['String']['input']>;
  identificationRemarks?: InputMaybe<Scalars['String']['input']>;
  identificationVerificationStatus?: InputMaybe<Scalars['String']['input']>;
  identifiedBy?: InputMaybe<Scalars['String']['input']>;
  ipenNumber?: InputMaybe<Scalars['String']['input']>;
  materialReceivedCode?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesData?: InputMaybe<Scalars['JSON']['input']>;
  parentageNotes?: InputMaybe<Scalars['String']['input']>;
  parentageNotesData?: InputMaybe<Scalars['JSON']['input']>;
  propagationHistoryCode?: InputMaybe<PropagationHistoryCode>;
  provenanceCategoryCode?: InputMaybe<ProvenanceCategoryCode>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
  taxonId?: InputMaybe<Scalars['String']['input']>;
};

export type AccessionEdge = {
  __typename?: 'AccessionEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Accession;
};

export type AccessionFilter = {
  accessionDate?: InputMaybe<DateComparator>;
  and?: InputMaybe<Array<AccessionFilter>>;
  archived?: InputMaybe<BooleanComparator>;
  createdBy?: InputMaybe<NullableUserFilter>;
  deaccessionDate?: InputMaybe<DateComparator>;
  donor?: InputMaybe<NullableStringComparator>;
  excludeDeaccessioned?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdComparator>;
  ipenNumber?: InputMaybe<NullableStringComparator>;
  materialReceived?: InputMaybe<MaterialTypeFilter>;
  materialType?: InputMaybe<MaterialTypeFilter>;
  notes?: InputMaybe<NullableStringComparator>;
  or?: InputMaybe<Array<AccessionFilter>>;
  provenance?: InputMaybe<ProvenanceFilter>;
  tags?: InputMaybe<RecordTagFilter>;
  taxaTags?: InputMaybe<RecordTagFilter>;
  taxon?: InputMaybe<TaxaFilter>;
  updatedBy?: InputMaybe<NullableUserFilter>;
};

export type AccessionHistory = {
  __typename?: 'AccessionHistory';
  accession?: Maybe<Accession>;
  accessionId: Scalars['String']['output'];
  archivedPlantMaterial?: Maybe<PlantMaterial>;
  archivedPlantMaterialId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdPlantMaterial?: Maybe<PlantMaterial>;
  createdPlantMaterialId?: Maybe<Scalars['String']['output']>;
  fromAccessionDate?: Maybe<Scalars['Date']['output']>;
  fromAccessionNumber?: Maybe<Scalars['String']['output']>;
  fromAccessionNumberFormat?: Maybe<AccessionNumberFormat>;
  fromCollectionAssociatedTaxa?: Maybe<Scalars['String']['output']>;
  fromCollectionCollectors?: Maybe<Scalars['String']['output']>;
  fromCollectionCollectorsFieldNumber?: Maybe<Scalars['String']['output']>;
  fromCollectionCoordinateUncertainty?: Maybe<Scalars['Int']['output']>;
  fromCollectionCountry?: Maybe<Country>;
  fromCollectionCountryCode?: Maybe<Scalars['String']['output']>;
  fromCollectionDate?: Maybe<Scalars['Date']['output']>;
  fromCollectionElevation?: Maybe<Scalars['String']['output']>;
  fromCollectionHabitat?: Maybe<Scalars['String']['output']>;
  fromCollectionLatitude?: Maybe<Scalars['String']['output']>;
  fromCollectionLocality?: Maybe<Scalars['String']['output']>;
  fromCollectionLocation?: Maybe<Scalars['String']['output']>;
  fromCollectionLongitude?: Maybe<Scalars['String']['output']>;
  fromCollectionRemarks?: Maybe<Scalars['String']['output']>;
  fromCollectionStateProvince?: Maybe<Scalars['String']['output']>;
  fromDateIdentified?: Maybe<Scalars['Date']['output']>;
  fromDonor?: Maybe<Scalars['String']['output']>;
  fromIdentificationQualifier?: Maybe<Scalars['String']['output']>;
  fromIdentificationRemarks?: Maybe<Scalars['String']['output']>;
  fromIdentificationVerificationStatus?: Maybe<Scalars['String']['output']>;
  fromIdentifiedBy?: Maybe<Scalars['String']['output']>;
  fromIpenNumber?: Maybe<Scalars['String']['output']>;
  fromMaterialReceived?: Maybe<MaterialType>;
  fromMaterialReceivedCode?: Maybe<Scalars['String']['output']>;
  fromMaterialType?: Maybe<MaterialType>;
  fromMaterialTypeId?: Maybe<Scalars['String']['output']>;
  fromNotes?: Maybe<Scalars['String']['output']>;
  fromParentageNotes?: Maybe<Scalars['String']['output']>;
  fromPropagationHistoryCode?: Maybe<PropagationHistoryCode>;
  fromProvenanceCategory?: Maybe<ProvenanceCategory>;
  fromProvenanceCategoryCode?: Maybe<ProvenanceCategoryCode>;
  fromScientificName?: Maybe<Scalars['String']['output']>;
  fromTaxon?: Maybe<Taxon>;
  fromTaxonId?: Maybe<Scalars['String']['output']>;
  historicCreatedByInitials?: Maybe<Scalars['String']['output']>;
  restoredPlantMaterial?: Maybe<PlantMaterial>;
  restoredPlantMaterialId?: Maybe<Scalars['String']['output']>;
  toAccessionDate?: Maybe<Scalars['Date']['output']>;
  toAccessionNumber?: Maybe<Scalars['String']['output']>;
  toAccessionNumberFormat?: Maybe<AccessionNumberFormat>;
  toCollectionAssociatedTaxa?: Maybe<Scalars['String']['output']>;
  toCollectionCollectors?: Maybe<Scalars['String']['output']>;
  toCollectionCollectorsFieldNumber?: Maybe<Scalars['String']['output']>;
  toCollectionCoordinateUncertainty?: Maybe<Scalars['Int']['output']>;
  toCollectionCountry?: Maybe<Country>;
  toCollectionCountryCode?: Maybe<Scalars['String']['output']>;
  toCollectionDate?: Maybe<Scalars['Date']['output']>;
  toCollectionElevation?: Maybe<Scalars['String']['output']>;
  toCollectionHabitat?: Maybe<Scalars['String']['output']>;
  toCollectionLatitude?: Maybe<Scalars['String']['output']>;
  toCollectionLocality?: Maybe<Scalars['String']['output']>;
  toCollectionLocation?: Maybe<Scalars['String']['output']>;
  toCollectionLongitude?: Maybe<Scalars['String']['output']>;
  toCollectionRemarks?: Maybe<Scalars['String']['output']>;
  toCollectionStateProvince?: Maybe<Scalars['String']['output']>;
  toDateIdentified?: Maybe<Scalars['Date']['output']>;
  toDonor?: Maybe<Scalars['String']['output']>;
  toIdentificationQualifier?: Maybe<Scalars['String']['output']>;
  toIdentificationRemarks?: Maybe<Scalars['String']['output']>;
  toIdentificationVerificationStatus?: Maybe<Scalars['String']['output']>;
  toIdentifiedBy?: Maybe<Scalars['String']['output']>;
  toIpenNumber?: Maybe<Scalars['String']['output']>;
  toMaterialReceived?: Maybe<MaterialType>;
  toMaterialReceivedCode?: Maybe<Scalars['String']['output']>;
  toMaterialType?: Maybe<MaterialType>;
  toMaterialTypeId?: Maybe<Scalars['String']['output']>;
  toNotes?: Maybe<Scalars['String']['output']>;
  toParentageNotes?: Maybe<Scalars['String']['output']>;
  toPropagationHistoryCode?: Maybe<PropagationHistoryCode>;
  toProvenanceCategory?: Maybe<ProvenanceCategory>;
  toProvenanceCategoryCode?: Maybe<ProvenanceCategoryCode>;
  toScientificName?: Maybe<Scalars['String']['output']>;
  toTaxon?: Maybe<Taxon>;
  toTaxonId?: Maybe<Scalars['String']['output']>;
  wasArchived?: Maybe<Scalars['Boolean']['output']>;
  wasDeaccessioned?: Maybe<Scalars['Boolean']['output']>;
  wasManualImport: Scalars['Boolean']['output'];
  wasReinstated?: Maybe<Scalars['Boolean']['output']>;
  wasRestored?: Maybe<Scalars['Boolean']['output']>;
};

export type AccessionHistoryConnection = {
  __typename?: 'AccessionHistoryConnection';
  edges: Array<AccessionHistoryEdge>;
  nodes: Array<AccessionHistory>;
  pageInfo: PageInfo;
};

export type AccessionHistoryEdge = {
  __typename?: 'AccessionHistoryEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: AccessionHistory;
};

export enum AccessionNumberFormat {
  Exogenous = 'EXOGENOUS',
  PrefixSuffix = 'PREFIX_SUFFIX'
}

export type AccessionNumberSort = {
  order?: InputMaybe<SortOrder>;
};

export type AccessionPayload = {
  __typename?: 'AccessionPayload';
  accession?: Maybe<Accession>;
  success: Scalars['Boolean']['output'];
};

export enum AccessionsColumn {
  AccessionDate = 'ACCESSION_DATE',
  AccessionNum = 'ACCESSION_NUM',
  CommonName = 'COMMON_NAME',
  DonorSupplier = 'DONOR_SUPPLIER',
  GlobalRedListStatus = 'GLOBAL_RED_LIST_STATUS',
  LastUpdated = 'LAST_UPDATED',
  ProvenanceCategoryCode = 'PROVENANCE_CATEGORY_CODE',
  ScientificName = 'SCIENTIFIC_NAME'
}

export type AccessionsNotFoundError = Error & {
  __typename?: 'AccessionsNotFoundError';
  message: Scalars['String']['output'];
  missingAccessions: Array<MissingAccession>;
};

export type AccessionsOrderByInput = {
  direction: SortDirection;
  field: AccessionsColumn;
};

export enum AccessionsSearchColumn {
  AccessionNum = 'ACCESSION_NUM',
  ScientificName = 'SCIENTIFIC_NAME'
}

export type AccessionsSearchTerm = {
  field: AccessionsSearchColumn;
  value: Scalars['String']['input'];
};

export type Activity = {
  __typename?: 'Activity';
  accession?: Maybe<Accession>;
  accessionId?: Maybe<Scalars['ID']['output']>;
  plantMaterial?: Maybe<PlantMaterial>;
  plantMaterialId?: Maybe<Scalars['ID']['output']>;
  taxon?: Maybe<Taxon>;
  taxonId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['ID']['output']>;
};

export enum ActivityEntity {
  Accession = 'ACCESSION',
  PlantMaterial = 'PLANT_MATERIAL',
  Taxa = 'TAXA'
}

export type ActivityFilter = {
  entity?: InputMaybe<ActivityEntity>;
};

export type ArchiveResult = {
  __typename?: 'ArchiveResult';
  success: Scalars['Boolean']['output'];
};

export type AssociatedAccessionsError = Error & {
  __typename?: 'AssociatedAccessionsError';
  message: Scalars['String']['output'];
  taxa: Array<Taxon>;
};

export type BaseMap = {
  __typename?: 'BaseMap';
  attribution?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  maxZoom?: Maybe<Scalars['Int']['output']>;
  minZoom?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  url: Scalars['String']['output'];
};

export type BatchAccessionsPayload = {
  __typename?: 'BatchAccessionsPayload';
  accessions: Array<Accession>;
  errors?: Maybe<Array<GenericError>>;
  success: Scalars['Boolean']['output'];
};

export type BatchCreateObservationInput = {
  condition: ObservationConditionType;
  materialIds: Array<Scalars['ID']['input']>;
};

export type BatchMaterialImagePayload = {
  __typename?: 'BatchMaterialImagePayload';
  materialImages: Array<MaterialImage>;
  success: Scalars['Boolean']['output'];
};

export type BatchObservationPayload = {
  __typename?: 'BatchObservationPayload';
  observations: Array<Observation>;
  success: Scalars['Boolean']['output'];
};

export type BatchPlantMaterialPayload = {
  __typename?: 'BatchPlantMaterialPayload';
  errors?: Maybe<Array<GenericError>>;
  plantMaterials: Array<PlantMaterial>;
  success: Scalars['Boolean']['output'];
};

export type BatchTaxaError = AssociatedAccessionsError | GenericError;

export type BatchTaxaPayload = {
  __typename?: 'BatchTaxaPayload';
  errors?: Maybe<Array<BatchTaxaError>>;
  success: Scalars['Boolean']['output'];
  taxa: Array<Taxon>;
};

export enum BillingCycle {
  Year = 'YEAR'
}

export enum BillingStatus {
  Active = 'ACTIVE',
  Paused = 'PAUSED',
  Trial = 'TRIAL'
}

export type BooleanComparator = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Circle = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  radius: Scalars['Float']['input'];
  units: LengthUnit;
};

export type Classification = {
  __typename?: 'Classification';
  class?: Maybe<Scalars['String']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  genus?: Maybe<Scalars['String']['output']>;
  infraspecies?: Maybe<Scalars['String']['output']>;
  kingdom?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['String']['output']>;
  phylum?: Maybe<Scalars['String']['output']>;
  section?: Maybe<Scalars['String']['output']>;
  series?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  subclass?: Maybe<Scalars['String']['output']>;
  subfamily?: Maybe<Scalars['String']['output']>;
  subgenus?: Maybe<Scalars['String']['output']>;
  subkingdom?: Maybe<Scalars['String']['output']>;
  suborder?: Maybe<Scalars['String']['output']>;
  subphylum?: Maybe<Scalars['String']['output']>;
  subsection?: Maybe<Scalars['String']['output']>;
  subseries?: Maybe<Scalars['String']['output']>;
  subspecies?: Maybe<Scalars['String']['output']>;
  subtribe?: Maybe<Scalars['String']['output']>;
  superorder?: Maybe<Scalars['String']['output']>;
  tribe?: Maybe<Scalars['String']['output']>;
};

export type ClassificationFilter = {
  class?: InputMaybe<NullableStringComparator>;
  family?: InputMaybe<NullableStringComparator>;
  genus?: InputMaybe<NullableStringComparator>;
  infraspecies?: InputMaybe<NullableStringComparator>;
  kingdom?: InputMaybe<NullableStringComparator>;
  order?: InputMaybe<NullableStringComparator>;
  phylum?: InputMaybe<NullableStringComparator>;
  section?: InputMaybe<NullableStringComparator>;
  series?: InputMaybe<NullableStringComparator>;
  species?: InputMaybe<NullableStringComparator>;
  subclass?: InputMaybe<NullableStringComparator>;
  subfamily?: InputMaybe<NullableStringComparator>;
  subgenus?: InputMaybe<NullableStringComparator>;
  subkingdom?: InputMaybe<NullableStringComparator>;
  suborder?: InputMaybe<NullableStringComparator>;
  subphylum?: InputMaybe<NullableStringComparator>;
  subsection?: InputMaybe<NullableStringComparator>;
  subseries?: InputMaybe<NullableStringComparator>;
  subspecies?: InputMaybe<NullableStringComparator>;
  subtribe?: InputMaybe<NullableStringComparator>;
  superorder?: InputMaybe<NullableStringComparator>;
  tribe?: InputMaybe<NullableStringComparator>;
};

export type CollectionDataUpdates = {
  collectionAssociatedTaxa?: InputMaybe<Scalars['String']['input']>;
  collectionCollectors?: InputMaybe<Scalars['String']['input']>;
  collectionCollectorsFieldNumber?: InputMaybe<Scalars['String']['input']>;
  collectionCoordinateUncertainty?: InputMaybe<Scalars['Int']['input']>;
  collectionCountryCode?: InputMaybe<Scalars['String']['input']>;
  collectionDate?: InputMaybe<Scalars['Date']['input']>;
  collectionElevation?: InputMaybe<Scalars['String']['input']>;
  collectionHabitat?: InputMaybe<Scalars['String']['input']>;
  collectionLatitude?: InputMaybe<Scalars['String']['input']>;
  collectionLocality?: InputMaybe<Scalars['String']['input']>;
  collectionLocation?: InputMaybe<Scalars['String']['input']>;
  collectionLongitude?: InputMaybe<Scalars['String']['input']>;
  collectionRemarks?: InputMaybe<Scalars['String']['input']>;
  collectionStateProvince?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionLocationsNotFoundError = Error & {
  __typename?: 'CollectionLocationsNotFoundError';
  message: Scalars['String']['output'];
  missingLocations: Array<MissingLocation>;
};

/** Name of individual garden being managed by collection owner */
export type CollectionSite = {
  __typename?: 'CollectionSite';
  accession?: Maybe<Accession>;
  accessionTotal?: Maybe<Scalars['Int']['output']>;
  accessions?: Maybe<AccessionConnection>;
  activity?: Maybe<Array<Activity>>;
  baseMap?: Maybe<BaseMap>;
  baseMapId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  donors?: Maybe<ContactConnection>;
  id: Scalars['ID']['output'];
  /** @deprecated No longer used, fields are enabled by default */
  identificationFieldsEnabled: Scalars['Boolean']['output'];
  /** @deprecated No longer used, fields are enabled by default */
  ipenNumbersEnabled: Scalars['Boolean']['output'];
  lifeForms?: Maybe<LifeFormConnection>;
  location?: Maybe<Location>;
  /** @deprecated Use locationsConnection instead */
  locations?: Maybe<Array<CollectionSiteLocation>>;
  locationsConnection?: Maybe<LocationConnection>;
  locationsGeometry?: Maybe<Scalars['JSON']['output']>;
  locationsTotal?: Maybe<Scalars['Int']['output']>;
  manualAccessionNumberErrors?: Maybe<Array<ManualAccessionNumberError>>;
  mapCenterLatitude?: Maybe<Scalars['Float']['output']>;
  mapCenterLongitude?: Maybe<Scalars['Float']['output']>;
  mapZoomLevel?: Maybe<Scalars['Float']['output']>;
  materialQualifierFormat: MaterialQualifierFormat;
  members?: Maybe<Array<User>>;
  name: Scalars['String']['output'];
  observationConditionCounts?: Maybe<Array<ObservationConditionCount>>;
  observationHistoricSnapshots?: Maybe<Array<ObservationsHistoricSnapshot>>;
  organisation?: Maybe<Organisation>;
  organisationId: Scalars['ID']['output'];
  plantMaterial?: Maybe<PlantMaterial>;
  plantMaterialTotal?: Maybe<Scalars['Int']['output']>;
  plantMaterials?: Maybe<PlantMaterialConnection>;
  plantMaterialsAsGeoJSON?: Maybe<Scalars['JSON']['output']>;
  plantMaterialsGeometry?: Maybe<PlantMaterialGeoJsonFeatureCollection>;
  plantMaterialsGeometryWithinCircleWIP?: Maybe<PlantMaterialGeoJsonFeatureCollection>;
  provenanceCategoryCounts?: Maybe<Array<ProvenanceCategoryCount>>;
  /** Whether the site is publicly visible. */
  public: Scalars['Boolean']['output'];
  publicAbout?: Maybe<Scalars['String']['output']>;
  publicContactEmail?: Maybe<Scalars['String']['output']>;
  publicCountry?: Maybe<Country>;
  publicCountryCode?: Maybe<Scalars['String']['output']>;
  publicDefaultBaseMap?: Maybe<BaseMap>;
  publicDefaultBaseMapId?: Maybe<Scalars['ID']['output']>;
  publicLocation?: Maybe<Scalars['String']['output']>;
  publicWebsite?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use tags instead */
  recordTags?: Maybe<Array<RecordTag>>;
  redListStatusCounts?: Maybe<Array<RedListStatusCount>>;
  /** @deprecated No longer used, fields are enabled by default */
  sexEnabled: Scalars['Boolean']['output'];
  sharedScientificNames?: Maybe<ScientificNameConnection>;
  shortenedName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use sharedScientificNames instead */
  supraspecificTaxa?: Maybe<SupraspecificTaxaConnection>;
  /** @deprecated No longer used, fields are enabled by default */
  tagNumbersEnabled: Scalars['Boolean']['output'];
  tags?: Maybe<RecordTagConnection>;
  taxa?: Maybe<TaxonConnection>;
  taxaTotal?: Maybe<Scalars['Int']['output']>;
  taxonCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
  urlSlug: Scalars['String']['output'];
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteAccessionArgs = {
  accessionNumber: Scalars['String']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteAccessionTotalArgs = {
  filters?: InputMaybe<AccessionFilter>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<AccessionsSearchTerm>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteAccessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AccessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccessionsOrderByInput>;
  searchTerm?: InputMaybe<AccessionsSearchTerm>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteActivityArgs = {
  filter?: InputMaybe<ActivityFilter>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteDonorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteLocationArgs = {
  name: Scalars['String']['input'];
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteLocationsArgs = {
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LocationOrderByInput>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteLocationsGeometryArgs = {
  filter?: InputMaybe<LocationFilter>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteLocationsTotalArgs = {
  filter?: InputMaybe<LocationFilter>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteManualAccessionNumberErrorsArgs = {
  accessionNumberPrefix?: InputMaybe<Scalars['Int']['input']>;
  accessionNumberSuffix?: InputMaybe<Scalars['Int']['input']>;
  exogenousAccessionNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteMembersArgs = {
  filter?: InputMaybe<UserFilter>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSitePlantMaterialArgs = {
  accessionNumber: Scalars['String']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  qualifier: Scalars['String']['input'];
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSitePlantMaterialTotalArgs = {
  filters?: InputMaybe<PlantMaterialFilter>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<PlantMaterialsSearchTerm>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSitePlantMaterialsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PlantMaterialFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PlantMaterialsOrderByInput>;
  searchTerm?: InputMaybe<PlantMaterialsSearchTerm>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSitePlantMaterialsAsGeoJsonArgs = {
  filters?: InputMaybe<PlantMaterialFilter>;
  orderBy?: InputMaybe<PlantMaterialsOrderByInput>;
  searchTerm?: InputMaybe<PlantMaterialsSearchTerm>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSitePlantMaterialsGeometryArgs = {
  filters?: InputMaybe<PlantMaterialFilter>;
  orderBy?: InputMaybe<PlantMaterialsOrderByInput>;
  searchTerm?: InputMaybe<PlantMaterialsSearchTerm>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSitePlantMaterialsGeometryWithinCircleWipArgs = {
  bounds: Circle;
  filters?: InputMaybe<PlantMaterialFilter>;
  orderBy?: InputMaybe<PlantMaterialsOrderByInput>;
  searchTerm?: InputMaybe<PlantMaterialsSearchTerm>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteProvenanceCategoryCountsArgs = {
  filters?: InputMaybe<AccessionFilter>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteRecordTagsArgs = {
  filters?: InputMaybe<RecordTagFilters>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteSharedScientificNamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ScientificNameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ScientificNameOrderBy>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteSupraspecificTaxaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SupraspecificTaxaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SupraspecificTaxaOrderBy>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteTagsArgs = {
  filters?: InputMaybe<RecordTagFilters>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteTaxaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TaxaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TaxaOrderByInput>;
  searchTerm?: InputMaybe<TaxaSearchTerm>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteTaxaTotalArgs = {
  filter?: InputMaybe<TaxaFilter>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<TaxaSearchTerm>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Name of individual garden being managed by collection owner */
export type CollectionSiteTaxonCountArgs = {
  filters?: InputMaybe<AccessionFilter>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CollectionSiteFilter = {
  id?: InputMaybe<IdComparator>;
  slug?: InputMaybe<StringComparator>;
};

/** Location in an individual garden (Collection Site), where plant material is situated */
export type CollectionSiteLocation = {
  __typename?: 'CollectionSiteLocation';
  archived: Scalars['Boolean']['output'];
  /** @deprecated Use name instead */
  code?: Maybe<Scalars['String']['output']>;
  collectionSite?: Maybe<CollectionSite>;
  collectionSiteId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  totalPlantMaterial?: Maybe<Scalars['Int']['output']>;
};

export type CollectionSiteLocationUpdates = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionSiteMembership = {
  __typename?: 'CollectionSiteMembership';
  collectionSite?: Maybe<CollectionSite>;
  collectionSiteId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type CollectionSiteMembershipPayload = {
  __typename?: 'CollectionSiteMembershipPayload';
  membership?: Maybe<CollectionSiteMembership>;
  success: Scalars['Boolean']['output'];
};

export type CollectionSiteResult = {
  __typename?: 'CollectionSiteResult';
  collectionSite?: Maybe<CollectionSite>;
  errors?: Maybe<Array<CollectionSiteResultErrors>>;
  success: Scalars['Boolean']['output'];
};

export type CollectionSiteResultErrors = DuplicateNameError | DuplicateUrlSlugError | GenericError;

export type CollectionSiteUpdates = {
  baseMap?: InputMaybe<CreateBaseMapInput>;
  identificationFieldsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ipenNumbersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  mapCenterLatitude?: InputMaybe<Scalars['Float']['input']>;
  mapCenterLongitude?: InputMaybe<Scalars['Float']['input']>;
  mapZoomLevel?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether the site is publicly visible, can only be changed by admins. */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  publicAbout?: InputMaybe<Scalars['String']['input']>;
  publicContactEmail?: InputMaybe<Scalars['String']['input']>;
  publicCountryCode?: InputMaybe<Scalars['String']['input']>;
  publicDefaultBaseMapId?: InputMaybe<Scalars['ID']['input']>;
  publicLocation?: InputMaybe<Scalars['String']['input']>;
  publicWebsite?: InputMaybe<Scalars['String']['input']>;
  sexEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  shortenedName?: InputMaybe<Scalars['String']['input']>;
  tagNumbersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  urlSlug?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionSitesNotFoundError = Error & {
  __typename?: 'CollectionSitesNotFoundError';
  message: Scalars['String']['output'];
  missingSites: Array<Scalars['String']['output']>;
};

export enum Condition {
  Excellent = 'EXCELLENT',
  Fair = 'FAIR',
  Good = 'GOOD',
  Poor = 'POOR',
  VeryPoor = 'VERY_POOR'
}

export type ConditionFilter = {
  and?: InputMaybe<Array<ConditionFilter>>;
  eq?: InputMaybe<Condition>;
  neq?: InputMaybe<Condition>;
  or?: InputMaybe<Array<ConditionFilter>>;
};

export type Contact = {
  __typename?: 'Contact';
  name: Scalars['String']['output'];
};

export type ContactConnection = {
  __typename?: 'ContactConnection';
  edges: Array<ContactEdge>;
  nodes: Array<Contact>;
  pageInfo: PageInfo;
};

export type ContactEdge = {
  __typename?: 'ContactEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Contact;
};

/** A continent is one of several large landmasses */
export enum Continent {
  Africa = 'AFRICA',
  Antarctica = 'ANTARCTICA',
  Asia = 'ASIA',
  Europe = 'EUROPE',
  NorthAmerica = 'NORTH_AMERICA',
  Oceania = 'OCEANIA',
  SouthAmerica = 'SOUTH_AMERICA'
}

/** A country is a distinct territorial body or political entity */
export type Country = {
  __typename?: 'Country';
  archived: Scalars['Boolean']['output'];
  codeId: Scalars['String']['output'];
  continent: Continent;
  countryCodeAlpha2?: Maybe<Scalars['String']['output']>;
  countryCodeNumeric?: Maybe<Scalars['String']['output']>;
  extant: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CreateAccession = {
  accessionDate: Scalars['Date']['input'];
  accessionNumberFormat?: InputMaybe<AccessionNumberFormat>;
  accessionNumberPrefix?: InputMaybe<Scalars['Int']['input']>;
  accessionNumberSuffix?: InputMaybe<Scalars['Int']['input']>;
  collectionAssociatedTaxa?: InputMaybe<Scalars['String']['input']>;
  collectionCollectors?: InputMaybe<Scalars['String']['input']>;
  collectionCollectorsFieldNumber?: InputMaybe<Scalars['String']['input']>;
  collectionCoordinateUncertainty?: InputMaybe<Scalars['Int']['input']>;
  collectionCountryCode?: InputMaybe<Scalars['String']['input']>;
  collectionDate?: InputMaybe<Scalars['Date']['input']>;
  collectionElevation?: InputMaybe<Scalars['String']['input']>;
  collectionHabitat?: InputMaybe<Scalars['String']['input']>;
  collectionLatitude?: InputMaybe<Scalars['String']['input']>;
  collectionLocality?: InputMaybe<Scalars['String']['input']>;
  collectionLocation?: InputMaybe<Scalars['String']['input']>;
  collectionLongitude?: InputMaybe<Scalars['String']['input']>;
  collectionRemarks?: InputMaybe<Scalars['String']['input']>;
  collectionSiteId: Scalars['ID']['input'];
  collectionStateProvince?: InputMaybe<Scalars['String']['input']>;
  createdByInitials?: InputMaybe<Scalars['String']['input']>;
  dateIdentified?: InputMaybe<Scalars['Date']['input']>;
  deaccessionDate?: InputMaybe<Scalars['Date']['input']>;
  donor?: InputMaybe<Scalars['String']['input']>;
  exogenousAccessionNumber?: InputMaybe<Scalars['String']['input']>;
  /** Optional identifier, if not provided one will be generated */
  id?: InputMaybe<Scalars['ID']['input']>;
  identificationQualifier?: InputMaybe<Scalars['String']['input']>;
  identificationRemarks?: InputMaybe<Scalars['String']['input']>;
  identificationVerificationStatus?: InputMaybe<Scalars['String']['input']>;
  identifiedBy?: InputMaybe<Scalars['String']['input']>;
  ipenNumber?: InputMaybe<Scalars['String']['input']>;
  isManualImport?: InputMaybe<Scalars['Boolean']['input']>;
  materialReceivedCode?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesData?: InputMaybe<Scalars['JSON']['input']>;
  parentageNotes?: InputMaybe<Scalars['String']['input']>;
  parentageNotesData?: InputMaybe<Scalars['JSON']['input']>;
  plantMaterial?: InputMaybe<Array<PlantMaterialInput>>;
  propagationHistoryCode?: InputMaybe<PropagationHistoryCode>;
  provenanceCategoryCode: ProvenanceCategoryCode;
  /** Additional supplemental data associated with the taxon. */
  supplementalData?: InputMaybe<Scalars['JSONObject']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  taxonId: Scalars['ID']['input'];
};

export type CreateAccessionsResult = CollectionSitesNotFoundError | CreateAccessionsSuccess | DuplicateAccessionNumbersError | GenericError | InvalidMaterialTypeCodesError | InvalidSiteIdsError;

export type CreateAccessionsSuccess = {
  __typename?: 'CreateAccessionsSuccess';
  createdAccessions: Array<CreatedAccession>;
};

export type CreateBaseMapInput = {
  attribution?: InputMaybe<Scalars['String']['input']>;
  maxZoom?: InputMaybe<Scalars['Int']['input']>;
  minZoom?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateBatchTaxaPayload = {
  __typename?: 'CreateBatchTaxaPayload';
  results: Array<CreateTaxaResult>;
  totalFailed: Scalars['Int']['output'];
  totalSkipped: Scalars['Int']['output'];
  totalSuccess: Scalars['Int']['output'];
};

export type CreateCollectionSiteInput = {
  accessionNumberFormat?: InputMaybe<SiteAccessionNumberFormat>;
  baseMap?: InputMaybe<CreateBaseMapInput>;
  identificationFieldsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ipenNumbersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  mapCenterLatitude?: InputMaybe<Scalars['Float']['input']>;
  mapCenterLongitude?: InputMaybe<Scalars['Float']['input']>;
  mapZoomLevel?: InputMaybe<Scalars['Float']['input']>;
  materialQualifierFormat?: InputMaybe<MaterialQualifierFormat>;
  name: Scalars['String']['input'];
  organisationId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the site is publicly visible. */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  publicAbout?: InputMaybe<Scalars['String']['input']>;
  publicContactEmail?: InputMaybe<Scalars['String']['input']>;
  publicCountryCode?: InputMaybe<Scalars['String']['input']>;
  publicDefaultBaseMapId?: InputMaybe<Scalars['ID']['input']>;
  publicLocation?: InputMaybe<Scalars['String']['input']>;
  publicWebsite?: InputMaybe<Scalars['String']['input']>;
  sexEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  shortenedName?: InputMaybe<Scalars['String']['input']>;
  tagNumbersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  urlSlug: Scalars['String']['input'];
};

export type CreateCollectionSiteLocation = {
  collectionSiteId: Scalars['ID']['input'];
  createdByInitials?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isManualImport?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCollectionSiteLocationResult = CollectionSiteLocation | DuplicateCollectionSiteLocationCodeError;

export type CreateCollectionSiteLocationWithSlug = {
  collectionSiteId: Scalars['String']['input'];
  createdByInitials?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isManualImport?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCollectionSiteLocationsResult = CollectionSitesNotFoundError | CreateCollectionSiteLocationsSuccess | DuplicateSiteCodePairsError | InvalidSiteIdsError;

export type CreateCollectionSiteLocationsSuccess = {
  __typename?: 'CreateCollectionSiteLocationsSuccess';
  createdCollectionSiteLocations?: Maybe<Array<CollectionSiteLocation>>;
};

export type CreateCollectionSiteMembershipInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  siteId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type CreateCollectionSitesResult = CreateCollectionSitesSuccess | DuplicateOrgSlugPairsError | GenericError | InvalidSubdomainsError;

export type CreateCollectionSitesSuccess = {
  __typename?: 'CreateCollectionSitesSuccess';
  createdCollectionSites?: Maybe<Array<CreatedCollectionSite>>;
};

export type CreateInitialObservationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  bodyData?: InputMaybe<Scalars['JSON']['input']>;
  condition: ObservationConditionType;
  images?: InputMaybe<Array<CreateMaterialImageFromUrlInput>>;
};

export type CreateLocationInput = {
  collectionSiteId: Scalars['ID']['input'];
  createdByInitials?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  geometry?: InputMaybe<Scalars['JSON']['input']>;
  geometryColor?: InputMaybe<Scalars['String']['input']>;
  isManualImport?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateMaterialImageFromUrlInput = {
  assetUrl: Scalars['String']['input'];
  capturedAt?: InputMaybe<Scalars['Date']['input']>;
  capturedBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMaterialImageInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  bucketName: Scalars['String']['input'];
  capturedAt?: InputMaybe<Scalars['Date']['input']>;
  capturedBy?: InputMaybe<Scalars['String']['input']>;
  /** Can either be a UUID, or organisation/site tuple in format <org_subdomain>:<site_slug> */
  collectionSiteId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  /** If a UUID is not provided one will be generated */
  id?: InputMaybe<Scalars['String']['input']>;
  manualImport: Scalars['Boolean']['input'];
  /** Can either be a UUID, or material number in format 2020-0001_A */
  materialId: Scalars['String']['input'];
};

export type CreateMaterialImageResult = {
  __typename?: 'CreateMaterialImageResult';
  bucketName: Scalars['String']['output'];
  errors: Array<GenericError>;
  fileName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type CreateMaterialImagesPayload = {
  __typename?: 'CreateMaterialImagesPayload';
  results: Array<CreateMaterialImageResult>;
  totalFailed: Scalars['Int']['output'];
  totalSkipped: Scalars['Int']['output'];
  totalSuccess: Scalars['Int']['output'];
};

export type CreateObservationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  bodyData?: InputMaybe<Scalars['JSON']['input']>;
  condition: ObservationConditionType;
  images?: InputMaybe<Array<CreateMaterialImageFromUrlInput>>;
  materialId: Scalars['ID']['input'];
};

export type CreateOrganisation = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  billingAccountStatus?: InputMaybe<BillingStatus>;
  billingTzName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  shortenedName?: InputMaybe<Scalars['String']['input']>;
  subdomain: Scalars['String']['input'];
  taxaInterpretationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  trialEnd?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateOrganisationInput = {
  name: Scalars['String']['input'];
  subdomain: Scalars['String']['input'];
};

export type CreateOrganisationInviteInput = {
  email: Scalars['String']['input'];
  role?: InputMaybe<AccessRole>;
};

export type CreateOrganisationsResult = CreateOrganisationsSuccess | DuplicateSubdomainsError;

export type CreateOrganisationsSuccess = {
  __typename?: 'CreateOrganisationsSuccess';
  createdOrganisations: Array<CreatedOrganisation>;
};

export type CreatePlantMaterialResult = GenericError | PlantMaterial;

export type CreatePlantMaterialsResult = AccessionsNotFoundError | CollectionLocationsNotFoundError | CollectionSitesNotFoundError | CreatePlantMaterialsSuccess | DuplicateMaterialNumsError | InvalidSiteIdsError;

export type CreatePlantMaterialsSuccess = {
  __typename?: 'CreatePlantMaterialsSuccess';
  createdMaterials: Array<CreatedPlantMaterial>;
};

export type CreateTaxaResult = {
  __typename?: 'CreateTaxaResult';
  errors: Array<GenericError>;
  scientificName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type CreateTaxonInput = {
  authorship?: InputMaybe<Scalars['String']['input']>;
  commonName?: InputMaybe<Scalars['String']['input']>;
  interpretationDescription?: InputMaybe<Scalars['String']['input']>;
  nativeDistribution?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesData?: InputMaybe<Scalars['JSON']['input']>;
  organisationId: Scalars['ID']['input'];
  scientificName: Scalars['String']['input'];
  sharedScientificNameId?: InputMaybe<Scalars['ID']['input']>;
  /** Additional supplemental data associated with the taxon. */
  supplementalData?: InputMaybe<Scalars['JSONObject']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateUser = {
  accessRole?: InputMaybe<AccessRole>;
  askMeAbout?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  collectionSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  email: Scalars['String']['input'];
  experimentalFeaturesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  initials?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['ID']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type CreateUserWithSubdomainAndSlug = {
  accessRole?: InputMaybe<AccessRole>;
  askMeAbout?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  collectionSiteSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  email: Scalars['String']['input'];
  experimentalFeaturesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  initials?: InputMaybe<Scalars['String']['input']>;
  organisationSubdomain: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUsersResult = CreateUsersSuccess | DuplicateEmailsError | InvalidEmailsError | InvalidSlugsError | InvalidSubdomainsError;

export type CreateUsersSuccess = {
  __typename?: 'CreateUsersSuccess';
  createdUsers?: Maybe<Array<User>>;
};

export type CreatedAccession = {
  __typename?: 'CreatedAccession';
  accessionNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type CreatedCollectionSite = {
  __typename?: 'CreatedCollectionSite';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  urlSlug: Scalars['String']['output'];
};

export type CreatedOrganisation = {
  __typename?: 'CreatedOrganisation';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subdomain?: Maybe<Scalars['String']['output']>;
};

export type CreatedPlantMaterial = {
  __typename?: 'CreatedPlantMaterial';
  id: Scalars['ID']['output'];
  materialNumber: Scalars['String']['output'];
};

export type DailyUsageAnalytics = {
  __typename?: 'DailyUsageAnalytics';
  accessionChanges: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  materialChanges: Scalars['Int']['output'];
  uniqueActiveUsers: Scalars['Int']['output'];
};

export type DateComparator = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  neq?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<Scalars['Date']['input']>>;
};

export type DeleteResult = {
  __typename?: 'DeleteResult';
  errors?: Maybe<Array<GenericError>>;
  success: Scalars['Boolean']['output'];
};

export type DeprecatedLocationFilter = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  hasNoValue?: InputMaybe<Scalars['Boolean']['input']>;
  is?: InputMaybe<Array<Scalars['ID']['input']>>;
  isNot?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DuplicateAccessionNumbersError = Error & {
  __typename?: 'DuplicateAccessionNumbersError';
  duplicateNumbers: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type DuplicateCollectionSiteLocationCodeError = {
  __typename?: 'DuplicateCollectionSiteLocationCodeError';
  message: Scalars['String']['output'];
};

export type DuplicateEmailsError = Error & {
  __typename?: 'DuplicateEmailsError';
  duplicateEmails: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type DuplicateMaterialNumsError = Error & {
  __typename?: 'DuplicateMaterialNumsError';
  duplicateNumbers: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type DuplicateNameError = Error & {
  __typename?: 'DuplicateNameError';
  message: Scalars['String']['output'];
};

export type DuplicateOrgSlugPair = {
  __typename?: 'DuplicateOrgSlugPair';
  subdomain: Scalars['String']['output'];
  urlSlug: Scalars['String']['output'];
};

export type DuplicateOrgSlugPairsError = Error & {
  __typename?: 'DuplicateOrgSlugPairsError';
  duplicatePairs: Array<DuplicateOrgSlugPair>;
  message: Scalars['String']['output'];
};

export type DuplicateScientificNameError = Error & {
  __typename?: 'DuplicateScientificNameError';
  message: Scalars['String']['output'];
};

export type DuplicateSiteCodePair = {
  __typename?: 'DuplicateSiteCodePair';
  code: Scalars['String']['output'];
  collectionSiteSlug: Scalars['String']['output'];
};

export type DuplicateSiteCodePairsError = Error & {
  __typename?: 'DuplicateSiteCodePairsError';
  duplicatePairs: Array<DuplicateSiteCodePair>;
  message: Scalars['String']['output'];
};

export type DuplicateSubdomainsError = Error & {
  __typename?: 'DuplicateSubdomainsError';
  duplicateSubdomains: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type DuplicateUrlSlugError = Error & {
  __typename?: 'DuplicateUrlSlugError';
  message: Scalars['String']['output'];
};

export type Error = {
  message: Scalars['String']['output'];
};

export type FollowUp = {
  __typename?: 'FollowUp';
  count: Scalars['Int']['output'];
  period: Period;
};

export type FollowUpInput = {
  count: Scalars['Int']['input'];
  period: Period;
};

export type GenericError = Error & {
  __typename?: 'GenericError';
  message: Scalars['String']['output'];
};

export enum GeoJsonFeatureCollectionType {
  FeatureCollection = 'FeatureCollection'
}

export enum GeoJsonFeatureType {
  Feature = 'Feature'
}

export type GeographicInput = {
  elevation?: InputMaybe<Scalars['Float']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type GeographicPosition = {
  __typename?: 'GeographicPosition';
  elevation?: Maybe<Scalars['Float']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GetOrgUsageAnalyticsResult = GenericError | UsageAnalytics;

export enum HybridType {
  GraftChimaera = 'GRAFT_CHIMAERA',
  Hybrid = 'HYBRID',
  None = 'NONE'
}

export type IdComparator = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  neq?: InputMaybe<Scalars['ID']['input']>;
  nin?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type InvalidEmailsError = Error & {
  __typename?: 'InvalidEmailsError';
  invalidEmails: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvalidMaterialTypeCodesError = Error & {
  __typename?: 'InvalidMaterialTypeCodesError';
  invalidCodes: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvalidSiteIdsError = Error & {
  __typename?: 'InvalidSiteIdsError';
  invalidSiteIds: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvalidSlugsError = Error & {
  __typename?: 'InvalidSlugsError';
  invalidSlugs: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvalidSubdomainsError = Error & {
  __typename?: 'InvalidSubdomainsError';
  invalidSubdomains: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InviteMembersResponse = DuplicateEmailsError | GenericError | InvalidEmailsError | InviteMembersSuccess;

export type InviteMembersSuccess = {
  __typename?: 'InviteMembersSuccess';
  members?: Maybe<Array<User>>;
};

export type InvitedMember = {
  accessRole?: InputMaybe<AccessRole>;
  email: Scalars['String']['input'];
};

export enum LengthUnit {
  Meters = 'METERS'
}

export type LifeForm = {
  __typename?: 'LifeForm';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LifeFormConnection = {
  __typename?: 'LifeFormConnection';
  edges: Array<LifeFormEdge>;
  nodes: Array<LifeForm>;
  pageInfo: PageInfo;
};

export type LifeFormEdge = {
  __typename?: 'LifeFormEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: LifeForm;
};

export type LifeFormFilter = {
  and?: InputMaybe<Array<LifeFormFilter>>;
  id?: InputMaybe<IdComparator>;
  name?: InputMaybe<NullableStringComparator>;
  or?: InputMaybe<Array<LifeFormFilter>>;
};

/** Location in an individual site, where material is situated */
export type Location = {
  __typename?: 'Location';
  archived: Scalars['Boolean']['output'];
  collectionSiteId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  geometry?: Maybe<Scalars['JSON']['output']>;
  geometryColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  material?: Maybe<PlantMaterialConnection>;
  name: Scalars['String']['output'];
  site?: Maybe<CollectionSite>;
  totalMaterial?: Maybe<Scalars['Int']['output']>;
};


/** Location in an individual site, where material is situated */
export type LocationMaterialArgs = {
  filter?: InputMaybe<PlantMaterialFilter>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<MaterialSortInput>>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LocationConnection = {
  __typename?: 'LocationConnection';
  edges: Array<LocationEdge>;
  nodes: Array<Location>;
  pageInfo: PageInfo;
};

export type LocationEdge = {
  __typename?: 'LocationEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Location;
};

export type LocationFilter = {
  and?: InputMaybe<Array<LocationFilter>>;
  archived?: InputMaybe<BooleanComparator>;
  description?: InputMaybe<NullableStringComparator>;
  geometry?: InputMaybe<NullableGeometryComparator>;
  name?: InputMaybe<StringComparator>;
  or?: InputMaybe<Array<LocationFilter>>;
};

export type LocationOrderByInput = {
  direction: SortDirection;
  field: LocationSortColumn;
};

export type LocationPayload = {
  __typename?: 'LocationPayload';
  errors?: Maybe<Array<LocationPayloadError>>;
  location?: Maybe<Location>;
  success: Scalars['Boolean']['output'];
};

export type LocationPayloadError = DuplicateCollectionSiteLocationCodeError | GenericError;

export enum LocationSortColumn {
  Name = 'NAME'
}

export enum ManualAccessionNumberError {
  DuplicateAccessionNumber = 'DUPLICATE_ACCESSION_NUMBER',
  InvalidAccessionNumber = 'INVALID_ACCESSION_NUMBER',
  InvalidCharacters = 'INVALID_CHARACTERS',
  InvalidInputs = 'INVALID_INPUTS'
}

export type ManualAccessionNumberUpdateInput = {
  newAccessionNumber: Scalars['String']['input'];
  oldAccessionNumber: Scalars['String']['input'];
};

export type ManualAccessionNumberUpdateResult = GenericError | ManualAccessionNumberUpdateSuccess;

export type ManualAccessionNumberUpdateSuccess = {
  __typename?: 'ManualAccessionNumberUpdateSuccess';
  message: Scalars['String']['output'];
};

export type MapConfig = {
  __typename?: 'MapConfig';
  key?: Maybe<Scalars['String']['output']>;
};

export enum MaterialGroup {
  Plant = 'PLANT',
  Seed = 'SEED'
}

export type MaterialGroupFilter = {
  and?: InputMaybe<Array<MaterialGroupFilter>>;
  eq?: InputMaybe<MaterialGroup>;
  neq?: InputMaybe<MaterialGroup>;
  or?: InputMaybe<Array<MaterialGroupFilter>>;
};

export type MaterialImage = {
  __typename?: 'MaterialImage';
  archived: Scalars['Boolean']['output'];
  bucketName: Scalars['String']['output'];
  capturedAt?: Maybe<Scalars['Date']['output']>;
  capturedBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPrimaryImage?: Maybe<Scalars['Boolean']['output']>;
  manualImport: Scalars['Boolean']['output'];
  plantMaterialId: Scalars['ID']['output'];
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedBy?: Maybe<User>;
};


export type MaterialImageIsPrimaryImageArgs = {
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MaterialImageConnection = {
  __typename?: 'MaterialImageConnection';
  edges: Array<MaterialImageEdge>;
  nodes: Array<MaterialImage>;
  pageInfo: PageInfo;
};

export type MaterialImageEdge = {
  __typename?: 'MaterialImageEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: MaterialImage;
};

export type MaterialImageUpdates = {
  capturedAt?: InputMaybe<Scalars['Date']['input']>;
  capturedBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type MaterialImageUpload = {
  capturedAt?: InputMaybe<Scalars['Date']['input']>;
  capturedBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
};

export enum MaterialQualifierFormat {
  BijectiveBase_26 = 'BIJECTIVE_BASE_26',
  Numeric_99 = 'NUMERIC_99'
}

export enum MaterialSex {
  Agamosperm = 'AGAMOSPERM',
  Female = 'FEMALE',
  Hermaphrodite = 'HERMAPHRODITE',
  Male = 'MALE',
  Unknown = 'UNKNOWN'
}

export type MaterialSortInput = {
  accessionNumber?: InputMaybe<AccessionNumberSort>;
  qualifier?: InputMaybe<QualifierSort>;
  scientificName?: InputMaybe<ScientificNameSort>;
};

/** Indicates the type of material the current accession is composed of */
export type MaterialType = {
  __typename?: 'MaterialType';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MaterialTypeFilter = {
  and?: InputMaybe<Array<MaterialTypeFilter>>;
  code?: InputMaybe<StringComparator>;
  id?: InputMaybe<IdComparator>;
  or?: InputMaybe<Array<MaterialTypeFilter>>;
};

export type MissingAccession = {
  __typename?: 'MissingAccession';
  accessionNumber: Scalars['String']['output'];
  collectionSiteId: Scalars['String']['output'];
};

export type MissingLocation = {
  __typename?: 'MissingLocation';
  code: Scalars['String']['output'];
  collectionSiteId: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _?: Maybe<Scalars['String']['output']>;
  activateUser: Scalars['Boolean']['output'];
  addCollectionSiteToUsers?: Maybe<ReturnedBoolError>;
  addTagAccessions: BatchAccessionsPayload;
  addTagPlantMaterials: BatchPlantMaterialPayload;
  addTagTaxa: BatchTaxaPayload;
  archiveAccession?: Maybe<UpdateAccessionResult>;
  archiveCollectionSiteLocation: ArchiveResult;
  archiveLocation: LocationPayload;
  archiveMaterialImage?: Maybe<UpdateMaterialImageResult>;
  archiveObservation: ObservationPayload;
  archivePlantMaterial?: Maybe<UpdatePlantMaterialResult>;
  archivePlantMaterials: BatchPlantMaterialPayload;
  archiveRecordTag?: Maybe<ArchiveResult>;
  archiveTaxon: ArchiveResult;
  batchArchiveAccessions?: Maybe<BatchAccessionsPayload>;
  batchArchiveTaxa: BatchTaxaPayload;
  batchCreateMaterialImages: CreateMaterialImagesPayload;
  batchCreateObservation: BatchObservationPayload;
  createAccession?: Maybe<CreatedAccession>;
  createAccessions?: Maybe<CreateAccessionsResult>;
  createBatchTaxa: CreateBatchTaxaPayload;
  createCollectionSite?: Maybe<CollectionSiteResult>;
  /** @deprecated Use createLocation instead */
  createCollectionSiteLocation?: Maybe<CreateCollectionSiteLocationResult>;
  createCollectionSiteLocations?: Maybe<CreateCollectionSiteLocationsResult>;
  createCollectionSiteMembership: CollectionSiteMembershipPayload;
  createCollectionSites?: Maybe<CreateCollectionSitesResult>;
  createLocation: LocationPayload;
  createMaterialImages: BatchMaterialImagePayload;
  createObservation: ObservationPayload;
  createOrganisation?: Maybe<Organisation>;
  createOrganisationFromOnboarding: OrganisationFromOnboardingPayload;
  createOrganisations?: Maybe<CreateOrganisationsResult>;
  createPlantMaterial?: Maybe<CreatePlantMaterialResult>;
  createPlantMaterials?: Maybe<CreatePlantMaterialsResult>;
  createRecordTag?: Maybe<RecordTagResult>;
  createTaxon: TaxonResult;
  createUser?: Maybe<User>;
  createUsers?: Maybe<CreateUsersResult>;
  deaccessionAccession?: Maybe<Accession>;
  deactivateUser: UserAdminResult;
  deleteCollectionSite: DeleteResult;
  deleteCollectionSiteMembership: DeleteResult;
  inviteMembers?: Maybe<InviteMembersResponse>;
  reactivateUser: UserAdminResult;
  referAFriend: SuccessResult;
  reinstateAccession?: Maybe<Accession>;
  removeTagAccessions: BatchAccessionsPayload;
  removeTagPlantMaterials: BatchPlantMaterialPayload;
  removeTagTaxa: BatchTaxaPayload;
  restoreAccession?: Maybe<UpdateAccessionResult>;
  restoreMaterialImage?: Maybe<UpdateMaterialImageResult>;
  restorePlantMaterial?: Maybe<UpdatePlantMaterialResult>;
  restoreTaxon: TaxonResult;
  retroactivelyPromoteExogenousAccessionNumbers?: Maybe<PromoteExogenousAccessionNumbersResult>;
  retroactivelyUpdateManualAccessionNumbers?: Maybe<ManualAccessionNumberUpdateResult>;
  setAuthProviderId: Scalars['Boolean']['output'];
  setPrimaryImage?: Maybe<UpdateMaterialImageResult>;
  unsetPrimaryImage?: Maybe<UpdateMaterialImageResult>;
  updateAccession: AccessionPayload;
  updateAccessionData?: Maybe<UpdateAccessionResult>;
  updateCollectionData?: Maybe<UpdateAccessionResult>;
  updateCollectionSite?: Maybe<CollectionSiteResult>;
  updateCollectionSiteLocation?: Maybe<UpdateCollectionSiteLocationResult>;
  updateLocation: LocationPayload;
  updateMaterialImage?: Maybe<UpdateMaterialImageResult>;
  updateObservation: ObservationPayload;
  updateOrganisation?: Maybe<OrganisationPayload>;
  updateOrganisationAdmin?: Maybe<UpdateOrganisationResult>;
  updatePlantMaterial?: Maybe<UpdatePlantMaterialResult>;
  updatePlantMaterials: BatchPlantMaterialPayload;
  updateProfile?: Maybe<User>;
  updateRecordTag?: Maybe<RecordTagResult>;
  updateTaxon: TaxonResult;
  updateUserAccessRole: UserAdminResult;
  updateUserSettings: UserSettingsPayload;
  uploadFile: UploadPayload;
  uploadMaterialImage?: Maybe<UploadMaterialImageResult>;
  uploadOrganisationLogo?: Maybe<OrganisationPayload>;
  uploadProfileImage?: Maybe<UserPayload>;
  verifyEmail?: Maybe<VerifyEmailResponse>;
  verifyUser?: Maybe<VerifyUserResponse>;
};


export type MutationActivateUserArgs = {
  auth0User?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  signature: Scalars['String']['input'];
};


export type MutationAddCollectionSiteToUsersArgs = {
  orgSubdomain: Scalars['String']['input'];
  siteSlug: Scalars['String']['input'];
  userEmails: Array<Scalars['String']['input']>;
};


export type MutationAddTagAccessionsArgs = {
  ids: Array<Scalars['ID']['input']>;
  tagId: Scalars['ID']['input'];
};


export type MutationAddTagPlantMaterialsArgs = {
  ids: Array<Scalars['ID']['input']>;
  tagId: Scalars['ID']['input'];
};


export type MutationAddTagTaxaArgs = {
  ids: Array<Scalars['ID']['input']>;
  tagId: Scalars['ID']['input'];
};


export type MutationArchiveAccessionArgs = {
  accessionId: Scalars['ID']['input'];
};


export type MutationArchiveCollectionSiteLocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveLocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveMaterialImageArgs = {
  materialImageId: Scalars['ID']['input'];
};


export type MutationArchiveObservationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchivePlantMaterialArgs = {
  materialId: Scalars['ID']['input'];
};


export type MutationArchivePlantMaterialsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationArchiveRecordTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveTaxonArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBatchArchiveAccessionsArgs = {
  archiveAssociatedMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBatchArchiveTaxaArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBatchCreateMaterialImagesArgs = {
  input: Array<CreateMaterialImageInput>;
};


export type MutationBatchCreateObservationArgs = {
  input: BatchCreateObservationInput;
};


export type MutationCreateAccessionArgs = {
  accession: CreateAccession;
};


export type MutationCreateAccessionsArgs = {
  accessions: Array<CreateAccession>;
};


export type MutationCreateBatchTaxaArgs = {
  input: Array<CreateTaxonInput>;
};


export type MutationCreateCollectionSiteArgs = {
  input: CreateCollectionSiteInput;
};


export type MutationCreateCollectionSiteLocationArgs = {
  collectionSiteLocation: CreateCollectionSiteLocation;
};


export type MutationCreateCollectionSiteLocationsArgs = {
  collectionSiteLocations: Array<CreateCollectionSiteLocationWithSlug>;
};


export type MutationCreateCollectionSiteMembershipArgs = {
  input: CreateCollectionSiteMembershipInput;
};


export type MutationCreateCollectionSitesArgs = {
  collectionSites: Array<CreateCollectionSiteInput>;
};


export type MutationCreateLocationArgs = {
  input: CreateLocationInput;
};


export type MutationCreateMaterialImagesArgs = {
  input: Array<CreateMaterialImageFromUrlInput>;
  materialId: Scalars['ID']['input'];
};


export type MutationCreateObservationArgs = {
  followUp?: InputMaybe<FollowUpInput>;
  input: CreateObservationInput;
};


export type MutationCreateOrganisationArgs = {
  organisation: CreateOrganisation;
};


export type MutationCreateOrganisationFromOnboardingArgs = {
  input: CreateOrganisationInput;
  invite: CreateOrganisationInviteInput;
};


export type MutationCreateOrganisationsArgs = {
  organisations: Array<CreateOrganisation>;
};


export type MutationCreatePlantMaterialArgs = {
  accessionId: Scalars['ID']['input'];
  plantMaterial: PlantMaterialInput;
};


export type MutationCreatePlantMaterialsArgs = {
  plantMaterials: Array<PlantMaterialInputWithAccessionNum>;
};


export type MutationCreateRecordTagArgs = {
  input: RecordTagInput;
};


export type MutationCreateTaxonArgs = {
  input: CreateTaxonInput;
};


export type MutationCreateUserArgs = {
  user: CreateUser;
};


export type MutationCreateUsersArgs = {
  users: Array<CreateUserWithSubdomainAndSlug>;
};


export type MutationDeaccessionAccessionArgs = {
  accessionId: Scalars['ID']['input'];
  deaccessionDate: Scalars['Date']['input'];
  setPlantMaterialsToAbsent: Scalars['Boolean']['input'];
};


export type MutationDeactivateUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationDeleteCollectionSiteArgs = {
  collectionSiteName: Scalars['String']['input'];
  deleteAssociatedTaxa?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteCollectionSiteMembershipArgs = {
  id: Scalars['String']['input'];
};


export type MutationInviteMembersArgs = {
  addToAllSites: Scalars['Boolean']['input'];
  members: Array<InvitedMember>;
  organisationId: Scalars['ID']['input'];
};


export type MutationReactivateUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationReferAFriendArgs = {
  input: ReferAFriendInput;
};


export type MutationReinstateAccessionArgs = {
  accessionId: Scalars['ID']['input'];
};


export type MutationRemoveTagAccessionsArgs = {
  ids: Array<Scalars['ID']['input']>;
  tagId: Scalars['ID']['input'];
};


export type MutationRemoveTagPlantMaterialsArgs = {
  ids: Array<Scalars['ID']['input']>;
  tagId: Scalars['ID']['input'];
};


export type MutationRemoveTagTaxaArgs = {
  ids: Array<Scalars['ID']['input']>;
  tagId: Scalars['ID']['input'];
};


export type MutationRestoreAccessionArgs = {
  accessionId: Scalars['ID']['input'];
};


export type MutationRestoreMaterialImageArgs = {
  materialImageId: Scalars['ID']['input'];
};


export type MutationRestorePlantMaterialArgs = {
  materialId: Scalars['ID']['input'];
};


export type MutationRestoreTaxonArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetroactivelyPromoteExogenousAccessionNumbersArgs = {
  slug: Scalars['String']['input'];
  subdomain: Scalars['String']['input'];
  updates: Array<PromoteExogenousAccessionNumberInput>;
};


export type MutationRetroactivelyUpdateManualAccessionNumbersArgs = {
  accessionNumberUpdates: Array<ManualAccessionNumberUpdateInput>;
  slug: Scalars['String']['input'];
  subdomain: Scalars['String']['input'];
};


export type MutationSetAuthProviderIdArgs = {
  authProviderId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  signature: Scalars['String']['input'];
};


export type MutationSetPrimaryImageArgs = {
  materialImageId: Scalars['ID']['input'];
};


export type MutationUnsetPrimaryImageArgs = {
  materialImageId: Scalars['ID']['input'];
};


export type MutationUpdateAccessionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAccessionInput;
};


export type MutationUpdateAccessionDataArgs = {
  accessionId: Scalars['ID']['input'];
  updates: AccessionDataUpdates;
};


export type MutationUpdateCollectionDataArgs = {
  accessionId: Scalars['ID']['input'];
  updates: CollectionDataUpdates;
};


export type MutationUpdateCollectionSiteArgs = {
  id: Scalars['String']['input'];
  updates: CollectionSiteUpdates;
};


export type MutationUpdateCollectionSiteLocationArgs = {
  collectionSiteLocationId: Scalars['ID']['input'];
  updates: CollectionSiteLocationUpdates;
};


export type MutationUpdateLocationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLocationInput;
};


export type MutationUpdateMaterialImageArgs = {
  materialImageId: Scalars['ID']['input'];
  updates: MaterialImageUpdates;
};


export type MutationUpdateObservationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateObservationInput;
};


export type MutationUpdateOrganisationArgs = {
  id: Scalars['ID']['input'];
  input: OrganisationUpdateInput;
};


export type MutationUpdateOrganisationAdminArgs = {
  organisationUpdates: OrganisationUpdates;
  subdomain: Scalars['String']['input'];
};


export type MutationUpdatePlantMaterialArgs = {
  materialId: Scalars['ID']['input'];
  updates: PlantMaterialUpdates;
};


export type MutationUpdatePlantMaterialsArgs = {
  ids: Array<Scalars['ID']['input']>;
  input: PlantMaterialUpdates;
};


export type MutationUpdateProfileArgs = {
  profileChanges: ProfileChangesInput;
};


export type MutationUpdateRecordTagArgs = {
  id: Scalars['ID']['input'];
  input: RecordTagUpdateInput;
};


export type MutationUpdateTaxonArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTaxonInput;
};


export type MutationUpdateUserAccessRoleArgs = {
  accessRole: AccessRole;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateUserSettingsArgs = {
  input: UserSettingsInput;
};


export type MutationUploadFileArgs = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  size: Scalars['Int']['input'];
};


export type MutationUploadMaterialImageArgs = {
  image: MaterialImageUpload;
  plantMaterialId: Scalars['ID']['input'];
  setAsPrimaryImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUploadOrganisationLogoArgs = {
  file: Scalars['Upload']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUploadProfileImageArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationVerifyUserArgs = {
  email: Scalars['String']['input'];
  signature: Scalars['String']['input'];
};

export enum NameSource {
  Col = 'COL',
  Ipni = 'IPNI',
  Powo = 'POWO',
  Wikipedia = 'WIKIPEDIA'
}

export type NameSourceComparator = {
  and?: InputMaybe<Array<NameSourceComparator>>;
  eq?: InputMaybe<NameSource>;
  in?: InputMaybe<Array<NameSource>>;
  neq?: InputMaybe<NameSource>;
  nin?: InputMaybe<Array<NameSource>>;
  or?: InputMaybe<Array<NameSourceComparator>>;
};

export type NotFoundError = Error & {
  __typename?: 'NotFoundError';
  message: Scalars['String']['output'];
};

export type NullableGeometryComparator = {
  null?: InputMaybe<RelationExistsComparator>;
};

export type NullableMaterialSexFilter = {
  and?: InputMaybe<Array<NullableMaterialSexFilter>>;
  eq?: InputMaybe<MaterialSex>;
  neq?: InputMaybe<MaterialSex>;
  null?: InputMaybe<RelationExistsComparator>;
  or?: InputMaybe<Array<NullableMaterialSexFilter>>;
};

export type NullableObservationFilter = {
  condition?: InputMaybe<ObservationConditionFilter>;
  createdAt?: InputMaybe<DateComparator>;
  id?: InputMaybe<IdComparator>;
  null?: InputMaybe<RelationExistsComparator>;
  outdated?: InputMaybe<BooleanComparator>;
};

export type NullableScientificNameFilter = {
  and?: InputMaybe<Array<ScientificNameFilter>>;
  authorship?: InputMaybe<NullableStringComparator>;
  classification?: InputMaybe<ClassificationFilter>;
  id?: InputMaybe<IdComparator>;
  null?: InputMaybe<RelationExistsComparator>;
  or?: InputMaybe<Array<ScientificNameFilter>>;
  rank?: InputMaybe<TaxonomicRankComparator>;
  status?: InputMaybe<TaxonomicStatusComparator>;
  taxon?: InputMaybe<NullableSharedTaxonFilter>;
};

export type NullableSharedTaxonFilter = {
  and?: InputMaybe<Array<NullableSharedTaxonFilter>>;
  climate?: InputMaybe<NullableStringComparator>;
  globalRedListPublishedYear?: InputMaybe<NullableStringComparator>;
  globalRedListSourceUrl?: InputMaybe<NullableStringComparator>;
  globalRedListStatus?: InputMaybe<RedListStatusComparator>;
  globalRedListTaxonomicStatus?: InputMaybe<RedListTaxonomicStatusComparator>;
  lifeForms?: InputMaybe<LifeFormFilter>;
  nativeDistribution?: InputMaybe<NullableStringComparator>;
  null?: InputMaybe<RelationExistsComparator>;
  or?: InputMaybe<Array<NullableSharedTaxonFilter>>;
  taxonSource?: InputMaybe<NameSourceComparator>;
  taxonSourceId?: InputMaybe<NullableStringComparator>;
  taxonSourceLifeForm?: InputMaybe<NullableStringComparator>;
};

export type NullableStringComparator = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableUserFilter = {
  id?: InputMaybe<IdComparator>;
  null?: InputMaybe<BooleanComparator>;
};

export type Observation = {
  __typename?: 'Observation';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  bodyData?: Maybe<Scalars['JSON']['output']>;
  condition: ObservationConditionType;
  createdAt: Scalars['DateTime']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  images: MaterialImageConnection;
  material: PlantMaterial;
  materialId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type ObservationConditionCount = {
  __typename?: 'ObservationConditionCount';
  condition: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type ObservationConditionFilter = {
  and?: InputMaybe<Array<ObservationConditionFilter>>;
  eq?: InputMaybe<ObservationConditionType>;
  neq?: InputMaybe<ObservationConditionType>;
  or?: InputMaybe<Array<ObservationConditionFilter>>;
};

export enum ObservationConditionType {
  Dead = 'DEAD',
  Fair = 'FAIR',
  Good = 'GOOD',
  Poor = 'POOR'
}

export type ObservationConnection = {
  __typename?: 'ObservationConnection';
  edges: Array<ObservationEdge>;
  nodes: Array<Observation>;
  pageInfo: PageInfo;
};

export type ObservationEdge = {
  __typename?: 'ObservationEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Observation;
};

export type ObservationPayload = {
  __typename?: 'ObservationPayload';
  observation: Observation;
  success: Scalars['Boolean']['output'];
};

export type ObservationsHistoricSnapshot = {
  __typename?: 'ObservationsHistoricSnapshot';
  timestamp: Scalars['DateTime']['output'];
  total: Scalars['Int']['output'];
  totalMaterials: Scalars['Int']['output'];
  totalOutdated: Scalars['Int']['output'];
};

/** Institution or Organisation acting as the collection owner */
export type Organisation = {
  __typename?: 'Organisation';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  billingAccountStatus: BillingStatus;
  billingTzName?: Maybe<Scalars['String']['output']>;
  collectionSiteBySlug?: Maybe<CollectionSite>;
  collectionSites?: Maybe<Array<CollectionSite>>;
  createdAt: Scalars['DateTime']['output'];
  donors?: Maybe<ContactConnection>;
  id: Scalars['ID']['output'];
  lifeForms?: Maybe<LifeFormConnection>;
  map?: Maybe<MapConfig>;
  member?: Maybe<User>;
  members?: Maybe<Array<User>>;
  name: Scalars['String']['output'];
  /** @deprecated Use tags instead */
  recordTags?: Maybe<Array<RecordTag>>;
  redListStatusCounts?: Maybe<Array<RedListStatusCount>>;
  sharedScientificNames?: Maybe<ScientificNameConnection>;
  shortenedName?: Maybe<Scalars['String']['output']>;
  subdomain: Scalars['String']['output'];
  subscription?: Maybe<Subscription>;
  /** @deprecated Use sharedScientificNames instead */
  supraspecificTaxa?: Maybe<SupraspecificTaxaConnection>;
  tags?: Maybe<RecordTagConnection>;
  taxa?: Maybe<TaxonConnection>;
  taxaInterpretationEnabled: Scalars['Boolean']['output'];
  taxaTotal?: Maybe<Scalars['Int']['output']>;
  trialEnd?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Institution or Organisation acting as the collection owner */
export type OrganisationCollectionSiteBySlugArgs = {
  slug: Scalars['String']['input'];
};


/** Institution or Organisation acting as the collection owner */
export type OrganisationDonorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


/** Institution or Organisation acting as the collection owner */
export type OrganisationMemberArgs = {
  id: Scalars['ID']['input'];
};


/** Institution or Organisation acting as the collection owner */
export type OrganisationMembersArgs = {
  filter?: InputMaybe<UserFilter>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Institution or Organisation acting as the collection owner */
export type OrganisationRecordTagsArgs = {
  filters?: InputMaybe<RecordTagFilters>;
};


/** Institution or Organisation acting as the collection owner */
export type OrganisationSharedScientificNamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ScientificNameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ScientificNameOrderBy>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


/** Institution or Organisation acting as the collection owner */
export type OrganisationSupraspecificTaxaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SupraspecificTaxaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SupraspecificTaxaOrderBy>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


/** Institution or Organisation acting as the collection owner */
export type OrganisationTagsArgs = {
  filters?: InputMaybe<RecordTagFilters>;
};


/** Institution or Organisation acting as the collection owner */
export type OrganisationTaxaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TaxaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TaxaOrderByInput>;
  searchTerm?: InputMaybe<TaxaSearchTerm>;
};


/** Institution or Organisation acting as the collection owner */
export type OrganisationTaxaTotalArgs = {
  filter?: InputMaybe<TaxaFilter>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<TaxaSearchTerm>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrganisationFromOnboardingPayload = {
  __typename?: 'OrganisationFromOnboardingPayload';
  membership: CollectionSiteMembership;
  organisation: Organisation;
  site: CollectionSite;
  success: Scalars['Boolean']['output'];
  user: User;
};

export type OrganisationPayload = {
  __typename?: 'OrganisationPayload';
  organisation?: Maybe<Organisation>;
  success: Scalars['Boolean']['output'];
};

export type OrganisationUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  shortenedName?: InputMaybe<Scalars['String']['input']>;
  taxaInterpretationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganisationUpdates = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  billingAccountStatus?: InputMaybe<BillingStatus>;
  billingTzName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortenedName?: InputMaybe<Scalars['String']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  trialEnd?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum Period {
  Days = 'DAYS',
  Months = 'MONTHS',
  Weeks = 'WEEKS',
  Years = 'YEARS'
}

/** An individual or group of plants that have been collected, grown, or acquired by the garden */
export type PlantMaterial = {
  __typename?: 'PlantMaterial';
  accession?: Maybe<Accession>;
  accessionId: Scalars['String']['output'];
  archived: Scalars['Boolean']['output'];
  /** @deprecated Use location instead */
  collectionSiteLocation?: Maybe<CollectionSiteLocation>;
  /** @deprecated Use locationId instead */
  collectionSiteLocationId: Scalars['ID']['output'];
  condition?: Maybe<Condition>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdByInitials?: Maybe<Scalars['String']['output']>;
  daysOverdueFollowUp?: Maybe<Scalars['Int']['output']>;
  firstAbsent?: Maybe<Scalars['Date']['output']>;
  firstPresent?: Maybe<Scalars['Date']['output']>;
  followUp?: Maybe<FollowUp>;
  /** @deprecated Use historyConnection instead */
  history?: Maybe<Array<PlantMaterialHistory>>;
  historyConnection?: Maybe<PlantMaterialHistoryConnection>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<MaterialImage>>;
  lastObservation?: Maybe<Observation>;
  lastObservationId?: Maybe<Scalars['String']['output']>;
  lastObserved?: Maybe<Scalars['Date']['output']>;
  location?: Maybe<Location>;
  locationId: Scalars['ID']['output'];
  massPlanting: Scalars['Boolean']['output'];
  materialGroup: MaterialGroup;
  notes?: Maybe<Scalars['String']['output']>;
  notesData?: Maybe<Scalars['JSON']['output']>;
  observations?: Maybe<ObservationConnection>;
  position?: Maybe<GeographicPosition>;
  primaryImage?: Maybe<MaterialImage>;
  /** Whether the material is publicly visible. */
  public: Scalars['Boolean']['output'];
  qualifier: Scalars['String']['output'];
  quantity?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<MaterialSex>;
  status: PlantMaterialStatus;
  /** Additional supplemental data associated with the material. */
  supplementalData?: Maybe<Scalars['JSONObject']['output']>;
  tagNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use tagsConnection instead */
  tags?: Maybe<Array<RecordTag>>;
  tagsConnection?: Maybe<RecordTagConnection>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedByInitials?: Maybe<Scalars['String']['output']>;
  wasManualImport: Scalars['Boolean']['output'];
  weight?: Maybe<Scalars['String']['output']>;
};


/** An individual or group of plants that have been collected, grown, or acquired by the garden */
export type PlantMaterialImagesArgs = {
  includeArchivedImages?: InputMaybe<Scalars['Boolean']['input']>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};


/** An individual or group of plants that have been collected, grown, or acquired by the garden */
export type PlantMaterialObservationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['String']['input']>;
};


/** An individual or group of plants that have been collected, grown, or acquired by the garden */
export type PlantMaterialPrimaryImageArgs = {
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Connection for `PlantMaterial` */
export type PlantMaterialConnection = {
  __typename?: 'PlantMaterialConnection';
  edges: Array<PlantMaterialEdge>;
  nodes: Array<PlantMaterial>;
  pageInfo: PageInfo;
};

export type PlantMaterialEdge = {
  __typename?: 'PlantMaterialEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: PlantMaterial;
};

export type PlantMaterialFilter = {
  accession?: InputMaybe<AccessionFilter>;
  accessionTags?: InputMaybe<RecordTagFilter>;
  and?: InputMaybe<Array<PlantMaterialFilter>>;
  archived?: InputMaybe<BooleanComparator>;
  condition?: InputMaybe<ConditionFilter>;
  createdBy?: InputMaybe<NullableUserFilter>;
  excludeAbsentMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  firstAbsent?: InputMaybe<DateComparator>;
  firstPresent?: InputMaybe<DateComparator>;
  hasImages?: InputMaybe<RelationExistsComparator>;
  id?: InputMaybe<IdComparator>;
  lastObservation?: InputMaybe<NullableObservationFilter>;
  lastObserved?: InputMaybe<DateComparator>;
  location?: InputMaybe<DeprecatedLocationFilter>;
  massPlanting?: InputMaybe<BooleanComparator>;
  materialGroup?: InputMaybe<MaterialGroupFilter>;
  notes?: InputMaybe<NullableStringComparator>;
  or?: InputMaybe<Array<PlantMaterialFilter>>;
  public?: InputMaybe<BooleanComparator>;
  sex?: InputMaybe<NullableMaterialSexFilter>;
  status?: InputMaybe<StatusFilter>;
  tagNumber?: InputMaybe<NullableStringComparator>;
  tags?: InputMaybe<RecordTagFilter>;
  taxaTags?: InputMaybe<RecordTagFilter>;
  updatedBy?: InputMaybe<NullableUserFilter>;
  withCoordinates?: InputMaybe<Scalars['Boolean']['input']>;
  withoutCoordinates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlantMaterialGeoJsonFeature = {
  __typename?: 'PlantMaterialGeoJSONFeature';
  geometry: Scalars['GeoJSONGeometry']['output'];
  properties: PlantMaterialGeoJsonProperties;
  type: GeoJsonFeatureType;
};

export type PlantMaterialGeoJsonFeatureCollection = {
  __typename?: 'PlantMaterialGeoJSONFeatureCollection';
  features: Array<PlantMaterialGeoJsonFeature>;
  type: GeoJsonFeatureCollectionType;
};

export type PlantMaterialGeoJsonProperties = {
  __typename?: 'PlantMaterialGeoJSONProperties';
  adHoc?: Maybe<Scalars['PlantMaterialGeoJSONPropertiesAdHoc']['output']>;
  id: Scalars['String']['output'];
  plantMaterial?: Maybe<PlantMaterial>;
};

export type PlantMaterialHistory = {
  __typename?: 'PlantMaterialHistory';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use fromLocation instead */
  fromCollectionSiteLocation?: Maybe<CollectionSiteLocation>;
  /** @deprecated Use fromLocationId instead */
  fromCollectionSiteLocationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Observations migrated from material */
  fromCondition?: Maybe<Condition>;
  fromFirstAbsent?: Maybe<Scalars['Date']['output']>;
  fromFirstPresent?: Maybe<Scalars['Date']['output']>;
  fromFollowUp?: Maybe<FollowUp>;
  fromFollowUpPeriodCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Observations migrated from material */
  fromLastObserved?: Maybe<Scalars['Date']['output']>;
  fromLocation?: Maybe<Location>;
  fromLocationId?: Maybe<Scalars['String']['output']>;
  fromMassPlanting?: Maybe<Scalars['Boolean']['output']>;
  fromMaterialGroup?: Maybe<Scalars['String']['output']>;
  fromNotes?: Maybe<Scalars['String']['output']>;
  fromPosition?: Maybe<GeographicPosition>;
  fromQuantity?: Maybe<Scalars['String']['output']>;
  fromSex?: Maybe<MaterialSex>;
  fromStatus?: Maybe<PlantMaterialStatus>;
  fromTagNumber?: Maybe<Scalars['String']['output']>;
  fromWeight?: Maybe<Scalars['String']['output']>;
  historicCreatedByInitials?: Maybe<Scalars['String']['output']>;
  madePrivate?: Maybe<Scalars['Boolean']['output']>;
  madePublic?: Maybe<Scalars['Boolean']['output']>;
  plantMaterial?: Maybe<PlantMaterial>;
  plantMaterialId: Scalars['String']['output'];
  /** @deprecated Use toLocation instead */
  toCollectionSiteLocation?: Maybe<CollectionSiteLocation>;
  /** @deprecated Use toLocationId instead */
  toCollectionSiteLocationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Observations migrated from material */
  toCondition?: Maybe<Condition>;
  toFirstAbsent?: Maybe<Scalars['Date']['output']>;
  toFirstPresent?: Maybe<Scalars['Date']['output']>;
  toFollowUp?: Maybe<FollowUp>;
  toFollowUpPeriodCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Observations migrated from material */
  toLastObserved?: Maybe<Scalars['Date']['output']>;
  toLocation?: Maybe<Location>;
  toLocationId?: Maybe<Scalars['String']['output']>;
  toMassPlanting?: Maybe<Scalars['Boolean']['output']>;
  toMaterialGroup?: Maybe<Scalars['String']['output']>;
  toNotes?: Maybe<Scalars['String']['output']>;
  toPosition?: Maybe<GeographicPosition>;
  toQuantity?: Maybe<Scalars['String']['output']>;
  toSex?: Maybe<MaterialSex>;
  toStatus?: Maybe<PlantMaterialStatus>;
  toTagNumber?: Maybe<Scalars['String']['output']>;
  toWeight?: Maybe<Scalars['String']['output']>;
  wasArchived?: Maybe<Scalars['Boolean']['output']>;
  wasManualImport: Scalars['Boolean']['output'];
  wasRestored?: Maybe<Scalars['Boolean']['output']>;
};

export type PlantMaterialHistoryConnection = {
  __typename?: 'PlantMaterialHistoryConnection';
  edges: Array<PlantMaterialHistoryEdge>;
  nodes: Array<PlantMaterialHistory>;
  pageInfo: PageInfo;
};

export type PlantMaterialHistoryEdge = {
  __typename?: 'PlantMaterialHistoryEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: PlantMaterialHistory;
};

export type PlantMaterialInput = {
  createdByInitials?: InputMaybe<Scalars['String']['input']>;
  firstAbsent?: InputMaybe<Scalars['Date']['input']>;
  firstPresent?: InputMaybe<Scalars['Date']['input']>;
  followUp?: InputMaybe<FollowUpInput>;
  images?: InputMaybe<Array<CreateMaterialImageFromUrlInput>>;
  initialObservation?: InputMaybe<CreateInitialObservationInput>;
  isManualImport?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  massPlanting?: InputMaybe<Scalars['Boolean']['input']>;
  materialGroup: MaterialGroup;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesData?: InputMaybe<Scalars['JSON']['input']>;
  position?: InputMaybe<GeographicInput>;
  /** Whether the material is publicly visible. */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  qualifier?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<MaterialSex>;
  status: PlantMaterialStatus;
  /** Additional supplemental data associated with the material. */
  supplementalData?: InputMaybe<Scalars['JSONObject']['input']>;
  tagNumber?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedByInitials?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type PlantMaterialInputWithAccessionNum = {
  accessionNumber: Scalars['String']['input'];
  collectionSiteId: Scalars['ID']['input'];
  createdByInitials?: InputMaybe<Scalars['String']['input']>;
  firstAbsent?: InputMaybe<Scalars['Date']['input']>;
  firstPresent?: InputMaybe<Scalars['Date']['input']>;
  followUp?: InputMaybe<FollowUpInput>;
  isManualImport?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  massPlanting?: InputMaybe<Scalars['Boolean']['input']>;
  materialGroup: MaterialGroup;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesData?: InputMaybe<Scalars['JSON']['input']>;
  position?: InputMaybe<GeographicInput>;
  /** Whether the material is publicly visible. */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  qualifier: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<MaterialSex>;
  status: PlantMaterialStatus;
  /** Additional supplemental data associated with the material. */
  supplementalData?: InputMaybe<Scalars['JSONObject']['input']>;
  tagNumber?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedByInitials?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export enum PlantMaterialStatus {
  Absent = 'ABSENT',
  Present = 'PRESENT',
  Transient = 'TRANSIENT',
  Unknown = 'UNKNOWN'
}

export type PlantMaterialUpdates = {
  condition?: InputMaybe<Condition>;
  firstAbsent?: InputMaybe<Scalars['Date']['input']>;
  firstPresent?: InputMaybe<Scalars['Date']['input']>;
  followUp?: InputMaybe<FollowUpInput>;
  lastObserved?: InputMaybe<Scalars['Date']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  massPlanting?: InputMaybe<Scalars['Boolean']['input']>;
  materialGroup?: InputMaybe<MaterialGroup>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesData?: InputMaybe<Scalars['JSON']['input']>;
  position?: InputMaybe<GeographicInput>;
  /** Whether the material is publicly visible. */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<MaterialSex>;
  status?: InputMaybe<PlantMaterialStatus>;
  /** Additional supplemental data associated with the material. */
  supplementalData?: InputMaybe<Scalars['JSONObject']['input']>;
  tagNumber?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export enum PlantMaterialsColumn {
  AccessionNum = 'ACCESSION_NUM',
  CommonName = 'COMMON_NAME',
  DateAdded = 'DATE_ADDED',
  DaysOverdueFollowUp = 'DAYS_OVERDUE_FOLLOW_UP',
  DonorSupplier = 'DONOR_SUPPLIER',
  GlobalRedListStatus = 'GLOBAL_RED_LIST_STATUS',
  LastObserved = 'LAST_OBSERVED',
  LastUpdated = 'LAST_UPDATED',
  LocationCode = 'LOCATION_CODE',
  MaterialGroup = 'MATERIAL_GROUP',
  ProvenanceCategoryCode = 'PROVENANCE_CATEGORY_CODE',
  Quantity = 'QUANTITY',
  ScientificName = 'SCIENTIFIC_NAME',
  Status = 'STATUS'
}

export type PlantMaterialsOrderByInput = {
  direction: SortDirection;
  field: PlantMaterialsColumn;
};

export enum PlantMaterialsSearchColumn {
  MaterialNumber = 'MATERIAL_NUMBER',
  ScientificName = 'SCIENTIFIC_NAME'
}

export type PlantMaterialsSearchTerm = {
  field: PlantMaterialsSearchColumn;
  value: Scalars['String']['input'];
};

export type ProfileChangesInput = {
  askMeAbout?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type PromoteExogenousAccessionNumberInput = {
  oldAccessionNumber: Scalars['String']['input'];
  prefix: Scalars['Int']['input'];
  suffix?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoteExogenousAccessionNumbersResult = GenericError | PromoteExogenousAccessionNumbersSuccess;

export type PromoteExogenousAccessionNumbersSuccess = {
  __typename?: 'PromoteExogenousAccessionNumbersSuccess';
  message: Scalars['String']['output'];
};

export enum PropagationHistoryCode {
  I = 'I',
  S = 'S',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  U = 'U',
  V = 'V',
  Va = 'VA',
  Vb = 'VB'
}

/** Details about the original source geolocation from where the accession and plant material was obtained */
export type ProvenanceCategory = {
  __typename?: 'ProvenanceCategory';
  codeId: ProvenanceCategoryCode;
  name: Scalars['String']['output'];
  ordering: Scalars['Int']['output'];
};

export enum ProvenanceCategoryCode {
  G = 'G',
  U = 'U',
  W = 'W',
  Z = 'Z'
}

export type ProvenanceCategoryCount = {
  __typename?: 'ProvenanceCategoryCount';
  count: Scalars['Int']['output'];
  provenanceCategoryCode: Scalars['String']['output'];
};

export type ProvenanceFilter = {
  and?: InputMaybe<Array<ProvenanceFilter>>;
  eq?: InputMaybe<ProvenanceCategoryCode>;
  neq?: InputMaybe<ProvenanceCategoryCode>;
  or?: InputMaybe<Array<ProvenanceFilter>>;
};

export type PublicOrganisation = {
  __typename?: 'PublicOrganisation';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  subdomain?: Maybe<Scalars['String']['output']>;
};

export type QualifierSort = {
  order?: InputMaybe<SortOrder>;
};

export type Query = {
  __typename?: 'Query';
  _?: Maybe<Scalars['String']['output']>;
  accession?: Maybe<Accession>;
  collectionSite?: Maybe<CollectionSite>;
  /** @deprecated Use location instead */
  collectionSiteLocation?: Maybe<CollectionSiteLocation>;
  collectionSiteMembership?: Maybe<CollectionSiteMembership>;
  countries?: Maybe<Array<Country>>;
  getOrgUsageAnalytics?: Maybe<GetOrgUsageAnalyticsResult>;
  lifeForms: LifeFormConnection;
  location?: Maybe<Location>;
  material?: Maybe<PlantMaterial>;
  materialImage?: Maybe<MaterialImage>;
  materialType?: Maybe<MaterialType>;
  materialTypes?: Maybe<Array<MaterialType>>;
  me?: Maybe<User>;
  observation?: Maybe<Observation>;
  organisation?: Maybe<Organisation>;
  organisationBySubdomain?: Maybe<Organisation>;
  permissions?: Maybe<UserPermissions>;
  provenanceCategories?: Maybe<Array<ProvenanceCategory>>;
  publicOrganisation?: Maybe<PublicOrganisation>;
  recordTag?: Maybe<RecordTag>;
  sharedScientificName?: Maybe<ScientificName>;
  sharedScientificNames: ScientificNameConnection;
  sharedTaxon?: Maybe<SharedTaxon>;
  /** @deprecated Use sharedScientificNames instead */
  supraspecificTaxa: SupraspecificTaxaConnection;
  taxon?: Maybe<Taxon>;
  user?: Maybe<User>;
  userSettings: UserSettings;
  validateBatchArchiveTaxa: BatchTaxaPayload;
  verifyAccessions: VerifyAccessionsResult;
};


export type QueryAccessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCollectionSiteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCollectionSiteLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCollectionSiteMembershipArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrgUsageAnalyticsArgs = {
  organisationSubdomain: Scalars['String']['input'];
};


export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMaterialArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMaterialImageArgs = {
  id: Scalars['ID']['input'];
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMaterialTypeArgs = {
  code: Scalars['String']['input'];
};


export type QueryObservationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganisationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganisationBySubdomainArgs = {
  subdomain: Scalars['String']['input'];
};


export type QueryPermissionsArgs = {
  collectionSiteSlug?: InputMaybe<Scalars['String']['input']>;
  organisationSubdomain: Scalars['String']['input'];
};


export type QueryPublicOrganisationArgs = {
  subdomain: Scalars['String']['input'];
};


export type QueryRecordTagArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySharedScientificNameArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySharedScientificNamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ScientificNameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ScientificNameOrderBy>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySharedTaxonArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupraspecificTaxaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SupraspecificTaxaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SupraspecificTaxaOrderBy>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTaxonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryValidateBatchArchiveTaxaArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryVerifyAccessionsArgs = {
  accessions: Array<CreateAccession>;
  collectionSiteId: Scalars['String']['input'];
};

export type RecordTag = {
  __typename?: 'RecordTag';
  archived: Scalars['Boolean']['output'];
  collectionSite?: Maybe<CollectionSite>;
  collectionSiteId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RecordTagConnection = {
  __typename?: 'RecordTagConnection';
  edges: Array<RecordTagEdge>;
  nodes: Array<RecordTag>;
  pageInfo: PageInfo;
};

export type RecordTagEdge = {
  __typename?: 'RecordTagEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: RecordTag;
};

export type RecordTagFilter = {
  id?: InputMaybe<IdComparator>;
  name?: InputMaybe<StringComparator>;
};

export type RecordTagFilters = {
  collectionSite?: InputMaybe<CollectionSiteFilter>;
  hasAccessionRelations?: InputMaybe<RelationExistsComparator>;
  hasCollectionSiteRelation?: InputMaybe<RelationExistsComparator>;
  hasMaterialRelations?: InputMaybe<RelationExistsComparator>;
  hasTaxaRelations?: InputMaybe<RelationExistsComparator>;
};

export type RecordTagInput = {
  collectionSiteId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type RecordTagResult = {
  __typename?: 'RecordTagResult';
  errors?: Maybe<Array<RecordTagResultError>>;
  recordTag?: Maybe<RecordTag>;
  success: Scalars['Boolean']['output'];
};

export type RecordTagResultError = DuplicateNameError | GenericError | NotFoundError | SiteTagMergeError;

export type RecordTagUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum RedListStatus {
  ConservationDependent = 'CONSERVATION_DEPENDENT',
  CriticallyEndangered = 'CRITICALLY_ENDANGERED',
  DataDeficient = 'DATA_DEFICIENT',
  Endangered = 'ENDANGERED',
  Extinct = 'EXTINCT',
  ExtinctInTheWild = 'EXTINCT_IN_THE_WILD',
  LeastConcern = 'LEAST_CONCERN',
  NearThreatened = 'NEAR_THREATENED',
  NotEvaluated = 'NOT_EVALUATED',
  Vulnerable = 'VULNERABLE'
}

export type RedListStatusComparator = {
  and?: InputMaybe<Array<RedListStatusComparator>>;
  eq?: InputMaybe<RedListStatus>;
  in?: InputMaybe<Array<RedListStatus>>;
  neq?: InputMaybe<RedListStatus>;
  nin?: InputMaybe<Array<RedListStatus>>;
  or?: InputMaybe<Array<RedListStatusComparator>>;
};

export type RedListStatusCount = {
  __typename?: 'RedListStatusCount';
  count: Scalars['Int']['output'];
  redListStatus: RedListStatus;
};

export enum RedListTaxonomicStatus {
  Accepted = 'ACCEPTED',
  HetrotypicSynonym = 'HETROTYPIC_SYNONYM',
  HomotypicSynonym = 'HOMOTYPIC_SYNONYM',
  OrthographicSynonym = 'ORTHOGRAPHIC_SYNONYM'
}

export type RedListTaxonomicStatusComparator = {
  and?: InputMaybe<Array<RedListTaxonomicStatusComparator>>;
  eq?: InputMaybe<RedListTaxonomicStatus>;
  in?: InputMaybe<Array<RedListTaxonomicStatus>>;
  neq?: InputMaybe<RedListTaxonomicStatus>;
  nin?: InputMaybe<Array<RedListTaxonomicStatus>>;
  or?: InputMaybe<Array<RedListTaxonomicStatusComparator>>;
};

export type ReferAFriendInput = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  organisationName: Scalars['String']['input'];
};

export type RelationExistsComparator = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReturnedBoolError = {
  __typename?: 'ReturnedBoolError';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ScientificName = {
  __typename?: 'ScientificName';
  acceptedName?: Maybe<ScientificName>;
  acceptedNameId?: Maybe<Scalars['ID']['output']>;
  authorship?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<Classification>;
  higherClassification?: Maybe<Array<Scalars['String']['output']>>;
  hybridType: HybridType;
  id: Scalars['ID']['output'];
  nameSource: NameSource;
  nameSourceId?: Maybe<Scalars['String']['output']>;
  nameSourceRank?: Maybe<Scalars['String']['output']>;
  nameSourceStatus?: Maybe<Scalars['String']['output']>;
  nameSourceUrl: Scalars['String']['output'];
  parent?: Maybe<ScientificName>;
  parentId?: Maybe<Scalars['ID']['output']>;
  parentPrimaryRank?: Maybe<ScientificName>;
  parentPrimaryRankId?: Maybe<Scalars['ID']['output']>;
  rank: TaxonomicRank;
  scientificName: Scalars['String']['output'];
  scientificNameShort?: Maybe<Scalars['String']['output']>;
  status: TaxonomicStatus;
  synonymType?: Maybe<SynonymType>;
  taxon?: Maybe<SharedTaxon>;
  taxonId?: Maybe<Scalars['ID']['output']>;
};

export type ScientificNameConnection = {
  __typename?: 'ScientificNameConnection';
  edges: Array<ScientificNameEdge>;
  nodes: Array<ScientificName>;
  pageInfo: PageInfo;
};

export type ScientificNameEdge = {
  __typename?: 'ScientificNameEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: ScientificName;
};

export type ScientificNameFilter = {
  and?: InputMaybe<Array<ScientificNameFilter>>;
  authorship?: InputMaybe<NullableStringComparator>;
  classification?: InputMaybe<ClassificationFilter>;
  id?: InputMaybe<IdComparator>;
  or?: InputMaybe<Array<ScientificNameFilter>>;
  rank?: InputMaybe<TaxonomicRankComparator>;
  status?: InputMaybe<TaxonomicStatusComparator>;
  taxon?: InputMaybe<NullableSharedTaxonFilter>;
};

export type ScientificNameOrderBy = {
  direction: SortDirection;
  field: ScientificNameSortColumn;
};

export type ScientificNameSort = {
  order?: InputMaybe<SortOrder>;
};

export enum ScientificNameSortColumn {
  ScientificName = 'SCIENTIFIC_NAME',
  Status = 'STATUS'
}

export type SharedTaxon = {
  __typename?: 'SharedTaxon';
  climate?: Maybe<Scalars['String']['output']>;
  globalRedListPublishedYear?: Maybe<Scalars['String']['output']>;
  globalRedListSourceUrl?: Maybe<Scalars['String']['output']>;
  globalRedListStatus?: Maybe<RedListStatus>;
  globalRedListTaxonomicStatus?: Maybe<RedListTaxonomicStatus>;
  id: Scalars['ID']['output'];
  lifeForms?: Maybe<LifeFormConnection>;
  nativeDistribution?: Maybe<Scalars['String']['output']>;
  taxonSource?: Maybe<NameSource>;
  taxonSourceId?: Maybe<Scalars['String']['output']>;
  taxonSourceLifeForm?: Maybe<Scalars['String']['output']>;
};

export enum SiteAccessionNumberFormat {
  YearSeq_4DigitPadded = 'YEAR_SEQ_4_DIGIT_PADDED',
  YearSeq_5DigitPadded = 'YEAR_SEQ_5_DIGIT_PADDED'
}

export type SiteTagMergeError = Error & {
  __typename?: 'SiteTagMergeError';
  message: Scalars['String']['output'];
  tags: Array<RecordTag>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortOrder {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export type StatusFilter = {
  is?: InputMaybe<Array<PlantMaterialStatus>>;
  isNot?: InputMaybe<Array<PlantMaterialStatus>>;
};

export type StringComparator = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubdomainSlugPair = {
  __typename?: 'SubdomainSlugPair';
  slug: Scalars['String']['output'];
  subdomain: Scalars['String']['output'];
};

/** An organisation's subscription */
export type Subscription = {
  __typename?: 'Subscription';
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdManually: Scalars['Boolean']['output'];
  cycle: BillingCycle;
  flexibleDays?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  organisation: Organisation;
  plan: SubscriptionPlan;
  renewsAt: Scalars['DateTime']['output'];
  seats?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum SubscriptionPlan {
  Basic = 'BASIC',
  Custom = 'CUSTOM',
  Plus = 'PLUS',
  Standard = 'STANDARD'
}

export type SuccessResult = {
  __typename?: 'SuccessResult';
  success: Scalars['Boolean']['output'];
};

export type SupraspecificTaxaConnection = {
  __typename?: 'SupraspecificTaxaConnection';
  edges: Array<SupraspecificTaxaEdge>;
  nodes: Array<SupraspecificTaxon>;
  pageInfo: PageInfo;
};

export type SupraspecificTaxaEdge = {
  __typename?: 'SupraspecificTaxaEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: SupraspecificTaxon;
};

export type SupraspecificTaxaFilter = {
  and?: InputMaybe<Array<SupraspecificTaxaFilter>>;
  authorship?: InputMaybe<NullableStringComparator>;
  id?: InputMaybe<IdComparator>;
  or?: InputMaybe<Array<SupraspecificTaxaFilter>>;
  rank?: InputMaybe<TaxonomicRankComparator>;
  status?: InputMaybe<TaxonomicStatusComparator>;
};

export type SupraspecificTaxaOrderBy = {
  direction: SortDirection;
  field: SupraspecificTaxaSortColumn;
};

export enum SupraspecificTaxaSortColumn {
  ScientificName = 'SCIENTIFIC_NAME',
  Status = 'STATUS'
}

export type SupraspecificTaxon = {
  __typename?: 'SupraspecificTaxon';
  authorship?: Maybe<Scalars['String']['output']>;
  higherClassification?: Maybe<Array<Scalars['String']['output']>>;
  hybridType: HybridType;
  id: Scalars['ID']['output'];
  nameSource: NameSource;
  nameSourceUrl: Scalars['String']['output'];
  parent?: Maybe<SupraspecificTaxon>;
  parentId?: Maybe<Scalars['ID']['output']>;
  parentPrimaryRank?: Maybe<SupraspecificTaxon>;
  parentPrimaryRankId?: Maybe<Scalars['ID']['output']>;
  rank: TaxonomicRank;
  scientificName: Scalars['String']['output'];
  scientificNameShort?: Maybe<Scalars['String']['output']>;
  status: TaxonomicStatus;
};

export enum SynonymType {
  Hetrotypic = 'HETROTYPIC',
  Homotypic = 'HOMOTYPIC'
}

export enum TaxaColumn {
  Authorship = 'AUTHORSHIP',
  CommonName = 'COMMON_NAME',
  FamilyName = 'FAMILY_NAME',
  GlobalRedListStatus = 'GLOBAL_RED_LIST_STATUS',
  LastUpdated = 'LAST_UPDATED',
  ScientificName = 'SCIENTIFIC_NAME'
}

export type TaxaFilter = {
  and?: InputMaybe<Array<TaxaFilter>>;
  archived?: InputMaybe<BooleanComparator>;
  authorship?: InputMaybe<NullableStringComparator>;
  commonName?: InputMaybe<NullableStringComparator>;
  createdBy?: InputMaybe<NullableUserFilter>;
  fullyValidated?: InputMaybe<BooleanComparator>;
  id?: InputMaybe<IdComparator>;
  nativeDistribution?: InputMaybe<NullableStringComparator>;
  notes?: InputMaybe<NullableStringComparator>;
  or?: InputMaybe<Array<TaxaFilter>>;
  sharedScientificName?: InputMaybe<NullableScientificNameFilter>;
  tags?: InputMaybe<RecordTagFilter>;
  updatedBy?: InputMaybe<NullableUserFilter>;
};

export type TaxaOrderByInput = {
  direction: SortDirection;
  field: TaxaColumn;
};

export enum TaxaSearchColumn {
  ScientificName = 'SCIENTIFIC_NAME'
}

export type TaxaSearchTerm = {
  field: TaxaSearchColumn;
  value: Scalars['String']['input'];
};

export type Taxon = {
  __typename?: 'Taxon';
  accessions?: Maybe<Array<Accession>>;
  archived: Scalars['Boolean']['output'];
  authorship?: Maybe<Scalars['String']['output']>;
  commonName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['ID']['output']>;
  fullyValidated: Scalars['Boolean']['output'];
  /** @deprecated Use sharedScientificName instead */
  genus?: Maybe<SupraspecificTaxon>;
  /** @deprecated Use sharedScientificNameId instead */
  genusId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use historyConnection instead */
  history?: Maybe<Array<TaxonHistory>>;
  historyConnection?: Maybe<TaxonHistoryConnection>;
  id: Scalars['ID']['output'];
  interpretationDescription?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use nativeDistribution instead */
  interpretationNaturalDistribution?: Maybe<Scalars['String']['output']>;
  nativeDistribution?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notesData?: Maybe<Scalars['JSON']['output']>;
  organisation?: Maybe<Organisation>;
  organisationId: Scalars['ID']['output'];
  scientificName: Scalars['String']['output'];
  sharedScientificName?: Maybe<ScientificName>;
  sharedScientificNameId?: Maybe<Scalars['ID']['output']>;
  /** Additional supplemental data associated with the taxon. */
  supplementalData?: Maybe<Scalars['JSONObject']['output']>;
  /** @deprecated Use tagsConnection instead */
  tags?: Maybe<Array<RecordTag>>;
  tagsConnection?: Maybe<RecordTagConnection>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['ID']['output']>;
};


export type TaxonAccessionsArgs = {
  filter?: InputMaybe<AccessionFilter>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection for `Taxon` */
export type TaxonConnection = {
  __typename?: 'TaxonConnection';
  edges: Array<TaxonEdge>;
  nodes: Array<Taxon>;
  pageInfo: PageInfo;
};

export type TaxonEdge = {
  __typename?: 'TaxonEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Taxon;
};

export type TaxonHistory = {
  __typename?: 'TaxonHistory';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  fromAuthorship?: Maybe<Scalars['String']['output']>;
  fromCommonName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use fromSharedScientificName instead */
  fromGenus?: Maybe<SupraspecificTaxon>;
  /** @deprecated Use fromSharedScientificNameId instead */
  fromGenusId?: Maybe<Scalars['ID']['output']>;
  fromInterpretationDescription?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use fromNativeDistribution instead */
  fromInterpretationNaturalDistribution?: Maybe<Scalars['String']['output']>;
  fromNativeDistribution?: Maybe<Scalars['String']['output']>;
  fromNotes?: Maybe<Scalars['String']['output']>;
  fromScientificName?: Maybe<Scalars['String']['output']>;
  fromSharedScientificName?: Maybe<ScientificName>;
  fromSharedScientificNameId?: Maybe<Scalars['ID']['output']>;
  taxon?: Maybe<Taxon>;
  taxonId: Scalars['String']['output'];
  toAuthorship?: Maybe<Scalars['String']['output']>;
  toCommonName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use toSharedScientificName instead */
  toGenus?: Maybe<SupraspecificTaxon>;
  /** @deprecated Use toSharedScientificNameId instead */
  toGenusId?: Maybe<Scalars['ID']['output']>;
  toInterpretationDescription?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use toNativeDistribution instead */
  toInterpretationNaturalDistribution?: Maybe<Scalars['String']['output']>;
  toNativeDistribution?: Maybe<Scalars['String']['output']>;
  toNotes?: Maybe<Scalars['String']['output']>;
  toScientificName?: Maybe<Scalars['String']['output']>;
  toSharedScientificName?: Maybe<ScientificName>;
  toSharedScientificNameId?: Maybe<Scalars['ID']['output']>;
  wasArchived?: Maybe<Scalars['Boolean']['output']>;
  wasRestored?: Maybe<Scalars['Boolean']['output']>;
};

export type TaxonHistoryConnection = {
  __typename?: 'TaxonHistoryConnection';
  edges: Array<TaxonHistoryEdge>;
  nodes: Array<TaxonHistory>;
  pageInfo: PageInfo;
};

export type TaxonHistoryEdge = {
  __typename?: 'TaxonHistoryEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: TaxonHistory;
};

export type TaxonResult = {
  __typename?: 'TaxonResult';
  errors?: Maybe<Array<DuplicateScientificNameError>>;
  success: Scalars['Boolean']['output'];
  taxon?: Maybe<Taxon>;
};

export enum TaxonomicRank {
  Class = 'CLASS',
  Family = 'FAMILY',
  Genus = 'GENUS',
  Infraspecies = 'INFRASPECIES',
  Kingdom = 'KINGDOM',
  Order = 'ORDER',
  Phylum = 'PHYLUM',
  Section = 'SECTION',
  Series = 'SERIES',
  Species = 'SPECIES',
  Subclass = 'SUBCLASS',
  Subfamily = 'SUBFAMILY',
  Subgenus = 'SUBGENUS',
  Subkingdom = 'SUBKINGDOM',
  Suborder = 'SUBORDER',
  Subphylum = 'SUBPHYLUM',
  Subsection = 'SUBSECTION',
  Subseries = 'SUBSERIES',
  Subspecies = 'SUBSPECIES',
  Subtribe = 'SUBTRIBE',
  Superorder = 'SUPERORDER',
  Tribe = 'TRIBE'
}

export type TaxonomicRankComparator = {
  and?: InputMaybe<Array<TaxonomicRankComparator>>;
  eq?: InputMaybe<TaxonomicRank>;
  neq?: InputMaybe<TaxonomicRank>;
  or?: InputMaybe<Array<TaxonomicRankComparator>>;
};

export enum TaxonomicStatus {
  Accepted = 'ACCEPTED',
  Synonym = 'SYNONYM',
  Unplaced = 'UNPLACED'
}

export type TaxonomicStatusComparator = {
  and?: InputMaybe<Array<TaxonomicStatusComparator>>;
  eq?: InputMaybe<TaxonomicStatus>;
  neq?: InputMaybe<TaxonomicStatus>;
  or?: InputMaybe<Array<TaxonomicStatusComparator>>;
};

/**
 * For unions that might be extended in the future. For example, feed returns
 * Posts, but in the future might return Posts and Plants. Should be handled in
 * default switch clauses
 */
export type UnknownPossibleFutureAddition = {
  __typename?: 'UnknownPossibleFutureAddition';
  _?: Maybe<Scalars['String']['output']>;
};

export type UpdateAccessionInput = {
  accessionDate?: InputMaybe<Scalars['Date']['input']>;
  accessionNumberFormat?: InputMaybe<AccessionNumberFormat>;
  accessionNumberPrefix?: InputMaybe<Scalars['Int']['input']>;
  accessionNumberSuffix?: InputMaybe<Scalars['Int']['input']>;
  collectionAssociatedTaxa?: InputMaybe<Scalars['String']['input']>;
  collectionCollectors?: InputMaybe<Scalars['String']['input']>;
  collectionCollectorsFieldNumber?: InputMaybe<Scalars['String']['input']>;
  collectionCoordinateUncertainty?: InputMaybe<Scalars['Int']['input']>;
  collectionCountryCode?: InputMaybe<Scalars['String']['input']>;
  collectionDate?: InputMaybe<Scalars['Date']['input']>;
  collectionElevation?: InputMaybe<Scalars['String']['input']>;
  collectionHabitat?: InputMaybe<Scalars['String']['input']>;
  collectionLatitude?: InputMaybe<Scalars['String']['input']>;
  collectionLocality?: InputMaybe<Scalars['String']['input']>;
  collectionLocation?: InputMaybe<Scalars['String']['input']>;
  collectionLongitude?: InputMaybe<Scalars['String']['input']>;
  collectionRemarks?: InputMaybe<Scalars['String']['input']>;
  collectionStateProvince?: InputMaybe<Scalars['String']['input']>;
  dateIdentified?: InputMaybe<Scalars['Date']['input']>;
  donor?: InputMaybe<Scalars['String']['input']>;
  exogenousAccessionNumber?: InputMaybe<Scalars['String']['input']>;
  identificationQualifier?: InputMaybe<Scalars['String']['input']>;
  identificationRemarks?: InputMaybe<Scalars['String']['input']>;
  identificationVerificationStatus?: InputMaybe<Scalars['String']['input']>;
  identifiedBy?: InputMaybe<Scalars['String']['input']>;
  ipenNumber?: InputMaybe<Scalars['String']['input']>;
  materialReceivedCode?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesData?: InputMaybe<Scalars['JSON']['input']>;
  parentageNotes?: InputMaybe<Scalars['String']['input']>;
  parentageNotesData?: InputMaybe<Scalars['JSON']['input']>;
  propagationHistoryCode?: InputMaybe<PropagationHistoryCode>;
  provenanceCategoryCode?: InputMaybe<ProvenanceCategoryCode>;
  /** Additional supplemental data associated with the taxon. */
  supplementalData?: InputMaybe<Scalars['JSONObject']['input']>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
  taxonId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccessionResult = Accession | GenericError;

export type UpdateCollectionSiteLocationResult = CollectionSiteLocation | DuplicateCollectionSiteLocationCodeError;

export type UpdateLocationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  geometry?: InputMaybe<Scalars['JSON']['input']>;
  geometryColor?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMaterialImageResult = GenericError | MaterialImage;

export type UpdateObservationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  bodyData?: InputMaybe<Scalars['JSON']['input']>;
  condition?: InputMaybe<ObservationConditionType>;
};

export type UpdateOrganisationResult = GenericError | Organisation;

export type UpdatePlantMaterialResult = GenericError | PlantMaterial;

export type UpdateTaxonInput = {
  authorship?: InputMaybe<Scalars['String']['input']>;
  commonName?: InputMaybe<Scalars['String']['input']>;
  interpretationDescription?: InputMaybe<Scalars['String']['input']>;
  nativeDistribution?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesData?: InputMaybe<Scalars['JSON']['input']>;
  scientificName?: InputMaybe<Scalars['String']['input']>;
  sharedScientificNameId?: InputMaybe<Scalars['ID']['input']>;
  /** Additional supplemental data associated with the taxon. */
  supplementalData?: InputMaybe<Scalars['JSONObject']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UploadFileHeader = {
  __typename?: 'UploadFileHeader';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UploadMaterialImageResult = GenericError | MaterialImage;

export type UploadPayload = {
  __typename?: 'UploadPayload';
  headers: Array<UploadFileHeader>;
  uploadUrl: Scalars['String']['output'];
};

export type UsageAnalytics = {
  __typename?: 'UsageAnalytics';
  analytics?: Maybe<Array<DailyUsageAnalytics>>;
};

/** A member of staff who operates Hortis within an individual collection site */
export type User = {
  __typename?: 'User';
  accessRole: AccessRole;
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  askMeAbout?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  collectionSiteMemberships?: Maybe<Array<CollectionSiteMembership>>;
  collectionSites?: Maybe<Array<CollectionSite>>;
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedBy?: Maybe<Scalars['ID']['output']>;
  email: Scalars['String']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initials: Scalars['String']['output'];
  isActivated: Scalars['Boolean']['output'];
  organisation?: Maybe<Organisation>;
  organisationId: Scalars['ID']['output'];
  role?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type UserAdminResult = {
  __typename?: 'UserAdminResult';
  success: Scalars['Boolean']['output'];
};

export type UserFilter = {
  and?: InputMaybe<Array<UserFilter>>;
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<UserFilter>>;
};

export type UserPayload = {
  __typename?: 'UserPayload';
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type UserPermissions = {
  __typename?: 'UserPermissions';
  deactivated: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isInvalidCollectionSite: Scalars['Boolean']['output'];
  isInvalidOrganisation: Scalars['Boolean']['output'];
  organisationId: Scalars['ID']['output'];
  user?: Maybe<User>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  experimentalFeaturesEnabled: Scalars['Boolean']['output'];
  settings: Scalars['JSONObject']['output'];
};

export type UserSettingsInput = {
  experimentalFeaturesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type UserSettingsPayload = {
  __typename?: 'UserSettingsPayload';
  success: Scalars['Boolean']['output'];
  userSettings: UserSettings;
};

export type VerifyAccessionResult = {
  __typename?: 'VerifyAccessionResult';
  errors: Array<GenericError>;
  success: Scalars['Boolean']['output'];
};

export type VerifyAccessionsResult = {
  __typename?: 'VerifyAccessionsResult';
  results: Array<VerifyAccessionResult>;
  totalFailed: Scalars['Int']['output'];
  totalSuccess: Scalars['Int']['output'];
};

export type VerifyEmailResponse = GenericError | VerifyEmailResult;

export type VerifyEmailResult = {
  __typename?: 'VerifyEmailResult';
  status: Scalars['String']['output'];
};

export type VerifyUserResponse = {
  __typename?: 'VerifyUserResponse';
  hortisId: Scalars['ID']['output'];
  isActivated: Scalars['Boolean']['output'];
  isDeactivated: Scalars['Boolean']['output'];
};

export type GetAccessionScientificNamesQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']['input']>;
  organisationSubdomain: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ScientificNameFilter>;
  orderBy?: InputMaybe<ScientificNameOrderBy>;
  taxaSearchTerm?: InputMaybe<TaxaSearchTerm>;
  taxaFilter?: InputMaybe<TaxaFilter>;
}>;


export type GetAccessionScientificNamesQuery = { __typename?: 'Query', sharedScientificNames: { __typename?: 'ScientificNameConnection', nodes: Array<{ __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, rank: TaxonomicRank, nameSource: NameSource }> }, org?: { __typename?: 'Organisation', result?: { __typename?: 'TaxonConnection', nodes: Array<{ __typename?: 'Taxon', id: string, scientificName: string, authorship?: string | null, commonName?: string | null, fullyValidated: boolean, nativeDistribution?: string | null, notes?: string | null, updatedAt: string, updatedBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, status: TaxonomicStatus, nameSourceUrl: string, nameSource: NameSource, rank: TaxonomicRank, authorship?: string | null, parentPrimaryRank?: { __typename?: 'ScientificName', id: string, scientificName: string } | null, classification?: { __typename?: 'Classification', family?: string | null } | null, taxon?: { __typename?: 'SharedTaxon', nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null }> } | null } | null };

export type GetMultiRankScientificNamesQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']['input']>;
  generaSearchTerm?: InputMaybe<Scalars['String']['input']>;
  speciesSearchTerm?: InputMaybe<Scalars['String']['input']>;
  infraspeciesSearchTerm?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<ScientificNameOrderBy>;
}>;


export type GetMultiRankScientificNamesQuery = { __typename?: 'Query', genera: { __typename?: 'ScientificNameConnection', nodes: Array<{ __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, rank: TaxonomicRank, nameSource: NameSource, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null }> }, species: { __typename?: 'ScientificNameConnection', nodes: Array<{ __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, rank: TaxonomicRank, nameSource: NameSource, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null }> }, infraspecies: { __typename?: 'ScientificNameConnection', nodes: Array<{ __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, rank: TaxonomicRank, nameSource: NameSource, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null }> } };

export type ReferAFriendMutationVariables = Exact<{
  input: ReferAFriendInput;
}>;


export type ReferAFriendMutation = { __typename?: 'Mutation', referAFriend: { __typename?: 'SuccessResult', success: boolean } };

export type GetUserSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSettingsQuery = { __typename?: 'Query', userSettings: { __typename?: 'UserSettings', experimentalFeaturesEnabled: boolean, settings: Record<string, any> } };

export type UpdateUserSettingsMutationVariables = Exact<{
  input: UserSettingsInput;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'Mutation', updateUserSettings: { __typename?: 'UserSettingsPayload', success: boolean, userSettings: { __typename?: 'UserSettings', experimentalFeaturesEnabled: boolean, settings: Record<string, any> } } };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename?: 'User', initials: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null } | null };

export type GetEntitySuggestionsQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
  search: Scalars['String']['input'];
}>;


export type GetEntitySuggestionsQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', taxa?: { __typename?: 'TaxonConnection', nodes: Array<{ __typename: 'Taxon', id: string, scientificName: string, commonName?: string | null }> } | null, site?: { __typename?: 'CollectionSite', accessions?: { __typename?: 'AccessionConnection', nodes: Array<{ __typename: 'Accession', id: string, accessionNumber: string, scientificName?: string | null }> } | null, plantMaterials?: { __typename?: 'PlantMaterialConnection', nodes: Array<{ __typename: 'PlantMaterial', id: string, status: PlantMaterialStatus, qualifier: string, accession?: { __typename?: 'Accession', accessionNumber: string, scientificName?: string | null } | null }> } | null } | null } | null };

export type UpdatePlantMaterialsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: PlantMaterialUpdates;
}>;


export type UpdatePlantMaterialsMutation = { __typename?: 'Mutation', updatePlantMaterials: { __typename: 'BatchPlantMaterialPayload', success: boolean, errors?: Array<{ __typename?: 'GenericError', message: string }> | null, plantMaterials: Array<{ __typename?: 'PlantMaterial', id: string }> } };

export type GetPublicOrganisationQueryVariables = Exact<{
  subdomain: Scalars['String']['input'];
}>;


export type GetPublicOrganisationQuery = { __typename?: 'Query', publicOrganisation?: { __typename?: 'PublicOrganisation', name: string, subdomain?: string | null, avatarUrl?: string | null } | null };

export type BaseMapFieldsFragment = { __typename?: 'BaseMap', id: string, name: string, url: string, attribution?: string | null, minZoom?: number | null, maxZoom?: number | null };

export type GetMapConfigQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
}>;


export type GetMapConfigQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', map?: { __typename?: 'MapConfig', key?: string | null } | null, site?: { __typename?: 'CollectionSite', id: string, name: string, urlSlug: string, mapCenterLatitude?: number | null, mapCenterLongitude?: number | null, mapZoomLevel?: number | null, baseMap?: { __typename?: 'BaseMap', id: string, name: string, url: string, attribution?: string | null, minZoom?: number | null, maxZoom?: number | null } | null } | null } | null };

export type GetCollectionLocationGeometryQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
  filter?: InputMaybe<LocationFilter>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCollectionLocationGeometryQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', site?: { __typename?: 'CollectionSite', name: string, locationsGeometry?: any | null } | null } | null };

export type GetCollectionGeometryQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
  filters?: InputMaybe<PlantMaterialFilter>;
  searchTerm?: InputMaybe<PlantMaterialsSearchTerm>;
}>;


export type GetCollectionGeometryQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', site?: { __typename?: 'CollectionSite', name: string, plantMaterialsAsGeoJSON?: any | null, baseMap?: { __typename?: 'BaseMap', id: string, name: string, url: string, attribution?: string | null, minZoom?: number | null, maxZoom?: number | null } | null } | null } | null };

export type GetCollectionGeometryWithinCircleQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
  searchTerm?: InputMaybe<PlantMaterialsSearchTerm>;
  bounds: Circle;
}>;


export type GetCollectionGeometryWithinCircleQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', site?: { __typename?: 'CollectionSite', name: string, plantMaterialsGeometryWithinCircleWIP?: { __typename?: 'PlantMaterialGeoJSONFeatureCollection', type: GeoJsonFeatureCollectionType, features: Array<{ __typename?: 'PlantMaterialGeoJSONFeature', type: GeoJsonFeatureType, geometry: GeoJSON.Geometry, properties: { __typename?: 'PlantMaterialGeoJSONProperties', adHoc?: PlantMaterialGeoJSONPropertiesAdHoc | null } }> } | null } | null } | null };

export type MapMaterialListFieldsFragment = { __typename?: 'PlantMaterial', id: string, qualifier: string, status: PlantMaterialStatus, materialGroup: MaterialGroup, public: boolean, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, code?: string | null, archived: boolean } | null, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, accession?: { __typename?: 'Accession', accessionNumber: string, scientificName?: string | null, provenanceCategoryCode: ProvenanceCategoryCode, taxon?: { __typename?: 'Taxon', scientificName: string, commonName?: string | null, fullyValidated: boolean, nativeDistribution?: string | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, status: TaxonomicStatus, nameSourceUrl: string, nameSource: NameSource, rank: TaxonomicRank, authorship?: string | null, classification?: { __typename?: 'Classification', family?: string | null } | null, taxon?: { __typename?: 'SharedTaxon', nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null } | null } | null } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, lastObservation?: { __typename?: 'Observation', id: string, createdAt: string, condition: ObservationConditionType } | null, followUp?: { __typename?: 'FollowUp', count: number, period: Period } | null };

export type MapListMaterialsQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
  orderBy?: InputMaybe<PlantMaterialsOrderByInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<PlantMaterialFilter>;
  searchTerm?: InputMaybe<PlantMaterialsSearchTerm>;
}>;


export type MapListMaterialsQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', site?: { __typename?: 'CollectionSite', total?: number | null, result?: { __typename?: 'PlantMaterialConnection', nodes: Array<{ __typename?: 'PlantMaterial', id: string, qualifier: string, status: PlantMaterialStatus, materialGroup: MaterialGroup, public: boolean, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, code?: string | null, archived: boolean } | null, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, accession?: { __typename?: 'Accession', accessionNumber: string, scientificName?: string | null, provenanceCategoryCode: ProvenanceCategoryCode, taxon?: { __typename?: 'Taxon', scientificName: string, commonName?: string | null, fullyValidated: boolean, nativeDistribution?: string | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, status: TaxonomicStatus, nameSourceUrl: string, nameSource: NameSource, rank: TaxonomicRank, authorship?: string | null, classification?: { __typename?: 'Classification', family?: string | null } | null, taxon?: { __typename?: 'SharedTaxon', nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null } | null } | null } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, lastObservation?: { __typename?: 'Observation', id: string, createdAt: string, condition: ObservationConditionType } | null, followUp?: { __typename?: 'FollowUp', count: number, period: Period } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } | null } | null } | null };

export type AccessionsListFieldsFragment = { __typename?: 'Accession', id: string, accessionNumber: string, accessionDate?: string | null, archived: boolean, deaccessionDate?: string | null, scientificName?: string | null, updatedAt?: string | null, notes?: string | null, ipenNumber?: string | null, provenanceCategoryCode: ProvenanceCategoryCode, donor?: string | null, createdByInitials?: string | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, materialType?: { __typename?: 'MaterialType', name: string } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, taxon?: { __typename?: 'Taxon', scientificName: string, commonName?: string | null, fullyValidated: boolean, nativeDistribution?: string | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, status: TaxonomicStatus, nameSourceUrl: string, nameSource: NameSource, rank: TaxonomicRank, authorship?: string | null, classification?: { __typename?: 'Classification', family?: string | null } | null, taxon?: { __typename?: 'SharedTaxon', nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null } | null } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', name: string, codeId: ProvenanceCategoryCode } | null, plantMaterial?: Array<{ __typename?: 'PlantMaterial', status: PlantMaterialStatus, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null }> | null };

export type MaterialsListFieldsFragment = { __typename?: 'PlantMaterial', id: string, qualifier: string, status: PlantMaterialStatus, archived: boolean, quantity?: string | null, massPlanting: boolean, weight?: string | null, materialGroup: MaterialGroup, createdAt: string, firstPresent?: string | null, firstAbsent?: string | null, updatedAt: string, sex?: MaterialSex | null, tagNumber?: string | null, public: boolean, notes?: string | null, condition?: Condition | null, lastObserved?: string | null, daysOverdueFollowUp?: number | null, lastObservation?: { __typename?: 'Observation', id: string, createdAt: string, condition: ObservationConditionType } | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, followUp?: { __typename?: 'FollowUp', count: number, period: Period } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, archived: boolean } | null, accession?: { __typename?: 'Accession', accessionNumber: string, scientificName?: string | null, donor?: string | null, provenanceCategoryCode: ProvenanceCategoryCode, taxon?: { __typename?: 'Taxon', scientificName: string, commonName?: string | null, fullyValidated: boolean, nativeDistribution?: string | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, status: TaxonomicStatus, nameSourceUrl: string, nameSource: NameSource, rank: TaxonomicRank, authorship?: string | null, classification?: { __typename?: 'Classification', family?: string | null } | null, taxon?: { __typename?: 'SharedTaxon', nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null } | null } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', name: string, codeId: ProvenanceCategoryCode } | null } | null };

export type PageInfoFieldsFragment = { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null };

export type GetAccessionsQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
  orderBy?: InputMaybe<AccessionsOrderByInput>;
  searchTerm?: InputMaybe<AccessionsSearchTerm>;
  filters?: InputMaybe<AccessionFilter>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  plantMaterialFilters?: InputMaybe<PlantMaterialFilter>;
}>;


export type GetAccessionsQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', site?: { __typename?: 'CollectionSite', total?: number | null, result?: { __typename?: 'AccessionConnection', nodes: Array<{ __typename?: 'Accession', id: string, accessionNumber: string, accessionDate?: string | null, archived: boolean, deaccessionDate?: string | null, scientificName?: string | null, updatedAt?: string | null, notes?: string | null, ipenNumber?: string | null, provenanceCategoryCode: ProvenanceCategoryCode, donor?: string | null, createdByInitials?: string | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, materialType?: { __typename?: 'MaterialType', name: string } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, taxon?: { __typename?: 'Taxon', scientificName: string, commonName?: string | null, fullyValidated: boolean, nativeDistribution?: string | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, status: TaxonomicStatus, nameSourceUrl: string, nameSource: NameSource, rank: TaxonomicRank, authorship?: string | null, classification?: { __typename?: 'Classification', family?: string | null } | null, taxon?: { __typename?: 'SharedTaxon', nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null } | null } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', name: string, codeId: ProvenanceCategoryCode } | null, plantMaterial?: Array<{ __typename?: 'PlantMaterial', status: PlantMaterialStatus, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null }> | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } | null } | null } | null };

export type GetAccessionByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  filters?: InputMaybe<PlantMaterialFilter>;
}>;


export type GetAccessionByIdQuery = { __typename?: 'Query', accession?: { __typename?: 'Accession', id: string, archived: boolean, accessionNumber: string, accessionNumberFormat?: AccessionNumberFormat | null, accessionNumberPrefix?: number | null, accessionNumberSuffix?: number | null, exogenousAccessionNumber?: string | null, accessionDate?: string | null, scientificName?: string | null, provenanceCategoryCode: ProvenanceCategoryCode, donor?: string | null, ipenNumber?: string | null, createdByInitials?: string | null, notes?: string | null, notesData?: any | null, collectionDate?: string | null, collectionCountryCode?: string | null, collectionStateProvince?: string | null, collectionLocality?: string | null, collectionLocation?: string | null, collectionLatitude?: string | null, collectionLongitude?: string | null, collectionElevation?: string | null, collectionCollectors?: string | null, collectionCollectorsFieldNumber?: string | null, collectionHabitat?: string | null, collectionAssociatedTaxa?: string | null, collectionRemarks?: string | null, collectionCoordinateUncertainty?: number | null, identifiedBy?: string | null, dateIdentified?: string | null, identificationQualifier?: string | null, identificationVerificationStatus?: string | null, identificationRemarks?: string | null, deaccessionDate?: string | null, collectionSite?: { __typename?: 'CollectionSite', urlSlug: string } | null, taxon?: { __typename?: 'Taxon', id: string, archived: boolean, createdAt: string, updatedAt: string, scientificName: string, commonName?: string | null, nativeDistribution?: string | null, fullyValidated: boolean, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string, ordering: number } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, collectionCountry?: { __typename?: 'Country', codeId: string, countryCodeAlpha2?: string | null, name: string } | null, materialType?: { __typename?: 'MaterialType', id: string, code: string, name: string } | null, createdBy?: { __typename?: 'User', givenName?: string | null, familyName?: string | null, id: string, avatarUrl?: string | null, initials: string } | null, plantMaterial?: Array<{ __typename?: 'PlantMaterial', id: string, archived: boolean, status: PlantMaterialStatus, qualifier: string, materialGroup: MaterialGroup, massPlanting: boolean, public: boolean, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, archived: boolean } | null }> | null, historyConnection?: { __typename?: 'AccessionHistoryConnection', nodes: Array<{ __typename?: 'AccessionHistory', createdAt: string, wasManualImport: boolean, historicCreatedByInitials?: string | null, wasArchived?: boolean | null, wasRestored?: boolean | null, wasDeaccessioned?: boolean | null, wasReinstated?: boolean | null, fromAccessionNumber?: string | null, toAccessionNumber?: string | null, fromAccessionDate?: string | null, toAccessionDate?: string | null, fromScientificName?: string | null, toScientificName?: string | null, fromDonor?: string | null, toDonor?: string | null, fromIpenNumber?: string | null, toIpenNumber?: string | null, fromNotes?: string | null, toNotes?: string | null, fromCollectionDate?: string | null, toCollectionDate?: string | null, fromCollectionStateProvince?: string | null, toCollectionStateProvince?: string | null, fromCollectionLocality?: string | null, toCollectionLocality?: string | null, fromCollectionLocation?: string | null, toCollectionLocation?: string | null, fromCollectionLatitude?: string | null, toCollectionLatitude?: string | null, fromCollectionLongitude?: string | null, toCollectionLongitude?: string | null, fromCollectionElevation?: string | null, toCollectionElevation?: string | null, fromCollectionCollectors?: string | null, toCollectionCollectors?: string | null, fromCollectionCollectorsFieldNumber?: string | null, toCollectionCollectorsFieldNumber?: string | null, fromCollectionHabitat?: string | null, toCollectionHabitat?: string | null, fromCollectionAssociatedTaxa?: string | null, toCollectionAssociatedTaxa?: string | null, fromCollectionRemarks?: string | null, toCollectionRemarks?: string | null, fromCollectionCoordinateUncertainty?: number | null, toCollectionCoordinateUncertainty?: number | null, fromIdentifiedBy?: string | null, toIdentifiedBy?: string | null, fromDateIdentified?: string | null, toDateIdentified?: string | null, fromIdentificationQualifier?: string | null, toIdentificationQualifier?: string | null, fromIdentificationVerificationStatus?: string | null, toIdentificationVerificationStatus?: string | null, fromIdentificationRemarks?: string | null, toIdentificationRemarks?: string | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, createdPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string, wasManualImport: boolean } | null, archivedPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string } | null, restoredPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string } | null, fromProvenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string } | null, toProvenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string } | null, fromTaxon?: { __typename?: 'Taxon', id: string, scientificName: string, archived: boolean } | null, toTaxon?: { __typename?: 'Taxon', id: string, scientificName: string, archived: boolean } | null, fromMaterialType?: { __typename?: 'MaterialType', code: string, name: string } | null, toMaterialType?: { __typename?: 'MaterialType', code: string, name: string } | null, fromCollectionCountry?: { __typename?: 'Country', codeId: string, name: string } | null, toCollectionCountry?: { __typename?: 'Country', codeId: string, name: string } | null }> } | null } | null };

export type PlantMaterialsQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
  orderBy?: InputMaybe<PlantMaterialsOrderByInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<PlantMaterialFilter>;
  searchTerm?: InputMaybe<PlantMaterialsSearchTerm>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PlantMaterialsQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', site?: { __typename?: 'CollectionSite', total?: number | null, result?: { __typename?: 'PlantMaterialConnection', nodes: Array<{ __typename?: 'PlantMaterial', id: string, qualifier: string, status: PlantMaterialStatus, archived: boolean, quantity?: string | null, massPlanting: boolean, weight?: string | null, materialGroup: MaterialGroup, createdAt: string, firstPresent?: string | null, firstAbsent?: string | null, updatedAt: string, sex?: MaterialSex | null, tagNumber?: string | null, public: boolean, notes?: string | null, condition?: Condition | null, lastObserved?: string | null, daysOverdueFollowUp?: number | null, lastObservation?: { __typename?: 'Observation', id: string, createdAt: string, condition: ObservationConditionType } | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, followUp?: { __typename?: 'FollowUp', count: number, period: Period } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, archived: boolean } | null, accession?: { __typename?: 'Accession', accessionNumber: string, scientificName?: string | null, donor?: string | null, provenanceCategoryCode: ProvenanceCategoryCode, taxon?: { __typename?: 'Taxon', scientificName: string, commonName?: string | null, fullyValidated: boolean, nativeDistribution?: string | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, status: TaxonomicStatus, nameSourceUrl: string, nameSource: NameSource, rank: TaxonomicRank, authorship?: string | null, classification?: { __typename?: 'Classification', family?: string | null } | null, taxon?: { __typename?: 'SharedTaxon', nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null } | null } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', name: string, codeId: ProvenanceCategoryCode } | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } | null } | null } | null };

export type GetMeGardenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeGardenQuery = { __typename?: 'Query', me?: { __typename?: 'User', collectionSites?: Array<{ __typename?: 'CollectionSite', name: string, urlSlug: string }> | null } | null };

export type GetSiteTaxaQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
  searchTerm?: InputMaybe<TaxaSearchTerm>;
  orderBy?: InputMaybe<TaxaOrderByInput>;
  filter?: InputMaybe<TaxaFilter>;
}>;


export type GetSiteTaxaQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', site?: { __typename?: 'CollectionSite', total?: number | null, result?: { __typename?: 'TaxonConnection', nodes: Array<{ __typename?: 'Taxon', id: string, scientificName: string, authorship?: string | null, commonName?: string | null, fullyValidated: boolean, nativeDistribution?: string | null, notes?: string | null, updatedAt: string, updatedBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, status: TaxonomicStatus, nameSourceUrl: string, nameSource: NameSource, rank: TaxonomicRank, authorship?: string | null, parentPrimaryRank?: { __typename?: 'ScientificName', id: string, scientificName: string } | null, classification?: { __typename?: 'Classification', family?: string | null } | null, taxon?: { __typename?: 'SharedTaxon', nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } | null } | null } | null };

export type GetOrgDonorsQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  organisationSubdomain: Scalars['String']['input'];
}>;


export type GetOrgDonorsQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', donors?: { __typename?: 'ContactConnection', nodes: Array<{ __typename?: 'Contact', name: string }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } | null } | null };

export type GetSiteDonorsQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
}>;


export type GetSiteDonorsQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', site?: { __typename?: 'CollectionSite', donors?: { __typename?: 'ContactConnection', nodes: Array<{ __typename?: 'Contact', name: string }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } | null } | null } | null };

export type GetAllMaterialTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMaterialTypesQuery = { __typename?: 'Query', materialTypes?: Array<{ __typename?: 'MaterialType', id: string, name: string, code: string }> | null };

export type GetAllProvenanceCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProvenanceCategoriesQuery = { __typename?: 'Query', provenanceCategories?: Array<{ __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string, ordering: number }> | null };

export type CreateAccessionMutationVariables = Exact<{
  accession: CreateAccession;
}>;


export type CreateAccessionMutation = { __typename?: 'Mutation', createAccession?: { __typename?: 'CreatedAccession', id: string, accessionNumber: string } | null };

export type CountryFieldsFragment = { __typename?: 'Country', codeId: string, name: string };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'Query', countries?: Array<{ __typename?: 'Country', codeId: string, name: string }> | null };

export type GetManualAccessionNumberErrorsQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
  accessionNumberPrefix?: InputMaybe<Scalars['Int']['input']>;
  accessionNumberSuffix?: InputMaybe<Scalars['Int']['input']>;
  exogenousAccessionNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetManualAccessionNumberErrorsQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', site?: { __typename?: 'CollectionSite', errors?: Array<ManualAccessionNumberError> | null } | null } | null };

export type UploadFileMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'UploadPayload', uploadUrl: string, headers: Array<{ __typename?: 'UploadFileHeader', key: string, value: string }> } };

export type DashboardFieldsFragment = { __typename?: 'CollectionSite', name: string, accessionTotal?: number | null, plantMaterialTotal?: number | null, taxaTotal?: number | null, accessionTotal10DaysAgo?: number | null, accessionTotal20DaysAgo?: number | null, accessionTotalMonthAgo?: number | null, plantMaterialTotal10DaysAgo?: number | null, plantMaterialTotal20DaysAgo?: number | null, plantMaterialTotalMonthAgo?: number | null, taxaTotal10DaysAgo?: number | null, taxaTotal20DaysAgo?: number | null, taxaTotalMonthAgo?: number | null, provenanceCategoryCounts?: Array<{ __typename?: 'ProvenanceCategoryCount', provenanceCategoryCode: string, count: number }> | null, redListStatusCounts?: Array<{ __typename?: 'RedListStatusCount', redListStatus: RedListStatus, count: number }> | null, observationConditionCounts?: Array<{ __typename?: 'ObservationConditionCount', condition: string, count: number }> | null, observationHistoricSnapshots?: Array<{ __typename?: 'ObservationsHistoricSnapshot', timestamp: string, total: number, totalMaterials: number, totalOutdated: number }> | null, activity?: Array<{ __typename?: 'Activity', accessionId?: string | null, taxonId?: string | null, plantMaterialId?: string | null, updatedAt: string, accession?: { __typename?: 'Accession', accessionNumber: string, scientificName?: string | null, taxon?: { __typename?: 'Taxon', scientificName: string } | null } | null, taxon?: { __typename?: 'Taxon', scientificName: string, commonName?: string | null } | null, plantMaterial?: { __typename?: 'PlantMaterial', qualifier: string, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, archived: boolean } | null, accession?: { __typename?: 'Accession', scientificName?: string | null, accessionNumber: string, taxon?: { __typename?: 'Taxon', scientificName: string } | null } | null } | null, updatedBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null }> | null };

export type GetDashboardQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
  validAtMonthAgo?: InputMaybe<Scalars['DateTime']['input']>;
  validAt10DaysAgo?: InputMaybe<Scalars['DateTime']['input']>;
  validAt20DaysAgo?: InputMaybe<Scalars['DateTime']['input']>;
  activityFilter?: InputMaybe<ActivityFilter>;
}>;


export type GetDashboardQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', site?: { __typename?: 'CollectionSite', name: string, accessionTotal?: number | null, plantMaterialTotal?: number | null, taxaTotal?: number | null, accessionTotal10DaysAgo?: number | null, accessionTotal20DaysAgo?: number | null, accessionTotalMonthAgo?: number | null, plantMaterialTotal10DaysAgo?: number | null, plantMaterialTotal20DaysAgo?: number | null, plantMaterialTotalMonthAgo?: number | null, taxaTotal10DaysAgo?: number | null, taxaTotal20DaysAgo?: number | null, taxaTotalMonthAgo?: number | null, provenanceCategoryCounts?: Array<{ __typename?: 'ProvenanceCategoryCount', provenanceCategoryCode: string, count: number }> | null, redListStatusCounts?: Array<{ __typename?: 'RedListStatusCount', redListStatus: RedListStatus, count: number }> | null, observationConditionCounts?: Array<{ __typename?: 'ObservationConditionCount', condition: string, count: number }> | null, observationHistoricSnapshots?: Array<{ __typename?: 'ObservationsHistoricSnapshot', timestamp: string, total: number, totalMaterials: number, totalOutdated: number }> | null, activity?: Array<{ __typename?: 'Activity', accessionId?: string | null, taxonId?: string | null, plantMaterialId?: string | null, updatedAt: string, accession?: { __typename?: 'Accession', accessionNumber: string, scientificName?: string | null, taxon?: { __typename?: 'Taxon', scientificName: string } | null } | null, taxon?: { __typename?: 'Taxon', scientificName: string, commonName?: string | null } | null, plantMaterial?: { __typename?: 'PlantMaterial', qualifier: string, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, archived: boolean } | null, accession?: { __typename?: 'Accession', scientificName?: string | null, accessionNumber: string, taxon?: { __typename?: 'Taxon', scientificName: string } | null } | null } | null, updatedBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null }> | null } | null } | null };

export type CollectionSiteLocationFieldsFragment = { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, archived: boolean };

export type LocationListFieldsFragment = { __typename?: 'Location', collectionSiteId: string, id: string, name: string, description?: string | null, archived: boolean };

export type LocationFieldsFragment = { __typename?: 'Location', id: string, collectionSiteId: string, description?: string | null, name: string, archived: boolean, totalMaterial?: number | null, geometry?: any | null, geometryColor?: string | null, material?: { __typename?: 'PlantMaterialConnection', nodes: Array<{ __typename?: 'PlantMaterial', id: string, qualifier: string, status: PlantMaterialStatus, materialGroup: MaterialGroup, public: boolean, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, code?: string | null, archived: boolean } | null, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, accession?: { __typename?: 'Accession', accessionNumber: string, scientificName?: string | null, provenanceCategoryCode: ProvenanceCategoryCode, taxon?: { __typename?: 'Taxon', scientificName: string, commonName?: string | null, fullyValidated: boolean, nativeDistribution?: string | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, status: TaxonomicStatus, nameSourceUrl: string, nameSource: NameSource, rank: TaxonomicRank, authorship?: string | null, classification?: { __typename?: 'Classification', family?: string | null } | null, taxon?: { __typename?: 'SharedTaxon', nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null } | null } | null } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, lastObservation?: { __typename?: 'Observation', id: string, createdAt: string, condition: ObservationConditionType } | null, followUp?: { __typename?: 'FollowUp', count: number, period: Period } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } | null };

export type GetLocationByNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  materialFilter?: InputMaybe<PlantMaterialFilter>;
  materialSort?: InputMaybe<Array<MaterialSortInput> | MaterialSortInput>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLocationByNameQuery = { __typename?: 'Query', collectionSite?: { __typename?: 'CollectionSite', location?: { __typename?: 'Location', id: string, collectionSiteId: string, description?: string | null, name: string, archived: boolean, totalMaterial?: number | null, geometry?: any | null, geometryColor?: string | null, material?: { __typename?: 'PlantMaterialConnection', nodes: Array<{ __typename?: 'PlantMaterial', id: string, qualifier: string, status: PlantMaterialStatus, materialGroup: MaterialGroup, public: boolean, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, code?: string | null, archived: boolean } | null, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, accession?: { __typename?: 'Accession', accessionNumber: string, scientificName?: string | null, provenanceCategoryCode: ProvenanceCategoryCode, taxon?: { __typename?: 'Taxon', scientificName: string, commonName?: string | null, fullyValidated: boolean, nativeDistribution?: string | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, status: TaxonomicStatus, nameSourceUrl: string, nameSource: NameSource, rank: TaxonomicRank, authorship?: string | null, classification?: { __typename?: 'Classification', family?: string | null } | null, taxon?: { __typename?: 'SharedTaxon', nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null } | null } | null } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, lastObservation?: { __typename?: 'Observation', id: string, createdAt: string, condition: ObservationConditionType } | null, followUp?: { __typename?: 'FollowUp', count: number, period: Period } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } | null } | null } | null };

export type GetLocationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLocationQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, collectionSiteId: string, description?: string | null, name: string, archived: boolean, totalMaterial?: number | null, geometry?: any | null, geometryColor?: string | null, material?: { __typename?: 'PlantMaterialConnection', nodes: Array<{ __typename?: 'PlantMaterial', id: string, qualifier: string, materialGroup: MaterialGroup, status: PlantMaterialStatus, accession?: { __typename?: 'Accession', id: string, accessionNumber: string, scientificName?: string | null } | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, code?: string | null, archived: boolean } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null }> } | null } | null };

export type GetLocationsQueryVariables = Exact<{
  subdomain: Scalars['String']['input'];
  siteSlug: Scalars['String']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<LocationFilter>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<LocationOrderByInput>;
}>;


export type GetLocationsQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', site?: { __typename?: 'CollectionSite', locationsTotal?: number | null, locationsConnection?: { __typename?: 'LocationConnection', nodes: Array<{ __typename?: 'Location', geometry?: any | null, geometryColor?: string | null, collectionSiteId: string, id: string, name: string, description?: string | null, archived: boolean }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null };

export type CreateLocationMutationVariables = Exact<{
  input: CreateLocationInput;
  materialFilter?: InputMaybe<PlantMaterialFilter>;
  materialSort?: InputMaybe<Array<MaterialSortInput> | MaterialSortInput>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateLocationMutation = { __typename?: 'Mutation', createLocation: { __typename: 'LocationPayload', success: boolean, location?: { __typename?: 'Location', id: string, collectionSiteId: string, description?: string | null, name: string, archived: boolean, totalMaterial?: number | null, geometry?: any | null, geometryColor?: string | null, material?: { __typename?: 'PlantMaterialConnection', nodes: Array<{ __typename?: 'PlantMaterial', id: string, qualifier: string, status: PlantMaterialStatus, materialGroup: MaterialGroup, public: boolean, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, code?: string | null, archived: boolean } | null, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, accession?: { __typename?: 'Accession', accessionNumber: string, scientificName?: string | null, provenanceCategoryCode: ProvenanceCategoryCode, taxon?: { __typename?: 'Taxon', scientificName: string, commonName?: string | null, fullyValidated: boolean, nativeDistribution?: string | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, status: TaxonomicStatus, nameSourceUrl: string, nameSource: NameSource, rank: TaxonomicRank, authorship?: string | null, classification?: { __typename?: 'Classification', family?: string | null } | null, taxon?: { __typename?: 'SharedTaxon', nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null } | null } | null } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, lastObservation?: { __typename?: 'Observation', id: string, createdAt: string, condition: ObservationConditionType } | null, followUp?: { __typename?: 'FollowUp', count: number, period: Period } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } | null } | null, errors?: Array<{ __typename?: 'DuplicateCollectionSiteLocationCodeError', message: string } | { __typename?: 'GenericError' }> | null } };

export type UpdateLocationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateLocationInput;
  materialFilter?: InputMaybe<PlantMaterialFilter>;
  materialSort?: InputMaybe<Array<MaterialSortInput> | MaterialSortInput>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutation', updateLocation: { __typename: 'LocationPayload', success: boolean, location?: { __typename?: 'Location', id: string, collectionSiteId: string, description?: string | null, name: string, archived: boolean, totalMaterial?: number | null, geometry?: any | null, geometryColor?: string | null, material?: { __typename?: 'PlantMaterialConnection', nodes: Array<{ __typename?: 'PlantMaterial', id: string, qualifier: string, status: PlantMaterialStatus, materialGroup: MaterialGroup, public: boolean, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, code?: string | null, archived: boolean } | null, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, accession?: { __typename?: 'Accession', accessionNumber: string, scientificName?: string | null, provenanceCategoryCode: ProvenanceCategoryCode, taxon?: { __typename?: 'Taxon', scientificName: string, commonName?: string | null, fullyValidated: boolean, nativeDistribution?: string | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, status: TaxonomicStatus, nameSourceUrl: string, nameSource: NameSource, rank: TaxonomicRank, authorship?: string | null, classification?: { __typename?: 'Classification', family?: string | null } | null, taxon?: { __typename?: 'SharedTaxon', nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null } | null } | null } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, lastObservation?: { __typename?: 'Observation', id: string, createdAt: string, condition: ObservationConditionType } | null, followUp?: { __typename?: 'FollowUp', count: number, period: Period } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } | null } | null, errors?: Array<{ __typename?: 'DuplicateCollectionSiteLocationCodeError', message: string } | { __typename?: 'GenericError' }> | null } };

export type ArchiveCollectionSiteLocationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveCollectionSiteLocationMutation = { __typename?: 'Mutation', archiveCollectionSiteLocation: { __typename?: 'ArchiveResult', success: boolean } };

export type SingleCollectionSiteLocationFieldsFragment = { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, totalPlantMaterial?: number | null, archived: boolean };

export type GetCollectionSiteLocationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCollectionSiteLocationQuery = { __typename?: 'Query', collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, totalPlantMaterial?: number | null, archived: boolean } | null };

export type ObservationFieldsFragment = { __typename?: 'Observation', id: string, createdAt: string, updatedAt: string, editedAt?: string | null, archivedAt?: string | null, body?: string | null, bodyData?: any | null, condition: ObservationConditionType, user: { __typename?: 'User', id: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, initials: string }, material: { __typename?: 'PlantMaterial', id: string }, images: { __typename?: 'MaterialImageConnection', nodes: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> } };

export type CreateObservationMutationVariables = Exact<{
  input: CreateObservationInput;
  followUp?: InputMaybe<FollowUpInput>;
}>;


export type CreateObservationMutation = { __typename?: 'Mutation', createObservation: { __typename?: 'ObservationPayload', success: boolean, observation: { __typename?: 'Observation', id: string, createdAt: string, updatedAt: string, editedAt?: string | null, archivedAt?: string | null, body?: string | null, bodyData?: any | null, condition: ObservationConditionType, user: { __typename?: 'User', id: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, initials: string }, material: { __typename?: 'PlantMaterial', id: string }, images: { __typename?: 'MaterialImageConnection', nodes: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> } } } };

export type UpdateObservationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateObservationInput;
}>;


export type UpdateObservationMutation = { __typename?: 'Mutation', updateObservation: { __typename?: 'ObservationPayload', success: boolean, observation: { __typename?: 'Observation', id: string, createdAt: string, updatedAt: string, editedAt?: string | null, archivedAt?: string | null, body?: string | null, bodyData?: any | null, condition: ObservationConditionType, user: { __typename?: 'User', id: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, initials: string }, material: { __typename?: 'PlantMaterial', id: string }, images: { __typename?: 'MaterialImageConnection', nodes: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> } } } };

export type ArchiveObservationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveObservationMutation = { __typename?: 'Mutation', archiveObservation: { __typename?: 'ObservationPayload', success: boolean, observation: { __typename?: 'Observation', id: string, archivedAt?: string | null, updatedAt: string } } };

export type CreateMaterialImagesMutationVariables = Exact<{
  materialId: Scalars['ID']['input'];
  input: Array<CreateMaterialImageFromUrlInput> | CreateMaterialImageFromUrlInput;
}>;


export type CreateMaterialImagesMutation = { __typename?: 'Mutation', createMaterialImages: { __typename?: 'BatchMaterialImagePayload', success: boolean, materialImages: Array<{ __typename?: 'MaterialImage', id: string }> } };

export type MeOrganisationFieldsFragment = { __typename?: 'Organisation', id: string, name: string, subdomain: string, avatarUrl?: string | null, taxaInterpretationEnabled: boolean };

export type MeCollectionSitesFieldsFragment = { __typename?: 'CollectionSite', id: string, name: string, urlSlug: string, materialQualifierFormat: MaterialQualifierFormat, mapCenterLongitude?: number | null, mapCenterLatitude?: number | null, mapZoomLevel?: number | null, public: boolean, publicAbout?: string | null, publicWebsite?: string | null, publicContactEmail?: string | null, publicCountryCode?: string | null, publicLocation?: string | null, publicDefaultBaseMapId?: string | null, ipenNumbersEnabled: boolean, tagNumbersEnabled: boolean, sexEnabled: boolean, identificationFieldsEnabled: boolean, publicCountry?: { __typename?: 'Country', codeId: string, name: string, countryCodeAlpha2?: string | null } | null, members?: Array<{ __typename?: 'User', id: string, initials: string, avatarUrl?: string | null, email: string }> | null, baseMap?: { __typename?: 'BaseMap', id: string, name: string, url: string, attribution?: string | null, minZoom?: number | null, maxZoom?: number | null } | null };

export type CollectionSiteMembershipFieldsFragment = { __typename?: 'CollectionSiteMembership', collectionSiteId: string, userId: string, id: string };

export type GetMeOrgWithSitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeOrgWithSitesQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, email: string, givenName?: string | null, familyName?: string | null, collectionSiteMemberships?: Array<{ __typename?: 'CollectionSiteMembership', collectionSiteId: string, userId: string, id: string }> | null, organisation?: { __typename?: 'Organisation', id: string, name: string, subdomain: string, avatarUrl?: string | null, taxaInterpretationEnabled: boolean } | null, collectionSites?: Array<{ __typename?: 'CollectionSite', id: string, name: string, urlSlug: string, materialQualifierFormat: MaterialQualifierFormat, mapCenterLongitude?: number | null, mapCenterLatitude?: number | null, mapZoomLevel?: number | null, public: boolean, publicAbout?: string | null, publicWebsite?: string | null, publicContactEmail?: string | null, publicCountryCode?: string | null, publicLocation?: string | null, publicDefaultBaseMapId?: string | null, ipenNumbersEnabled: boolean, tagNumbersEnabled: boolean, sexEnabled: boolean, identificationFieldsEnabled: boolean, publicCountry?: { __typename?: 'Country', codeId: string, name: string, countryCodeAlpha2?: string | null } | null, members?: Array<{ __typename?: 'User', id: string, initials: string, avatarUrl?: string | null, email: string }> | null, baseMap?: { __typename?: 'BaseMap', id: string, name: string, url: string, attribution?: string | null, minZoom?: number | null, maxZoom?: number | null } | null }> | null } | null };

export type GetCollectionSiteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCollectionSiteQuery = { __typename?: 'Query', collectionSite?: { __typename?: 'CollectionSite', urlSlug: string, name: string, id: string, materialQualifierFormat: MaterialQualifierFormat, ipenNumbersEnabled: boolean, identificationFieldsEnabled: boolean, tagNumbersEnabled: boolean, sexEnabled: boolean, public: boolean, publicAbout?: string | null, publicWebsite?: string | null, publicContactEmail?: string | null, publicCountryCode?: string | null, publicLocation?: string | null, baseMap?: { __typename?: 'BaseMap', id: string, name: string, url: string, attribution?: string | null, minZoom?: number | null, maxZoom?: number | null } | null, publicCountry?: { __typename?: 'Country', codeId: string, name: string, countryCodeAlpha2?: string | null } | null } | null };

export type CreateCollectionSiteMembershipMutationVariables = Exact<{
  input: CreateCollectionSiteMembershipInput;
}>;


export type CreateCollectionSiteMembershipMutation = { __typename?: 'Mutation', createCollectionSiteMembership: { __typename?: 'CollectionSiteMembershipPayload', success: boolean } };

export type DeleteCollectionSiteMembershipMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCollectionSiteMembershipMutation = { __typename?: 'Mutation', deleteCollectionSiteMembership: { __typename?: 'DeleteResult', success: boolean } };

export type GetUserPermissionsQueryVariables = Exact<{
  subdomain: Scalars['String']['input'];
  collectionSiteSlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserPermissionsQuery = { __typename?: 'Query', permissions?: { __typename?: 'UserPermissions', isInvalidOrganisation: boolean, isInvalidCollectionSite: boolean, deactivated: boolean } | null };

export type AccessionHistoryFieldsFragment = { __typename?: 'AccessionHistory', createdAt: string, wasManualImport: boolean, historicCreatedByInitials?: string | null, wasArchived?: boolean | null, wasRestored?: boolean | null, wasDeaccessioned?: boolean | null, wasReinstated?: boolean | null, fromAccessionNumber?: string | null, toAccessionNumber?: string | null, fromAccessionDate?: string | null, toAccessionDate?: string | null, fromScientificName?: string | null, toScientificName?: string | null, fromDonor?: string | null, toDonor?: string | null, fromIpenNumber?: string | null, toIpenNumber?: string | null, fromNotes?: string | null, toNotes?: string | null, fromCollectionDate?: string | null, toCollectionDate?: string | null, fromCollectionStateProvince?: string | null, toCollectionStateProvince?: string | null, fromCollectionLocality?: string | null, toCollectionLocality?: string | null, fromCollectionLocation?: string | null, toCollectionLocation?: string | null, fromCollectionLatitude?: string | null, toCollectionLatitude?: string | null, fromCollectionLongitude?: string | null, toCollectionLongitude?: string | null, fromCollectionElevation?: string | null, toCollectionElevation?: string | null, fromCollectionCollectors?: string | null, toCollectionCollectors?: string | null, fromCollectionCollectorsFieldNumber?: string | null, toCollectionCollectorsFieldNumber?: string | null, fromCollectionHabitat?: string | null, toCollectionHabitat?: string | null, fromCollectionAssociatedTaxa?: string | null, toCollectionAssociatedTaxa?: string | null, fromCollectionRemarks?: string | null, toCollectionRemarks?: string | null, fromCollectionCoordinateUncertainty?: number | null, toCollectionCoordinateUncertainty?: number | null, fromIdentifiedBy?: string | null, toIdentifiedBy?: string | null, fromDateIdentified?: string | null, toDateIdentified?: string | null, fromIdentificationQualifier?: string | null, toIdentificationQualifier?: string | null, fromIdentificationVerificationStatus?: string | null, toIdentificationVerificationStatus?: string | null, fromIdentificationRemarks?: string | null, toIdentificationRemarks?: string | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, createdPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string, wasManualImport: boolean } | null, archivedPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string } | null, restoredPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string } | null, fromProvenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string } | null, toProvenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string } | null, fromTaxon?: { __typename?: 'Taxon', id: string, scientificName: string, archived: boolean } | null, toTaxon?: { __typename?: 'Taxon', id: string, scientificName: string, archived: boolean } | null, fromMaterialType?: { __typename?: 'MaterialType', code: string, name: string } | null, toMaterialType?: { __typename?: 'MaterialType', code: string, name: string } | null, fromCollectionCountry?: { __typename?: 'Country', codeId: string, name: string } | null, toCollectionCountry?: { __typename?: 'Country', codeId: string, name: string } | null };

export type AccessionFieldsFragment = { __typename?: 'Accession', id: string, archived: boolean, accessionNumber: string, accessionNumberFormat?: AccessionNumberFormat | null, accessionNumberPrefix?: number | null, accessionNumberSuffix?: number | null, exogenousAccessionNumber?: string | null, accessionDate?: string | null, scientificName?: string | null, provenanceCategoryCode: ProvenanceCategoryCode, donor?: string | null, ipenNumber?: string | null, createdByInitials?: string | null, notes?: string | null, notesData?: any | null, collectionDate?: string | null, collectionCountryCode?: string | null, collectionStateProvince?: string | null, collectionLocality?: string | null, collectionLocation?: string | null, collectionLatitude?: string | null, collectionLongitude?: string | null, collectionElevation?: string | null, collectionCollectors?: string | null, collectionCollectorsFieldNumber?: string | null, collectionHabitat?: string | null, collectionAssociatedTaxa?: string | null, collectionRemarks?: string | null, collectionCoordinateUncertainty?: number | null, identifiedBy?: string | null, dateIdentified?: string | null, identificationQualifier?: string | null, identificationVerificationStatus?: string | null, identificationRemarks?: string | null, deaccessionDate?: string | null, collectionSite?: { __typename?: 'CollectionSite', urlSlug: string } | null, taxon?: { __typename?: 'Taxon', id: string, archived: boolean, createdAt: string, updatedAt: string, scientificName: string, commonName?: string | null, nativeDistribution?: string | null, fullyValidated: boolean, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string, ordering: number } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, collectionCountry?: { __typename?: 'Country', codeId: string, countryCodeAlpha2?: string | null, name: string } | null, materialType?: { __typename?: 'MaterialType', id: string, code: string, name: string } | null, createdBy?: { __typename?: 'User', givenName?: string | null, familyName?: string | null, id: string, avatarUrl?: string | null, initials: string } | null, plantMaterial?: Array<{ __typename?: 'PlantMaterial', id: string, archived: boolean, status: PlantMaterialStatus, qualifier: string, materialGroup: MaterialGroup, massPlanting: boolean, public: boolean, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, archived: boolean } | null }> | null, historyConnection?: { __typename?: 'AccessionHistoryConnection', nodes: Array<{ __typename?: 'AccessionHistory', createdAt: string, wasManualImport: boolean, historicCreatedByInitials?: string | null, wasArchived?: boolean | null, wasRestored?: boolean | null, wasDeaccessioned?: boolean | null, wasReinstated?: boolean | null, fromAccessionNumber?: string | null, toAccessionNumber?: string | null, fromAccessionDate?: string | null, toAccessionDate?: string | null, fromScientificName?: string | null, toScientificName?: string | null, fromDonor?: string | null, toDonor?: string | null, fromIpenNumber?: string | null, toIpenNumber?: string | null, fromNotes?: string | null, toNotes?: string | null, fromCollectionDate?: string | null, toCollectionDate?: string | null, fromCollectionStateProvince?: string | null, toCollectionStateProvince?: string | null, fromCollectionLocality?: string | null, toCollectionLocality?: string | null, fromCollectionLocation?: string | null, toCollectionLocation?: string | null, fromCollectionLatitude?: string | null, toCollectionLatitude?: string | null, fromCollectionLongitude?: string | null, toCollectionLongitude?: string | null, fromCollectionElevation?: string | null, toCollectionElevation?: string | null, fromCollectionCollectors?: string | null, toCollectionCollectors?: string | null, fromCollectionCollectorsFieldNumber?: string | null, toCollectionCollectorsFieldNumber?: string | null, fromCollectionHabitat?: string | null, toCollectionHabitat?: string | null, fromCollectionAssociatedTaxa?: string | null, toCollectionAssociatedTaxa?: string | null, fromCollectionRemarks?: string | null, toCollectionRemarks?: string | null, fromCollectionCoordinateUncertainty?: number | null, toCollectionCoordinateUncertainty?: number | null, fromIdentifiedBy?: string | null, toIdentifiedBy?: string | null, fromDateIdentified?: string | null, toDateIdentified?: string | null, fromIdentificationQualifier?: string | null, toIdentificationQualifier?: string | null, fromIdentificationVerificationStatus?: string | null, toIdentificationVerificationStatus?: string | null, fromIdentificationRemarks?: string | null, toIdentificationRemarks?: string | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, createdPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string, wasManualImport: boolean } | null, archivedPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string } | null, restoredPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string } | null, fromProvenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string } | null, toProvenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string } | null, fromTaxon?: { __typename?: 'Taxon', id: string, scientificName: string, archived: boolean } | null, toTaxon?: { __typename?: 'Taxon', id: string, scientificName: string, archived: boolean } | null, fromMaterialType?: { __typename?: 'MaterialType', code: string, name: string } | null, toMaterialType?: { __typename?: 'MaterialType', code: string, name: string } | null, fromCollectionCountry?: { __typename?: 'Country', codeId: string, name: string } | null, toCollectionCountry?: { __typename?: 'Country', codeId: string, name: string } | null }> } | null };

export type GetAccessionQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
  accessionNumber: Scalars['String']['input'];
  filters?: InputMaybe<PlantMaterialFilter>;
}>;


export type GetAccessionQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', site?: { __typename?: 'CollectionSite', result?: { __typename?: 'Accession', id: string, archived: boolean, accessionNumber: string, accessionNumberFormat?: AccessionNumberFormat | null, accessionNumberPrefix?: number | null, accessionNumberSuffix?: number | null, exogenousAccessionNumber?: string | null, accessionDate?: string | null, scientificName?: string | null, provenanceCategoryCode: ProvenanceCategoryCode, donor?: string | null, ipenNumber?: string | null, createdByInitials?: string | null, notes?: string | null, notesData?: any | null, collectionDate?: string | null, collectionCountryCode?: string | null, collectionStateProvince?: string | null, collectionLocality?: string | null, collectionLocation?: string | null, collectionLatitude?: string | null, collectionLongitude?: string | null, collectionElevation?: string | null, collectionCollectors?: string | null, collectionCollectorsFieldNumber?: string | null, collectionHabitat?: string | null, collectionAssociatedTaxa?: string | null, collectionRemarks?: string | null, collectionCoordinateUncertainty?: number | null, identifiedBy?: string | null, dateIdentified?: string | null, identificationQualifier?: string | null, identificationVerificationStatus?: string | null, identificationRemarks?: string | null, deaccessionDate?: string | null, collectionSite?: { __typename?: 'CollectionSite', urlSlug: string } | null, taxon?: { __typename?: 'Taxon', id: string, archived: boolean, createdAt: string, updatedAt: string, scientificName: string, commonName?: string | null, nativeDistribution?: string | null, fullyValidated: boolean, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string, ordering: number } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, collectionCountry?: { __typename?: 'Country', codeId: string, countryCodeAlpha2?: string | null, name: string } | null, materialType?: { __typename?: 'MaterialType', id: string, code: string, name: string } | null, createdBy?: { __typename?: 'User', givenName?: string | null, familyName?: string | null, id: string, avatarUrl?: string | null, initials: string } | null, plantMaterial?: Array<{ __typename?: 'PlantMaterial', id: string, archived: boolean, status: PlantMaterialStatus, qualifier: string, materialGroup: MaterialGroup, massPlanting: boolean, public: boolean, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, archived: boolean } | null }> | null, historyConnection?: { __typename?: 'AccessionHistoryConnection', nodes: Array<{ __typename?: 'AccessionHistory', createdAt: string, wasManualImport: boolean, historicCreatedByInitials?: string | null, wasArchived?: boolean | null, wasRestored?: boolean | null, wasDeaccessioned?: boolean | null, wasReinstated?: boolean | null, fromAccessionNumber?: string | null, toAccessionNumber?: string | null, fromAccessionDate?: string | null, toAccessionDate?: string | null, fromScientificName?: string | null, toScientificName?: string | null, fromDonor?: string | null, toDonor?: string | null, fromIpenNumber?: string | null, toIpenNumber?: string | null, fromNotes?: string | null, toNotes?: string | null, fromCollectionDate?: string | null, toCollectionDate?: string | null, fromCollectionStateProvince?: string | null, toCollectionStateProvince?: string | null, fromCollectionLocality?: string | null, toCollectionLocality?: string | null, fromCollectionLocation?: string | null, toCollectionLocation?: string | null, fromCollectionLatitude?: string | null, toCollectionLatitude?: string | null, fromCollectionLongitude?: string | null, toCollectionLongitude?: string | null, fromCollectionElevation?: string | null, toCollectionElevation?: string | null, fromCollectionCollectors?: string | null, toCollectionCollectors?: string | null, fromCollectionCollectorsFieldNumber?: string | null, toCollectionCollectorsFieldNumber?: string | null, fromCollectionHabitat?: string | null, toCollectionHabitat?: string | null, fromCollectionAssociatedTaxa?: string | null, toCollectionAssociatedTaxa?: string | null, fromCollectionRemarks?: string | null, toCollectionRemarks?: string | null, fromCollectionCoordinateUncertainty?: number | null, toCollectionCoordinateUncertainty?: number | null, fromIdentifiedBy?: string | null, toIdentifiedBy?: string | null, fromDateIdentified?: string | null, toDateIdentified?: string | null, fromIdentificationQualifier?: string | null, toIdentificationQualifier?: string | null, fromIdentificationVerificationStatus?: string | null, toIdentificationVerificationStatus?: string | null, fromIdentificationRemarks?: string | null, toIdentificationRemarks?: string | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, createdPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string, wasManualImport: boolean } | null, archivedPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string } | null, restoredPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string } | null, fromProvenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string } | null, toProvenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string } | null, fromTaxon?: { __typename?: 'Taxon', id: string, scientificName: string, archived: boolean } | null, toTaxon?: { __typename?: 'Taxon', id: string, scientificName: string, archived: boolean } | null, fromMaterialType?: { __typename?: 'MaterialType', code: string, name: string } | null, toMaterialType?: { __typename?: 'MaterialType', code: string, name: string } | null, fromCollectionCountry?: { __typename?: 'Country', codeId: string, name: string } | null, toCollectionCountry?: { __typename?: 'Country', codeId: string, name: string } | null }> } | null } | null } | null } | null };

export type UpdateAccessionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updates: UpdateAccessionInput;
}>;


export type UpdateAccessionMutation = { __typename?: 'Mutation', updateAccession: { __typename: 'AccessionPayload', success: boolean } };

export type UpdateAccessionDataMutationVariables = Exact<{
  accessionId: Scalars['ID']['input'];
  updates: AccessionDataUpdates;
}>;


export type UpdateAccessionDataMutation = { __typename?: 'Mutation', updateAccessionData?: { __typename: 'Accession', id: string, accessionNumber: string } | { __typename: 'GenericError', message: string } | null };

export type UpdateCollectionDataMutationVariables = Exact<{
  accessionId: Scalars['ID']['input'];
  updates: CollectionDataUpdates;
}>;


export type UpdateCollectionDataMutation = { __typename?: 'Mutation', updateCollectionData?: { __typename: 'Accession' } | { __typename: 'GenericError', message: string } | null };

export type DeaccessionAccessionMutationVariables = Exact<{
  accessionId: Scalars['ID']['input'];
  deaccessionDate: Scalars['Date']['input'];
  setPlantMaterialsToAbsent: Scalars['Boolean']['input'];
}>;


export type DeaccessionAccessionMutation = { __typename?: 'Mutation', deaccessionAccession?: { __typename?: 'Accession', id: string } | null };

export type ReinstateAccessionMutationVariables = Exact<{
  accessionId: Scalars['ID']['input'];
}>;


export type ReinstateAccessionMutation = { __typename?: 'Mutation', reinstateAccession?: { __typename?: 'Accession', id: string } | null };

export type ArchiveAccessionMutationVariables = Exact<{
  accessionId: Scalars['ID']['input'];
  filters?: InputMaybe<PlantMaterialFilter>;
}>;


export type ArchiveAccessionMutation = { __typename?: 'Mutation', archiveAccession?: { __typename: 'Accession', id: string, archived: boolean, accessionNumber: string, accessionNumberFormat?: AccessionNumberFormat | null, accessionNumberPrefix?: number | null, accessionNumberSuffix?: number | null, exogenousAccessionNumber?: string | null, accessionDate?: string | null, scientificName?: string | null, provenanceCategoryCode: ProvenanceCategoryCode, donor?: string | null, ipenNumber?: string | null, createdByInitials?: string | null, notes?: string | null, notesData?: any | null, collectionDate?: string | null, collectionCountryCode?: string | null, collectionStateProvince?: string | null, collectionLocality?: string | null, collectionLocation?: string | null, collectionLatitude?: string | null, collectionLongitude?: string | null, collectionElevation?: string | null, collectionCollectors?: string | null, collectionCollectorsFieldNumber?: string | null, collectionHabitat?: string | null, collectionAssociatedTaxa?: string | null, collectionRemarks?: string | null, collectionCoordinateUncertainty?: number | null, identifiedBy?: string | null, dateIdentified?: string | null, identificationQualifier?: string | null, identificationVerificationStatus?: string | null, identificationRemarks?: string | null, deaccessionDate?: string | null, collectionSite?: { __typename?: 'CollectionSite', urlSlug: string } | null, taxon?: { __typename?: 'Taxon', id: string, archived: boolean, createdAt: string, updatedAt: string, scientificName: string, commonName?: string | null, nativeDistribution?: string | null, fullyValidated: boolean, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string, ordering: number } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, collectionCountry?: { __typename?: 'Country', codeId: string, countryCodeAlpha2?: string | null, name: string } | null, materialType?: { __typename?: 'MaterialType', id: string, code: string, name: string } | null, createdBy?: { __typename?: 'User', givenName?: string | null, familyName?: string | null, id: string, avatarUrl?: string | null, initials: string } | null, plantMaterial?: Array<{ __typename?: 'PlantMaterial', id: string, archived: boolean, status: PlantMaterialStatus, qualifier: string, materialGroup: MaterialGroup, massPlanting: boolean, public: boolean, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, archived: boolean } | null }> | null, historyConnection?: { __typename?: 'AccessionHistoryConnection', nodes: Array<{ __typename?: 'AccessionHistory', createdAt: string, wasManualImport: boolean, historicCreatedByInitials?: string | null, wasArchived?: boolean | null, wasRestored?: boolean | null, wasDeaccessioned?: boolean | null, wasReinstated?: boolean | null, fromAccessionNumber?: string | null, toAccessionNumber?: string | null, fromAccessionDate?: string | null, toAccessionDate?: string | null, fromScientificName?: string | null, toScientificName?: string | null, fromDonor?: string | null, toDonor?: string | null, fromIpenNumber?: string | null, toIpenNumber?: string | null, fromNotes?: string | null, toNotes?: string | null, fromCollectionDate?: string | null, toCollectionDate?: string | null, fromCollectionStateProvince?: string | null, toCollectionStateProvince?: string | null, fromCollectionLocality?: string | null, toCollectionLocality?: string | null, fromCollectionLocation?: string | null, toCollectionLocation?: string | null, fromCollectionLatitude?: string | null, toCollectionLatitude?: string | null, fromCollectionLongitude?: string | null, toCollectionLongitude?: string | null, fromCollectionElevation?: string | null, toCollectionElevation?: string | null, fromCollectionCollectors?: string | null, toCollectionCollectors?: string | null, fromCollectionCollectorsFieldNumber?: string | null, toCollectionCollectorsFieldNumber?: string | null, fromCollectionHabitat?: string | null, toCollectionHabitat?: string | null, fromCollectionAssociatedTaxa?: string | null, toCollectionAssociatedTaxa?: string | null, fromCollectionRemarks?: string | null, toCollectionRemarks?: string | null, fromCollectionCoordinateUncertainty?: number | null, toCollectionCoordinateUncertainty?: number | null, fromIdentifiedBy?: string | null, toIdentifiedBy?: string | null, fromDateIdentified?: string | null, toDateIdentified?: string | null, fromIdentificationQualifier?: string | null, toIdentificationQualifier?: string | null, fromIdentificationVerificationStatus?: string | null, toIdentificationVerificationStatus?: string | null, fromIdentificationRemarks?: string | null, toIdentificationRemarks?: string | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, createdPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string, wasManualImport: boolean } | null, archivedPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string } | null, restoredPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string } | null, fromProvenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string } | null, toProvenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string } | null, fromTaxon?: { __typename?: 'Taxon', id: string, scientificName: string, archived: boolean } | null, toTaxon?: { __typename?: 'Taxon', id: string, scientificName: string, archived: boolean } | null, fromMaterialType?: { __typename?: 'MaterialType', code: string, name: string } | null, toMaterialType?: { __typename?: 'MaterialType', code: string, name: string } | null, fromCollectionCountry?: { __typename?: 'Country', codeId: string, name: string } | null, toCollectionCountry?: { __typename?: 'Country', codeId: string, name: string } | null }> } | null } | { __typename: 'GenericError', message: string } | null };

export type ArchiveAccessionsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ArchiveAccessionsMutation = { __typename?: 'Mutation', batchArchiveAccessions?: { __typename?: 'BatchAccessionsPayload', success: boolean, accessions: Array<{ __typename?: 'Accession', id: string, archived: boolean }>, errors?: Array<{ __typename?: 'GenericError', message: string }> | null } | null };

export type RestoreAccessionMutationVariables = Exact<{
  accessionId: Scalars['ID']['input'];
  filters?: InputMaybe<PlantMaterialFilter>;
}>;


export type RestoreAccessionMutation = { __typename?: 'Mutation', restoreAccession?: { __typename: 'Accession', id: string, archived: boolean, accessionNumber: string, accessionNumberFormat?: AccessionNumberFormat | null, accessionNumberPrefix?: number | null, accessionNumberSuffix?: number | null, exogenousAccessionNumber?: string | null, accessionDate?: string | null, scientificName?: string | null, provenanceCategoryCode: ProvenanceCategoryCode, donor?: string | null, ipenNumber?: string | null, createdByInitials?: string | null, notes?: string | null, notesData?: any | null, collectionDate?: string | null, collectionCountryCode?: string | null, collectionStateProvince?: string | null, collectionLocality?: string | null, collectionLocation?: string | null, collectionLatitude?: string | null, collectionLongitude?: string | null, collectionElevation?: string | null, collectionCollectors?: string | null, collectionCollectorsFieldNumber?: string | null, collectionHabitat?: string | null, collectionAssociatedTaxa?: string | null, collectionRemarks?: string | null, collectionCoordinateUncertainty?: number | null, identifiedBy?: string | null, dateIdentified?: string | null, identificationQualifier?: string | null, identificationVerificationStatus?: string | null, identificationRemarks?: string | null, deaccessionDate?: string | null, collectionSite?: { __typename?: 'CollectionSite', urlSlug: string } | null, taxon?: { __typename?: 'Taxon', id: string, archived: boolean, createdAt: string, updatedAt: string, scientificName: string, commonName?: string | null, nativeDistribution?: string | null, fullyValidated: boolean, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string, ordering: number } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, collectionCountry?: { __typename?: 'Country', codeId: string, countryCodeAlpha2?: string | null, name: string } | null, materialType?: { __typename?: 'MaterialType', id: string, code: string, name: string } | null, createdBy?: { __typename?: 'User', givenName?: string | null, familyName?: string | null, id: string, avatarUrl?: string | null, initials: string } | null, plantMaterial?: Array<{ __typename?: 'PlantMaterial', id: string, archived: boolean, status: PlantMaterialStatus, qualifier: string, materialGroup: MaterialGroup, massPlanting: boolean, public: boolean, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, archived: boolean } | null }> | null, historyConnection?: { __typename?: 'AccessionHistoryConnection', nodes: Array<{ __typename?: 'AccessionHistory', createdAt: string, wasManualImport: boolean, historicCreatedByInitials?: string | null, wasArchived?: boolean | null, wasRestored?: boolean | null, wasDeaccessioned?: boolean | null, wasReinstated?: boolean | null, fromAccessionNumber?: string | null, toAccessionNumber?: string | null, fromAccessionDate?: string | null, toAccessionDate?: string | null, fromScientificName?: string | null, toScientificName?: string | null, fromDonor?: string | null, toDonor?: string | null, fromIpenNumber?: string | null, toIpenNumber?: string | null, fromNotes?: string | null, toNotes?: string | null, fromCollectionDate?: string | null, toCollectionDate?: string | null, fromCollectionStateProvince?: string | null, toCollectionStateProvince?: string | null, fromCollectionLocality?: string | null, toCollectionLocality?: string | null, fromCollectionLocation?: string | null, toCollectionLocation?: string | null, fromCollectionLatitude?: string | null, toCollectionLatitude?: string | null, fromCollectionLongitude?: string | null, toCollectionLongitude?: string | null, fromCollectionElevation?: string | null, toCollectionElevation?: string | null, fromCollectionCollectors?: string | null, toCollectionCollectors?: string | null, fromCollectionCollectorsFieldNumber?: string | null, toCollectionCollectorsFieldNumber?: string | null, fromCollectionHabitat?: string | null, toCollectionHabitat?: string | null, fromCollectionAssociatedTaxa?: string | null, toCollectionAssociatedTaxa?: string | null, fromCollectionRemarks?: string | null, toCollectionRemarks?: string | null, fromCollectionCoordinateUncertainty?: number | null, toCollectionCoordinateUncertainty?: number | null, fromIdentifiedBy?: string | null, toIdentifiedBy?: string | null, fromDateIdentified?: string | null, toDateIdentified?: string | null, fromIdentificationQualifier?: string | null, toIdentificationQualifier?: string | null, fromIdentificationVerificationStatus?: string | null, toIdentificationVerificationStatus?: string | null, fromIdentificationRemarks?: string | null, toIdentificationRemarks?: string | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, createdPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string, wasManualImport: boolean } | null, archivedPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string } | null, restoredPlantMaterial?: { __typename?: 'PlantMaterial', qualifier: string } | null, fromProvenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string } | null, toProvenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string } | null, fromTaxon?: { __typename?: 'Taxon', id: string, scientificName: string, archived: boolean } | null, toTaxon?: { __typename?: 'Taxon', id: string, scientificName: string, archived: boolean } | null, fromMaterialType?: { __typename?: 'MaterialType', code: string, name: string } | null, toMaterialType?: { __typename?: 'MaterialType', code: string, name: string } | null, fromCollectionCountry?: { __typename?: 'Country', codeId: string, name: string } | null, toCollectionCountry?: { __typename?: 'Country', codeId: string, name: string } | null }> } | null } | { __typename: 'GenericError', message: string } | null };

export type CreateMaterialMutationVariables = Exact<{
  accessionId: Scalars['ID']['input'];
  plantMaterial: PlantMaterialInput;
  relatedMaterialsFilters?: InputMaybe<PlantMaterialFilter>;
}>;


export type CreateMaterialMutation = { __typename?: 'Mutation', createPlantMaterial?: { __typename: 'GenericError', message: string } | { __typename: 'PlantMaterial', id: string, archived: boolean, qualifier: string, quantity?: string | null, massPlanting: boolean, weight?: string | null, status: PlantMaterialStatus, firstPresent?: string | null, firstAbsent?: string | null, materialGroup: MaterialGroup, notes?: string | null, notesData?: any | null, sex?: MaterialSex | null, tagNumber?: string | null, daysOverdueFollowUp?: number | null, public: boolean, lastObserved?: string | null, condition?: Condition | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, archived: boolean } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, followUp?: { __typename?: 'FollowUp', count: number, period: Period } | null, lastObservation?: { __typename?: 'Observation', id: string, createdAt: string, updatedAt: string, editedAt?: string | null, archivedAt?: string | null, body?: string | null, bodyData?: any | null, condition: ObservationConditionType, user: { __typename?: 'User', id: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, initials: string }, material: { __typename?: 'PlantMaterial', id: string }, images: { __typename?: 'MaterialImageConnection', nodes: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> } } | null, createdBy?: { __typename?: 'User', givenName?: string | null, familyName?: string | null, id: string, avatarUrl?: string | null, initials: string } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, accession?: { __typename?: 'Accession', id: string, accessionNumber: string, donor?: string | null, accessionDate?: string | null, scientificName?: string | null, archived: boolean, provenanceCategoryCode: ProvenanceCategoryCode, collectionSite?: { __typename?: 'CollectionSite', urlSlug: string } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, taxon?: { __typename?: 'Taxon', id: string, scientificName: string, commonName?: string | null, nativeDistribution?: string | null, fullyValidated: boolean, archived: boolean, createdAt: string, updatedAt: string, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string, ordering: number } | null, plantMaterial?: Array<{ __typename?: 'PlantMaterial', id: string, archived: boolean, status: PlantMaterialStatus, qualifier: string, materialGroup: MaterialGroup, massPlanting: boolean, public: boolean, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, code?: string | null, archived: boolean } | null, accession?: { __typename?: 'Accession', scientificName?: string | null } | null }> | null } | null, historyConnection?: { __typename?: 'PlantMaterialHistoryConnection', nodes: Array<{ __typename?: 'PlantMaterialHistory', createdAt: string, wasManualImport: boolean, historicCreatedByInitials?: string | null, wasArchived?: boolean | null, wasRestored?: boolean | null, fromStatus?: PlantMaterialStatus | null, toStatus?: PlantMaterialStatus | null, fromMaterialGroup?: string | null, toMaterialGroup?: string | null, fromCollectionSiteLocationId?: string | null, toCollectionSiteLocationId?: string | null, fromQuantity?: string | null, toQuantity?: string | null, fromMassPlanting?: boolean | null, toMassPlanting?: boolean | null, fromWeight?: string | null, toWeight?: string | null, fromFirstPresent?: string | null, toFirstPresent?: string | null, fromFirstAbsent?: string | null, toFirstAbsent?: string | null, fromSex?: MaterialSex | null, toSex?: MaterialSex | null, fromTagNumber?: string | null, toTagNumber?: string | null, fromNotes?: string | null, toNotes?: string | null, madePublic?: boolean | null, madePrivate?: boolean | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, fromCollectionSiteLocation?: { __typename?: 'CollectionSiteLocation', code?: string | null, name: string, archived: boolean } | null, toCollectionSiteLocation?: { __typename?: 'CollectionSiteLocation', code?: string | null, name: string, archived: boolean } | null, fromPosition?: { __typename?: 'GeographicPosition', longitude: number, latitude: number, elevation?: number | null } | null, toPosition?: { __typename?: 'GeographicPosition', longitude: number, latitude: number, elevation?: number | null } | null }> } | null } | null };

export type AddTagToAccessionsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
}>;


export type AddTagToAccessionsMutation = { __typename?: 'Mutation', addTagAccessions: { __typename?: 'BatchAccessionsPayload', success: boolean, errors?: Array<{ __typename?: 'GenericError', message: string }> | null, accessions: Array<{ __typename?: 'Accession', id: string }> } };

export type RemoveTagFromAccessionsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
}>;


export type RemoveTagFromAccessionsMutation = { __typename?: 'Mutation', removeTagAccessions: { __typename?: 'BatchAccessionsPayload', success: boolean, errors?: Array<{ __typename?: 'GenericError', message: string }> | null, accessions: Array<{ __typename?: 'Accession', id: string }> } };

export type MaterialImageFieldsFragment = { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null };

export type MaterialHistoryFieldsFragment = { __typename?: 'PlantMaterialHistory', createdAt: string, wasManualImport: boolean, historicCreatedByInitials?: string | null, wasArchived?: boolean | null, wasRestored?: boolean | null, fromStatus?: PlantMaterialStatus | null, toStatus?: PlantMaterialStatus | null, fromMaterialGroup?: string | null, toMaterialGroup?: string | null, fromCollectionSiteLocationId?: string | null, toCollectionSiteLocationId?: string | null, fromQuantity?: string | null, toQuantity?: string | null, fromMassPlanting?: boolean | null, toMassPlanting?: boolean | null, fromWeight?: string | null, toWeight?: string | null, fromFirstPresent?: string | null, toFirstPresent?: string | null, fromFirstAbsent?: string | null, toFirstAbsent?: string | null, fromSex?: MaterialSex | null, toSex?: MaterialSex | null, fromTagNumber?: string | null, toTagNumber?: string | null, fromNotes?: string | null, toNotes?: string | null, madePublic?: boolean | null, madePrivate?: boolean | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, fromCollectionSiteLocation?: { __typename?: 'CollectionSiteLocation', code?: string | null, name: string, archived: boolean } | null, toCollectionSiteLocation?: { __typename?: 'CollectionSiteLocation', code?: string | null, name: string, archived: boolean } | null, fromPosition?: { __typename?: 'GeographicPosition', longitude: number, latitude: number, elevation?: number | null } | null, toPosition?: { __typename?: 'GeographicPosition', longitude: number, latitude: number, elevation?: number | null } | null };

export type MaterialFieldsFragment = { __typename?: 'PlantMaterial', id: string, archived: boolean, qualifier: string, quantity?: string | null, massPlanting: boolean, weight?: string | null, status: PlantMaterialStatus, firstPresent?: string | null, firstAbsent?: string | null, materialGroup: MaterialGroup, notes?: string | null, notesData?: any | null, sex?: MaterialSex | null, tagNumber?: string | null, daysOverdueFollowUp?: number | null, public: boolean, lastObserved?: string | null, condition?: Condition | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, archived: boolean } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, followUp?: { __typename?: 'FollowUp', count: number, period: Period } | null, lastObservation?: { __typename?: 'Observation', id: string, createdAt: string, updatedAt: string, editedAt?: string | null, archivedAt?: string | null, body?: string | null, bodyData?: any | null, condition: ObservationConditionType, user: { __typename?: 'User', id: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, initials: string }, material: { __typename?: 'PlantMaterial', id: string }, images: { __typename?: 'MaterialImageConnection', nodes: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> } } | null, createdBy?: { __typename?: 'User', givenName?: string | null, familyName?: string | null, id: string, avatarUrl?: string | null, initials: string } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, accession?: { __typename?: 'Accession', id: string, accessionNumber: string, donor?: string | null, accessionDate?: string | null, scientificName?: string | null, archived: boolean, provenanceCategoryCode: ProvenanceCategoryCode, collectionSite?: { __typename?: 'CollectionSite', urlSlug: string } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, taxon?: { __typename?: 'Taxon', id: string, scientificName: string, commonName?: string | null, nativeDistribution?: string | null, fullyValidated: boolean, archived: boolean, createdAt: string, updatedAt: string, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string, ordering: number } | null, plantMaterial?: Array<{ __typename?: 'PlantMaterial', id: string, archived: boolean, status: PlantMaterialStatus, qualifier: string, materialGroup: MaterialGroup, massPlanting: boolean, public: boolean, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, code?: string | null, archived: boolean } | null, accession?: { __typename?: 'Accession', scientificName?: string | null } | null }> | null } | null, historyConnection?: { __typename?: 'PlantMaterialHistoryConnection', nodes: Array<{ __typename?: 'PlantMaterialHistory', createdAt: string, wasManualImport: boolean, historicCreatedByInitials?: string | null, wasArchived?: boolean | null, wasRestored?: boolean | null, fromStatus?: PlantMaterialStatus | null, toStatus?: PlantMaterialStatus | null, fromMaterialGroup?: string | null, toMaterialGroup?: string | null, fromCollectionSiteLocationId?: string | null, toCollectionSiteLocationId?: string | null, fromQuantity?: string | null, toQuantity?: string | null, fromMassPlanting?: boolean | null, toMassPlanting?: boolean | null, fromWeight?: string | null, toWeight?: string | null, fromFirstPresent?: string | null, toFirstPresent?: string | null, fromFirstAbsent?: string | null, toFirstAbsent?: string | null, fromSex?: MaterialSex | null, toSex?: MaterialSex | null, fromTagNumber?: string | null, toTagNumber?: string | null, fromNotes?: string | null, toNotes?: string | null, madePublic?: boolean | null, madePrivate?: boolean | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, fromCollectionSiteLocation?: { __typename?: 'CollectionSiteLocation', code?: string | null, name: string, archived: boolean } | null, toCollectionSiteLocation?: { __typename?: 'CollectionSiteLocation', code?: string | null, name: string, archived: boolean } | null, fromPosition?: { __typename?: 'GeographicPosition', longitude: number, latitude: number, elevation?: number | null } | null, toPosition?: { __typename?: 'GeographicPosition', longitude: number, latitude: number, elevation?: number | null } | null }> } | null };

export type GetMaterialByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  relatedMaterialsFilters?: InputMaybe<PlantMaterialFilter>;
}>;


export type GetMaterialByIdQuery = { __typename?: 'Query', material?: { __typename?: 'PlantMaterial', id: string, archived: boolean, qualifier: string, quantity?: string | null, massPlanting: boolean, weight?: string | null, status: PlantMaterialStatus, firstPresent?: string | null, firstAbsent?: string | null, materialGroup: MaterialGroup, notes?: string | null, notesData?: any | null, sex?: MaterialSex | null, tagNumber?: string | null, daysOverdueFollowUp?: number | null, public: boolean, lastObserved?: string | null, condition?: Condition | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, archived: boolean } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, followUp?: { __typename?: 'FollowUp', count: number, period: Period } | null, lastObservation?: { __typename?: 'Observation', id: string, createdAt: string, updatedAt: string, editedAt?: string | null, archivedAt?: string | null, body?: string | null, bodyData?: any | null, condition: ObservationConditionType, user: { __typename?: 'User', id: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, initials: string }, material: { __typename?: 'PlantMaterial', id: string }, images: { __typename?: 'MaterialImageConnection', nodes: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> } } | null, createdBy?: { __typename?: 'User', givenName?: string | null, familyName?: string | null, id: string, avatarUrl?: string | null, initials: string } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, accession?: { __typename?: 'Accession', id: string, accessionNumber: string, donor?: string | null, accessionDate?: string | null, scientificName?: string | null, archived: boolean, provenanceCategoryCode: ProvenanceCategoryCode, collectionSite?: { __typename?: 'CollectionSite', urlSlug: string } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, taxon?: { __typename?: 'Taxon', id: string, scientificName: string, commonName?: string | null, nativeDistribution?: string | null, fullyValidated: boolean, archived: boolean, createdAt: string, updatedAt: string, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string, ordering: number } | null, plantMaterial?: Array<{ __typename?: 'PlantMaterial', id: string, archived: boolean, status: PlantMaterialStatus, qualifier: string, materialGroup: MaterialGroup, massPlanting: boolean, public: boolean, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, code?: string | null, archived: boolean } | null, accession?: { __typename?: 'Accession', scientificName?: string | null } | null }> | null } | null, historyConnection?: { __typename?: 'PlantMaterialHistoryConnection', nodes: Array<{ __typename?: 'PlantMaterialHistory', createdAt: string, wasManualImport: boolean, historicCreatedByInitials?: string | null, wasArchived?: boolean | null, wasRestored?: boolean | null, fromStatus?: PlantMaterialStatus | null, toStatus?: PlantMaterialStatus | null, fromMaterialGroup?: string | null, toMaterialGroup?: string | null, fromCollectionSiteLocationId?: string | null, toCollectionSiteLocationId?: string | null, fromQuantity?: string | null, toQuantity?: string | null, fromMassPlanting?: boolean | null, toMassPlanting?: boolean | null, fromWeight?: string | null, toWeight?: string | null, fromFirstPresent?: string | null, toFirstPresent?: string | null, fromFirstAbsent?: string | null, toFirstAbsent?: string | null, fromSex?: MaterialSex | null, toSex?: MaterialSex | null, fromTagNumber?: string | null, toTagNumber?: string | null, fromNotes?: string | null, toNotes?: string | null, madePublic?: boolean | null, madePrivate?: boolean | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, fromCollectionSiteLocation?: { __typename?: 'CollectionSiteLocation', code?: string | null, name: string, archived: boolean } | null, toCollectionSiteLocation?: { __typename?: 'CollectionSiteLocation', code?: string | null, name: string, archived: boolean } | null, fromPosition?: { __typename?: 'GeographicPosition', longitude: number, latitude: number, elevation?: number | null } | null, toPosition?: { __typename?: 'GeographicPosition', longitude: number, latitude: number, elevation?: number | null } | null }> } | null } | null };

export type GetObservationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetObservationQuery = { __typename?: 'Query', observation?: { __typename?: 'Observation', id: string, createdAt: string, updatedAt: string, editedAt?: string | null, archivedAt?: string | null, body?: string | null, bodyData?: any | null, condition: ObservationConditionType, user: { __typename?: 'User', id: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, initials: string }, material: { __typename?: 'PlantMaterial', id: string }, images: { __typename?: 'MaterialImageConnection', nodes: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> } } | null };

export type GetMaterialQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
  accessionNumber: Scalars['String']['input'];
  qualifier: Scalars['String']['input'];
  relatedMaterialsFilters?: InputMaybe<PlantMaterialFilter>;
}>;


export type GetMaterialQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', site?: { __typename?: 'CollectionSite', result?: { __typename?: 'PlantMaterial', id: string, archived: boolean, qualifier: string, quantity?: string | null, massPlanting: boolean, weight?: string | null, status: PlantMaterialStatus, firstPresent?: string | null, firstAbsent?: string | null, materialGroup: MaterialGroup, notes?: string | null, notesData?: any | null, sex?: MaterialSex | null, tagNumber?: string | null, daysOverdueFollowUp?: number | null, public: boolean, lastObserved?: string | null, condition?: Condition | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, archived: boolean } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, followUp?: { __typename?: 'FollowUp', count: number, period: Period } | null, lastObservation?: { __typename?: 'Observation', id: string, createdAt: string, updatedAt: string, editedAt?: string | null, archivedAt?: string | null, body?: string | null, bodyData?: any | null, condition: ObservationConditionType, user: { __typename?: 'User', id: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, initials: string }, material: { __typename?: 'PlantMaterial', id: string }, images: { __typename?: 'MaterialImageConnection', nodes: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> } } | null, createdBy?: { __typename?: 'User', givenName?: string | null, familyName?: string | null, id: string, avatarUrl?: string | null, initials: string } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, accession?: { __typename?: 'Accession', id: string, accessionNumber: string, donor?: string | null, accessionDate?: string | null, scientificName?: string | null, archived: boolean, provenanceCategoryCode: ProvenanceCategoryCode, collectionSite?: { __typename?: 'CollectionSite', urlSlug: string } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, taxon?: { __typename?: 'Taxon', id: string, scientificName: string, commonName?: string | null, nativeDistribution?: string | null, fullyValidated: boolean, archived: boolean, createdAt: string, updatedAt: string, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string, ordering: number } | null, plantMaterial?: Array<{ __typename?: 'PlantMaterial', id: string, archived: boolean, status: PlantMaterialStatus, qualifier: string, materialGroup: MaterialGroup, massPlanting: boolean, public: boolean, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, code?: string | null, archived: boolean } | null, accession?: { __typename?: 'Accession', scientificName?: string | null } | null }> | null } | null, historyConnection?: { __typename?: 'PlantMaterialHistoryConnection', nodes: Array<{ __typename?: 'PlantMaterialHistory', createdAt: string, wasManualImport: boolean, historicCreatedByInitials?: string | null, wasArchived?: boolean | null, wasRestored?: boolean | null, fromStatus?: PlantMaterialStatus | null, toStatus?: PlantMaterialStatus | null, fromMaterialGroup?: string | null, toMaterialGroup?: string | null, fromCollectionSiteLocationId?: string | null, toCollectionSiteLocationId?: string | null, fromQuantity?: string | null, toQuantity?: string | null, fromMassPlanting?: boolean | null, toMassPlanting?: boolean | null, fromWeight?: string | null, toWeight?: string | null, fromFirstPresent?: string | null, toFirstPresent?: string | null, fromFirstAbsent?: string | null, toFirstAbsent?: string | null, fromSex?: MaterialSex | null, toSex?: MaterialSex | null, fromTagNumber?: string | null, toTagNumber?: string | null, fromNotes?: string | null, toNotes?: string | null, madePublic?: boolean | null, madePrivate?: boolean | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, fromCollectionSiteLocation?: { __typename?: 'CollectionSiteLocation', code?: string | null, name: string, archived: boolean } | null, toCollectionSiteLocation?: { __typename?: 'CollectionSiteLocation', code?: string | null, name: string, archived: boolean } | null, fromPosition?: { __typename?: 'GeographicPosition', longitude: number, latitude: number, elevation?: number | null } | null, toPosition?: { __typename?: 'GeographicPosition', longitude: number, latitude: number, elevation?: number | null } | null }> } | null } | null } | null } | null };

export type UpdatePlantMaterialMutationVariables = Exact<{
  materialId: Scalars['ID']['input'];
  updates: PlantMaterialUpdates;
  relatedMaterialsFilters?: InputMaybe<PlantMaterialFilter>;
}>;


export type UpdatePlantMaterialMutation = { __typename?: 'Mutation', updatePlantMaterial?: { __typename: 'GenericError', message: string } | { __typename: 'PlantMaterial', id: string, archived: boolean, qualifier: string, quantity?: string | null, massPlanting: boolean, weight?: string | null, status: PlantMaterialStatus, firstPresent?: string | null, firstAbsent?: string | null, materialGroup: MaterialGroup, notes?: string | null, notesData?: any | null, sex?: MaterialSex | null, tagNumber?: string | null, daysOverdueFollowUp?: number | null, public: boolean, lastObserved?: string | null, condition?: Condition | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, archived: boolean } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, followUp?: { __typename?: 'FollowUp', count: number, period: Period } | null, lastObservation?: { __typename?: 'Observation', id: string, createdAt: string, updatedAt: string, editedAt?: string | null, archivedAt?: string | null, body?: string | null, bodyData?: any | null, condition: ObservationConditionType, user: { __typename?: 'User', id: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, initials: string }, material: { __typename?: 'PlantMaterial', id: string }, images: { __typename?: 'MaterialImageConnection', nodes: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> } } | null, createdBy?: { __typename?: 'User', givenName?: string | null, familyName?: string | null, id: string, avatarUrl?: string | null, initials: string } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, accession?: { __typename?: 'Accession', id: string, accessionNumber: string, donor?: string | null, accessionDate?: string | null, scientificName?: string | null, archived: boolean, provenanceCategoryCode: ProvenanceCategoryCode, collectionSite?: { __typename?: 'CollectionSite', urlSlug: string } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, taxon?: { __typename?: 'Taxon', id: string, scientificName: string, commonName?: string | null, nativeDistribution?: string | null, fullyValidated: boolean, archived: boolean, createdAt: string, updatedAt: string, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string, ordering: number } | null, plantMaterial?: Array<{ __typename?: 'PlantMaterial', id: string, archived: boolean, status: PlantMaterialStatus, qualifier: string, materialGroup: MaterialGroup, massPlanting: boolean, public: boolean, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, code?: string | null, archived: boolean } | null, accession?: { __typename?: 'Accession', scientificName?: string | null } | null }> | null } | null, historyConnection?: { __typename?: 'PlantMaterialHistoryConnection', nodes: Array<{ __typename?: 'PlantMaterialHistory', createdAt: string, wasManualImport: boolean, historicCreatedByInitials?: string | null, wasArchived?: boolean | null, wasRestored?: boolean | null, fromStatus?: PlantMaterialStatus | null, toStatus?: PlantMaterialStatus | null, fromMaterialGroup?: string | null, toMaterialGroup?: string | null, fromCollectionSiteLocationId?: string | null, toCollectionSiteLocationId?: string | null, fromQuantity?: string | null, toQuantity?: string | null, fromMassPlanting?: boolean | null, toMassPlanting?: boolean | null, fromWeight?: string | null, toWeight?: string | null, fromFirstPresent?: string | null, toFirstPresent?: string | null, fromFirstAbsent?: string | null, toFirstAbsent?: string | null, fromSex?: MaterialSex | null, toSex?: MaterialSex | null, fromTagNumber?: string | null, toTagNumber?: string | null, fromNotes?: string | null, toNotes?: string | null, madePublic?: boolean | null, madePrivate?: boolean | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, fromCollectionSiteLocation?: { __typename?: 'CollectionSiteLocation', code?: string | null, name: string, archived: boolean } | null, toCollectionSiteLocation?: { __typename?: 'CollectionSiteLocation', code?: string | null, name: string, archived: boolean } | null, fromPosition?: { __typename?: 'GeographicPosition', longitude: number, latitude: number, elevation?: number | null } | null, toPosition?: { __typename?: 'GeographicPosition', longitude: number, latitude: number, elevation?: number | null } | null }> } | null } | null };

export type UpdateMaterialImageMutationVariables = Exact<{
  materialImageId: Scalars['ID']['input'];
  updates: MaterialImageUpdates;
}>;


export type UpdateMaterialImageMutation = { __typename?: 'Mutation', updateMaterialImage?: { __typename: 'GenericError', message: string } | { __typename: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null };

export type ArchiveMaterialMutationVariables = Exact<{
  materialId: Scalars['ID']['input'];
  relatedMaterialsFilters?: InputMaybe<PlantMaterialFilter>;
}>;


export type ArchiveMaterialMutation = { __typename?: 'Mutation', archivePlantMaterial?: { __typename: 'GenericError', message: string } | { __typename: 'PlantMaterial', id: string, archived: boolean, qualifier: string, quantity?: string | null, massPlanting: boolean, weight?: string | null, status: PlantMaterialStatus, firstPresent?: string | null, firstAbsent?: string | null, materialGroup: MaterialGroup, notes?: string | null, notesData?: any | null, sex?: MaterialSex | null, tagNumber?: string | null, daysOverdueFollowUp?: number | null, public: boolean, lastObserved?: string | null, condition?: Condition | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, archived: boolean } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, followUp?: { __typename?: 'FollowUp', count: number, period: Period } | null, lastObservation?: { __typename?: 'Observation', id: string, createdAt: string, updatedAt: string, editedAt?: string | null, archivedAt?: string | null, body?: string | null, bodyData?: any | null, condition: ObservationConditionType, user: { __typename?: 'User', id: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, initials: string }, material: { __typename?: 'PlantMaterial', id: string }, images: { __typename?: 'MaterialImageConnection', nodes: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> } } | null, createdBy?: { __typename?: 'User', givenName?: string | null, familyName?: string | null, id: string, avatarUrl?: string | null, initials: string } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, accession?: { __typename?: 'Accession', id: string, accessionNumber: string, donor?: string | null, accessionDate?: string | null, scientificName?: string | null, archived: boolean, provenanceCategoryCode: ProvenanceCategoryCode, collectionSite?: { __typename?: 'CollectionSite', urlSlug: string } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, taxon?: { __typename?: 'Taxon', id: string, scientificName: string, commonName?: string | null, nativeDistribution?: string | null, fullyValidated: boolean, archived: boolean, createdAt: string, updatedAt: string, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string, ordering: number } | null, plantMaterial?: Array<{ __typename?: 'PlantMaterial', id: string, archived: boolean, status: PlantMaterialStatus, qualifier: string, materialGroup: MaterialGroup, massPlanting: boolean, public: boolean, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, code?: string | null, archived: boolean } | null, accession?: { __typename?: 'Accession', scientificName?: string | null } | null }> | null } | null, historyConnection?: { __typename?: 'PlantMaterialHistoryConnection', nodes: Array<{ __typename?: 'PlantMaterialHistory', createdAt: string, wasManualImport: boolean, historicCreatedByInitials?: string | null, wasArchived?: boolean | null, wasRestored?: boolean | null, fromStatus?: PlantMaterialStatus | null, toStatus?: PlantMaterialStatus | null, fromMaterialGroup?: string | null, toMaterialGroup?: string | null, fromCollectionSiteLocationId?: string | null, toCollectionSiteLocationId?: string | null, fromQuantity?: string | null, toQuantity?: string | null, fromMassPlanting?: boolean | null, toMassPlanting?: boolean | null, fromWeight?: string | null, toWeight?: string | null, fromFirstPresent?: string | null, toFirstPresent?: string | null, fromFirstAbsent?: string | null, toFirstAbsent?: string | null, fromSex?: MaterialSex | null, toSex?: MaterialSex | null, fromTagNumber?: string | null, toTagNumber?: string | null, fromNotes?: string | null, toNotes?: string | null, madePublic?: boolean | null, madePrivate?: boolean | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, fromCollectionSiteLocation?: { __typename?: 'CollectionSiteLocation', code?: string | null, name: string, archived: boolean } | null, toCollectionSiteLocation?: { __typename?: 'CollectionSiteLocation', code?: string | null, name: string, archived: boolean } | null, fromPosition?: { __typename?: 'GeographicPosition', longitude: number, latitude: number, elevation?: number | null } | null, toPosition?: { __typename?: 'GeographicPosition', longitude: number, latitude: number, elevation?: number | null } | null }> } | null } | null };

export type ArchiveMaterialsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ArchiveMaterialsMutation = { __typename?: 'Mutation', archivePlantMaterials: { __typename?: 'BatchPlantMaterialPayload', success: boolean, plantMaterials: Array<{ __typename?: 'PlantMaterial', id: string, archived: boolean }>, errors?: Array<{ __typename?: 'GenericError', message: string }> | null } };

export type RestoreMaterialMutationVariables = Exact<{
  materialId: Scalars['ID']['input'];
  relatedMaterialsFilters?: InputMaybe<PlantMaterialFilter>;
}>;


export type RestoreMaterialMutation = { __typename?: 'Mutation', restorePlantMaterial?: { __typename: 'GenericError', message: string } | { __typename: 'PlantMaterial', id: string, archived: boolean, qualifier: string, quantity?: string | null, massPlanting: boolean, weight?: string | null, status: PlantMaterialStatus, firstPresent?: string | null, firstAbsent?: string | null, materialGroup: MaterialGroup, notes?: string | null, notesData?: any | null, sex?: MaterialSex | null, tagNumber?: string | null, daysOverdueFollowUp?: number | null, public: boolean, lastObserved?: string | null, condition?: Condition | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, description?: string | null, archived: boolean } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, followUp?: { __typename?: 'FollowUp', count: number, period: Period } | null, lastObservation?: { __typename?: 'Observation', id: string, createdAt: string, updatedAt: string, editedAt?: string | null, archivedAt?: string | null, body?: string | null, bodyData?: any | null, condition: ObservationConditionType, user: { __typename?: 'User', id: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, initials: string }, material: { __typename?: 'PlantMaterial', id: string }, images: { __typename?: 'MaterialImageConnection', nodes: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> } } | null, createdBy?: { __typename?: 'User', givenName?: string | null, familyName?: string | null, id: string, avatarUrl?: string | null, initials: string } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, accession?: { __typename?: 'Accession', id: string, accessionNumber: string, donor?: string | null, accessionDate?: string | null, scientificName?: string | null, archived: boolean, provenanceCategoryCode: ProvenanceCategoryCode, collectionSite?: { __typename?: 'CollectionSite', urlSlug: string } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, taxon?: { __typename?: 'Taxon', id: string, scientificName: string, commonName?: string | null, nativeDistribution?: string | null, fullyValidated: boolean, archived: boolean, createdAt: string, updatedAt: string, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', codeId: ProvenanceCategoryCode, name: string, ordering: number } | null, plantMaterial?: Array<{ __typename?: 'PlantMaterial', id: string, archived: boolean, status: PlantMaterialStatus, qualifier: string, materialGroup: MaterialGroup, massPlanting: boolean, public: boolean, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, code?: string | null, archived: boolean } | null, accession?: { __typename?: 'Accession', scientificName?: string | null } | null }> | null } | null, historyConnection?: { __typename?: 'PlantMaterialHistoryConnection', nodes: Array<{ __typename?: 'PlantMaterialHistory', createdAt: string, wasManualImport: boolean, historicCreatedByInitials?: string | null, wasArchived?: boolean | null, wasRestored?: boolean | null, fromStatus?: PlantMaterialStatus | null, toStatus?: PlantMaterialStatus | null, fromMaterialGroup?: string | null, toMaterialGroup?: string | null, fromCollectionSiteLocationId?: string | null, toCollectionSiteLocationId?: string | null, fromQuantity?: string | null, toQuantity?: string | null, fromMassPlanting?: boolean | null, toMassPlanting?: boolean | null, fromWeight?: string | null, toWeight?: string | null, fromFirstPresent?: string | null, toFirstPresent?: string | null, fromFirstAbsent?: string | null, toFirstAbsent?: string | null, fromSex?: MaterialSex | null, toSex?: MaterialSex | null, fromTagNumber?: string | null, toTagNumber?: string | null, fromNotes?: string | null, toNotes?: string | null, madePublic?: boolean | null, madePrivate?: boolean | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, fromCollectionSiteLocation?: { __typename?: 'CollectionSiteLocation', code?: string | null, name: string, archived: boolean } | null, toCollectionSiteLocation?: { __typename?: 'CollectionSiteLocation', code?: string | null, name: string, archived: boolean } | null, fromPosition?: { __typename?: 'GeographicPosition', longitude: number, latitude: number, elevation?: number | null } | null, toPosition?: { __typename?: 'GeographicPosition', longitude: number, latitude: number, elevation?: number | null } | null }> } | null } | null };

export type SetPrimaryImageMutationVariables = Exact<{
  materialImageId: Scalars['ID']['input'];
}>;


export type SetPrimaryImageMutation = { __typename?: 'Mutation', setPrimaryImage?: { __typename: 'GenericError', message: string } | { __typename: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null };

export type UnsetPrimaryImageMutationVariables = Exact<{
  materialImageId: Scalars['ID']['input'];
}>;


export type UnsetPrimaryImageMutation = { __typename?: 'Mutation', unsetPrimaryImage?: { __typename: 'GenericError', message: string } | { __typename: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null };

export type UploadMaterialImageMutationVariables = Exact<{
  plantMaterialId: Scalars['ID']['input'];
  image: MaterialImageUpload;
}>;


export type UploadMaterialImageMutation = { __typename?: 'Mutation', uploadMaterialImage?: { __typename?: 'GenericError' } | { __typename: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null };

export type ArchiveMaterialImageMutationVariables = Exact<{
  materialImageId: Scalars['ID']['input'];
}>;


export type ArchiveMaterialImageMutation = { __typename?: 'Mutation', archiveMaterialImage?: { __typename: 'GenericError', message: string } | { __typename: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null };

export type AddTagToMaterialsMutationVariables = Exact<{
  tagId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddTagToMaterialsMutation = { __typename?: 'Mutation', addTagPlantMaterials: { __typename?: 'BatchPlantMaterialPayload', success: boolean, plantMaterials: Array<{ __typename?: 'PlantMaterial', id: string }>, errors?: Array<{ __typename?: 'GenericError', message: string }> | null } };

export type RemoveTagFromMaterialsMutationVariables = Exact<{
  tagId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveTagFromMaterialsMutation = { __typename?: 'Mutation', removeTagPlantMaterials: { __typename?: 'BatchPlantMaterialPayload', success: boolean, plantMaterials: Array<{ __typename?: 'PlantMaterial', id: string }>, errors?: Array<{ __typename?: 'GenericError', message: string }> | null } };

export type UpdateCollectionSiteMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updates: CollectionSiteUpdates;
}>;


export type UpdateCollectionSiteMutation = { __typename?: 'Mutation', updateCollectionSite?: { __typename?: 'CollectionSiteResult', success: boolean, collectionSite?: { __typename?: 'CollectionSite', id: string, name: string, urlSlug: string, organisation?: { __typename?: 'Organisation', id: string, name: string, subdomain: string, avatarUrl?: string | null, taxaInterpretationEnabled: boolean } | null } | null } | null };

export type MemberFieldsFragment = { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null };

export type GetOrganisationMembersQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOrganisationMembersQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', members?: Array<{ __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null }> | null } | null };

export type SiteMembersQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SiteMembersQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', site?: { __typename?: 'CollectionSite', id: string, name: string, members?: Array<{ __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null }> | null } | null } | null };

export type InviteMembersMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  members: Array<InvitedMember> | InvitedMember;
  addToAllSites: Scalars['Boolean']['input'];
}>;


export type InviteMembersMutation = { __typename?: 'Mutation', inviteMembers?: { __typename: 'DuplicateEmailsError', message: string, duplicateEmails: Array<string> } | { __typename: 'GenericError', message: string } | { __typename: 'InvalidEmailsError' } | { __typename: 'InviteMembersSuccess', members?: Array<{ __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null }> | null } | null };

export type SubscriptionFieldsFragment = { __typename?: 'Subscription', id: string, createdAt: string, updatedAt?: string | null, createdManually: boolean, flexibleDays?: number | null, seats?: number | null, canceledAt?: string | null, renewsAt: string, cycle: BillingCycle, plan: SubscriptionPlan };

export type GetSubscriptionQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
}>;


export type GetSubscriptionQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', billingAccountStatus: BillingStatus, trialEnd?: string | null, subscription?: { __typename?: 'Subscription', id: string, createdAt: string, updatedAt?: string | null, createdManually: boolean, flexibleDays?: number | null, seats?: number | null, canceledAt?: string | null, renewsAt: string, cycle: BillingCycle, plan: SubscriptionPlan } | null } | null };

export type UpdateUserAccessRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  accessRole: AccessRole;
}>;


export type UpdateUserAccessRoleMutation = { __typename?: 'Mutation', updateUserAccessRole: { __typename?: 'UserAdminResult', success: boolean } };

export type UpdateOrganisationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: OrganisationUpdateInput;
}>;


export type UpdateOrganisationMutation = { __typename?: 'Mutation', updateOrganisation?: { __typename?: 'OrganisationPayload', success: boolean, organisation?: { __typename?: 'Organisation', id: string, name: string, subdomain: string, avatarUrl?: string | null, taxaInterpretationEnabled: boolean } | null } | null };

export type UploadOrganisationLogoMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
}>;


export type UploadOrganisationLogoMutation = { __typename?: 'Mutation', uploadOrganisationLogo?: { __typename?: 'OrganisationPayload', success: boolean, organisation?: { __typename?: 'Organisation', id: string, name: string, subdomain: string, avatarUrl?: string | null, taxaInterpretationEnabled: boolean } | null } | null };

export type DeactivateUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type DeactivateUserMutation = { __typename?: 'Mutation', deactivateUser: { __typename?: 'UserAdminResult', success: boolean } };

export type ReactivateUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type ReactivateUserMutation = { __typename?: 'Mutation', reactivateUser: { __typename?: 'UserAdminResult', success: boolean } };

export type OrganisationFieldsFragment = { __typename?: 'Organisation', id: string, name: string, subdomain: string, avatarUrl?: string | null, taxaInterpretationEnabled: boolean };

export type CollectionSitesFieldsFragment = { __typename?: 'CollectionSite', id: string, name: string, urlSlug: string, organisation?: { __typename?: 'Organisation', id: string, name: string, subdomain: string, avatarUrl?: string | null, taxaInterpretationEnabled: boolean } | null };

export type GetMeWithSitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeWithSitesQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, askMeAbout?: string | null, role?: string | null, accessRole: AccessRole, organisation?: { __typename?: 'Organisation', id: string, name: string, subdomain: string, avatarUrl?: string | null, taxaInterpretationEnabled: boolean } | null, collectionSites?: Array<{ __typename?: 'CollectionSite', id: string, name: string, urlSlug: string, organisation?: { __typename?: 'Organisation', id: string, name: string, subdomain: string, avatarUrl?: string | null, taxaInterpretationEnabled: boolean } | null }> | null, collectionSiteMemberships?: Array<{ __typename?: 'CollectionSiteMembership', collectionSiteId: string, userId: string, id: string }> | null } | null };

export type UpdateProfileMutationVariables = Exact<{
  profileChanges: ProfileChangesInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', familyName?: string | null, givenName?: string | null, askMeAbout?: string | null, role?: string | null } | null };

export type VerifyEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail?: { __typename: 'GenericError', message: string } | { __typename: 'VerifyEmailResult', status: string } | null };

export type CreateCollectionSiteMutationVariables = Exact<{
  input: CreateCollectionSiteInput;
}>;


export type CreateCollectionSiteMutation = { __typename?: 'Mutation', createCollectionSite?: { __typename?: 'CollectionSiteResult', success: boolean, collectionSite?: { __typename?: 'CollectionSite', id: string, name: string, urlSlug: string } | null, errors?: Array<{ __typename: 'DuplicateNameError', message: string } | { __typename: 'DuplicateUrlSlugError', message: string } | { __typename: 'GenericError', message: string }> | null } | null };

export type RecordTagFieldsFragment = { __typename?: 'RecordTag', id: string, name: string };

export type CollectionSiteTagsQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
  filters?: InputMaybe<RecordTagFilters>;
  orgFilters?: InputMaybe<RecordTagFilters>;
}>;


export type CollectionSiteTagsQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', tags?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, site?: { __typename?: 'CollectionSite', tags?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null } | null } | null };

export type OrganisationTagsQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  filters?: InputMaybe<RecordTagFilters>;
}>;


export type OrganisationTagsQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', tags?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null } | null };

export type UpdateRecordTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: RecordTagUpdateInput;
}>;


export type UpdateRecordTagMutation = { __typename?: 'Mutation', updateRecordTag?: { __typename?: 'RecordTagResult', success: boolean, recordTag?: { __typename?: 'RecordTag', id: string, name: string } | null, errors?: Array<{ __typename: 'DuplicateNameError', message: string } | { __typename?: 'GenericError' } | { __typename?: 'NotFoundError' } | { __typename: 'SiteTagMergeError', message: string, tags: Array<{ __typename?: 'RecordTag', name: string, collectionSite?: { __typename?: 'CollectionSite', id: string, name: string } | null }> }> | null } | null };

export type ArchiveRecordTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveRecordTagMutation = { __typename?: 'Mutation', archiveRecordTag?: { __typename?: 'ArchiveResult', success: boolean } | null };

export type CreateRecordTagMutationVariables = Exact<{
  input: RecordTagInput;
}>;


export type CreateRecordTagMutation = { __typename?: 'Mutation', createRecordTag?: { __typename?: 'RecordTagResult', success: boolean, recordTag?: { __typename?: 'RecordTag', id: string, name: string } | null, errors?: Array<{ __typename: 'DuplicateNameError', message: string } | { __typename?: 'GenericError' } | { __typename?: 'NotFoundError' } | { __typename: 'SiteTagMergeError', message: string, tags: Array<{ __typename?: 'RecordTag', name: string, collectionSite?: { __typename?: 'CollectionSite', id: string, name: string } | null }> }> | null } | null };

export type TaxaListFieldsFragment = { __typename?: 'Taxon', id: string, scientificName: string, authorship?: string | null, commonName?: string | null, fullyValidated: boolean, nativeDistribution?: string | null, notes?: string | null, updatedAt: string, updatedBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, status: TaxonomicStatus, nameSourceUrl: string, nameSource: NameSource, rank: TaxonomicRank, authorship?: string | null, parentPrimaryRank?: { __typename?: 'ScientificName', id: string, scientificName: string } | null, classification?: { __typename?: 'Classification', family?: string | null } | null, taxon?: { __typename?: 'SharedTaxon', nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null };

export type GetTaxaQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organisationSubdomain: Scalars['String']['input'];
  searchTerm?: InputMaybe<TaxaSearchTerm>;
  orderBy?: InputMaybe<TaxaOrderByInput>;
  filter?: InputMaybe<TaxaFilter>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTaxaQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', total?: number | null, result?: { __typename?: 'TaxonConnection', nodes: Array<{ __typename?: 'Taxon', id: string, scientificName: string, authorship?: string | null, commonName?: string | null, fullyValidated: boolean, nativeDistribution?: string | null, notes?: string | null, updatedAt: string, updatedBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, status: TaxonomicStatus, nameSourceUrl: string, nameSource: NameSource, rank: TaxonomicRank, authorship?: string | null, parentPrimaryRank?: { __typename?: 'ScientificName', id: string, scientificName: string } | null, classification?: { __typename?: 'Classification', family?: string | null } | null, taxon?: { __typename?: 'SharedTaxon', nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } | null } | null };

export type GetOrgLifeFormsQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
}>;


export type GetOrgLifeFormsQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } | null } | null };

export type GetSiteLifeFormsQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
}>;


export type GetSiteLifeFormsQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', site?: { __typename?: 'CollectionSite', lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } | null } | null } | null };

export type GetOrgRedListStatusCountsQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
}>;


export type GetOrgRedListStatusCountsQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', redListStatusCounts?: Array<{ __typename?: 'RedListStatusCount', redListStatus: RedListStatus, count: number }> | null } | null };

export type GetSiteRedListStatusCountsQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
}>;


export type GetSiteRedListStatusCountsQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', site?: { __typename?: 'CollectionSite', redListStatusCounts?: Array<{ __typename?: 'RedListStatusCount', redListStatus: RedListStatus, count: number }> | null } | null } | null };

export type CreateTaxonMutationVariables = Exact<{
  input: CreateTaxonInput;
}>;


export type CreateTaxonMutation = { __typename?: 'Mutation', createTaxon: { __typename?: 'TaxonResult', success: boolean, errors?: Array<{ __typename: 'DuplicateScientificNameError', message: string }> | null, taxon?: { __typename?: 'Taxon', id: string, scientificName: string } | null } };

export type GetSharedScientificNamesQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<ScientificNameOrderBy>;
  filter?: InputMaybe<ScientificNameFilter>;
}>;


export type GetSharedScientificNamesQuery = { __typename?: 'Query', sharedScientificNames: { __typename?: 'ScientificNameConnection', nodes: Array<{ __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, rank: TaxonomicRank, nameSource: NameSource }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } };

export type GetOrgSharedScientificNamesQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<ScientificNameOrderBy>;
  filter?: InputMaybe<ScientificNameFilter>;
  organisationSubdomain: Scalars['String']['input'];
}>;


export type GetOrgSharedScientificNamesQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', sharedScientificNames?: { __typename?: 'ScientificNameConnection', nodes: Array<{ __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, rank: TaxonomicRank, nameSource: NameSource }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } | null } | null };

export type GetSiteSharedScientificNamesQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<ScientificNameOrderBy>;
  filter?: InputMaybe<ScientificNameFilter>;
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
}>;


export type GetSiteSharedScientificNamesQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', site?: { __typename?: 'CollectionSite', sharedScientificNames?: { __typename?: 'ScientificNameConnection', nodes: Array<{ __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, rank: TaxonomicRank, nameSource: NameSource }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } | null } | null } | null };

export type ClassificationFieldsFragment = { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null };

export type ScientificNameFieldsFragment = { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null };

export type TaxonFieldsFragment = { __typename?: 'Taxon', id: string, archived: boolean, createdAt: string, updatedAt: string, scientificName: string, commonName?: string | null, authorship?: string | null, notes?: string | null, notesData?: any | null, fullyValidated: boolean, interpretationDescription?: string | null, nativeDistribution?: string | null, organisation?: { __typename?: 'Organisation', id: string, taxaInterpretationEnabled: boolean } | null, createdBy?: { __typename?: 'User', id: string } | null, updatedBy?: { __typename?: 'User', id: string } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null, historyConnection?: { __typename?: 'TaxonHistoryConnection', nodes: Array<{ __typename?: 'TaxonHistory', taxonId: string, createdAt: string, createdById?: string | null, wasArchived?: boolean | null, wasRestored?: boolean | null, fromScientificName?: string | null, toScientificName?: string | null, fromCommonName?: string | null, toCommonName?: string | null, fromAuthorship?: string | null, toAuthorship?: string | null, fromNotes?: string | null, toNotes?: string | null, fromInterpretationDescription?: string | null, toInterpretationDescription?: string | null, fromNativeDistribution?: string | null, toNativeDistribution?: string | null, taxon?: { __typename?: 'Taxon', id: string, scientificName: string, archived: boolean, createdAt: string, organisationId: string, updatedAt: string } | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, fromSharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null, toSharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null }> } | null, accessions?: Array<{ __typename?: 'Accession', id: string, accessionNumber: string, accessionDate?: string | null, scientificName?: string | null, collectionSite?: { __typename?: 'CollectionSite', id: string, name: string, urlSlug: string } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', name: string, codeId: ProvenanceCategoryCode } | null, plantMaterial?: Array<{ __typename?: 'PlantMaterial', id: string, archived: boolean, status: PlantMaterialStatus, qualifier: string, materialGroup: MaterialGroup, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, accession?: { __typename?: 'Accession', scientificName?: string | null, accessionNumber: string, collectionSite?: { __typename?: 'CollectionSite', id: string, name: string, urlSlug: string } | null } | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, code?: string | null, archived: boolean } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null }> | null }> | null };

export type GetTaxonQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  relatedMaterialsFilters?: InputMaybe<PlantMaterialFilter>;
}>;


export type GetTaxonQuery = { __typename?: 'Query', taxon?: { __typename?: 'Taxon', id: string, archived: boolean, createdAt: string, updatedAt: string, scientificName: string, commonName?: string | null, authorship?: string | null, notes?: string | null, notesData?: any | null, fullyValidated: boolean, interpretationDescription?: string | null, nativeDistribution?: string | null, organisation?: { __typename?: 'Organisation', id: string, taxaInterpretationEnabled: boolean } | null, createdBy?: { __typename?: 'User', id: string } | null, updatedBy?: { __typename?: 'User', id: string } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null, historyConnection?: { __typename?: 'TaxonHistoryConnection', nodes: Array<{ __typename?: 'TaxonHistory', taxonId: string, createdAt: string, createdById?: string | null, wasArchived?: boolean | null, wasRestored?: boolean | null, fromScientificName?: string | null, toScientificName?: string | null, fromCommonName?: string | null, toCommonName?: string | null, fromAuthorship?: string | null, toAuthorship?: string | null, fromNotes?: string | null, toNotes?: string | null, fromInterpretationDescription?: string | null, toInterpretationDescription?: string | null, fromNativeDistribution?: string | null, toNativeDistribution?: string | null, taxon?: { __typename?: 'Taxon', id: string, scientificName: string, archived: boolean, createdAt: string, organisationId: string, updatedAt: string } | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, fromSharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null, toSharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null }> } | null, accessions?: Array<{ __typename?: 'Accession', id: string, accessionNumber: string, accessionDate?: string | null, scientificName?: string | null, collectionSite?: { __typename?: 'CollectionSite', id: string, name: string, urlSlug: string } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', name: string, codeId: ProvenanceCategoryCode } | null, plantMaterial?: Array<{ __typename?: 'PlantMaterial', id: string, archived: boolean, status: PlantMaterialStatus, qualifier: string, materialGroup: MaterialGroup, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, accession?: { __typename?: 'Accession', scientificName?: string | null, accessionNumber: string, collectionSite?: { __typename?: 'CollectionSite', id: string, name: string, urlSlug: string } | null } | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, code?: string | null, archived: boolean } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null }> | null }> | null } | null };

export type GetSharedScientificNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSharedScientificNameQuery = { __typename?: 'Query', sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null };

export type ArchiveTaxonMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveTaxonMutation = { __typename?: 'Mutation', archiveTaxon: { __typename?: 'ArchiveResult', success: boolean } };

export type RestoreTaxonMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  relatedMaterialsFilters?: InputMaybe<PlantMaterialFilter>;
}>;


export type RestoreTaxonMutation = { __typename?: 'Mutation', restoreTaxon: { __typename?: 'TaxonResult', success: boolean, errors?: Array<{ __typename: 'DuplicateScientificNameError', message: string }> | null, taxon?: { __typename?: 'Taxon', id: string, archived: boolean, createdAt: string, updatedAt: string, scientificName: string, commonName?: string | null, authorship?: string | null, notes?: string | null, notesData?: any | null, fullyValidated: boolean, interpretationDescription?: string | null, nativeDistribution?: string | null, organisation?: { __typename?: 'Organisation', id: string, taxaInterpretationEnabled: boolean } | null, createdBy?: { __typename?: 'User', id: string } | null, updatedBy?: { __typename?: 'User', id: string } | null, tagsConnection?: { __typename?: 'RecordTagConnection', nodes: Array<{ __typename?: 'RecordTag', id: string, name: string }> } | null, sharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null, historyConnection?: { __typename?: 'TaxonHistoryConnection', nodes: Array<{ __typename?: 'TaxonHistory', taxonId: string, createdAt: string, createdById?: string | null, wasArchived?: boolean | null, wasRestored?: boolean | null, fromScientificName?: string | null, toScientificName?: string | null, fromCommonName?: string | null, toCommonName?: string | null, fromAuthorship?: string | null, toAuthorship?: string | null, fromNotes?: string | null, toNotes?: string | null, fromInterpretationDescription?: string | null, toInterpretationDescription?: string | null, fromNativeDistribution?: string | null, toNativeDistribution?: string | null, taxon?: { __typename?: 'Taxon', id: string, scientificName: string, archived: boolean, createdAt: string, organisationId: string, updatedAt: string } | null, createdBy?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null, fromSharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null, toSharedScientificName?: { __typename?: 'ScientificName', id: string, scientificName: string, authorship?: string | null, status: TaxonomicStatus, hybridType: HybridType, rank: TaxonomicRank, nameSource: NameSource, nameSourceUrl: string, taxon?: { __typename?: 'SharedTaxon', id: string, nativeDistribution?: string | null, climate?: string | null, globalRedListStatus?: RedListStatus | null, globalRedListSourceUrl?: string | null, lifeForms?: { __typename?: 'LifeFormConnection', nodes: Array<{ __typename?: 'LifeForm', id: string, name: string }> } | null } | null, classification?: { __typename?: 'Classification', class?: string | null, family?: string | null, genus?: string | null, infraspecies?: string | null, kingdom?: string | null, order?: string | null, phylum?: string | null, section?: string | null, series?: string | null, species?: string | null, subclass?: string | null, subfamily?: string | null, subgenus?: string | null, subkingdom?: string | null, suborder?: string | null, subphylum?: string | null, subsection?: string | null, subseries?: string | null, subspecies?: string | null, subtribe?: string | null, superorder?: string | null, tribe?: string | null } | null } | null }> } | null, accessions?: Array<{ __typename?: 'Accession', id: string, accessionNumber: string, accessionDate?: string | null, scientificName?: string | null, collectionSite?: { __typename?: 'CollectionSite', id: string, name: string, urlSlug: string } | null, provenanceCategory?: { __typename?: 'ProvenanceCategory', name: string, codeId: ProvenanceCategoryCode } | null, plantMaterial?: Array<{ __typename?: 'PlantMaterial', id: string, archived: boolean, status: PlantMaterialStatus, qualifier: string, materialGroup: MaterialGroup, position?: { __typename?: 'GeographicPosition', latitude: number, longitude: number, elevation?: number | null } | null, accession?: { __typename?: 'Accession', scientificName?: string | null, accessionNumber: string, collectionSite?: { __typename?: 'CollectionSite', id: string, name: string, urlSlug: string } | null } | null, collectionSiteLocation?: { __typename?: 'CollectionSiteLocation', id: string, name: string, code?: string | null, archived: boolean } | null, primaryImage?: { __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null } | null, images?: Array<{ __typename?: 'MaterialImage', id: string, fileName: string, bucketName: string, description?: string | null, capturedAt?: string | null, capturedBy?: string | null, uploadedAt?: string | null, manualImport: boolean, isPrimaryImage?: boolean | null, uploadedBy?: { __typename?: 'User', id: string, avatarUrl?: string | null, givenName?: string | null, familyName?: string | null, initials: string } | null }> | null }> | null }> | null } | null } };

export type UpdateTaxonMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTaxonInput;
}>;


export type UpdateTaxonMutation = { __typename?: 'Mutation', updateTaxon: { __typename?: 'TaxonResult', success: boolean, errors?: Array<{ __typename: 'DuplicateScientificNameError', message: string }> | null, taxon?: { __typename?: 'Taxon', id: string, scientificName: string } | null } };

export type ValidateArchiveTaxaQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ValidateArchiveTaxaQuery = { __typename?: 'Query', validateBatchArchiveTaxa: { __typename?: 'BatchTaxaPayload', success: boolean, errors?: Array<{ __typename: 'AssociatedAccessionsError', message: string, taxa: Array<{ __typename?: 'Taxon', id: string }> } | { __typename?: 'GenericError' }> | null, taxa: Array<{ __typename?: 'Taxon', id: string, archived: boolean }> } };

export type BatchArchiveTaxaMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BatchArchiveTaxaMutation = { __typename?: 'Mutation', batchArchiveTaxa: { __typename?: 'BatchTaxaPayload', success: boolean, errors?: Array<{ __typename: 'AssociatedAccessionsError', message: string, taxa: Array<{ __typename?: 'Taxon', id: string }> } | { __typename?: 'GenericError' }> | null, taxa: Array<{ __typename?: 'Taxon', id: string, archived: boolean }> } };

export type AddTagToTaxaMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
}>;


export type AddTagToTaxaMutation = { __typename?: 'Mutation', addTagTaxa: { __typename?: 'BatchTaxaPayload', success: boolean, errors?: Array<{ __typename?: 'AssociatedAccessionsError' } | { __typename?: 'GenericError', message: string }> | null, taxa: Array<{ __typename?: 'Taxon', id: string }> } };

export type RemoveTagFromTaxaMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
}>;


export type RemoveTagFromTaxaMutation = { __typename?: 'Mutation', removeTagTaxa: { __typename?: 'BatchTaxaPayload', success: boolean, errors?: Array<{ __typename?: 'AssociatedAccessionsError' } | { __typename?: 'GenericError', message: string }> | null, taxa: Array<{ __typename?: 'Taxon', id: string }> } };

export type GetOrganisationMemberQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetOrganisationMemberQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', member?: { __typename?: 'User', id: string, initials: string, email: string, givenName?: string | null, familyName?: string | null, avatarUrl?: string | null, isActivated: boolean, accessRole: AccessRole, deactivatedAt?: string | null } | null } | null };

export type UploadProfileImageMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadProfileImageMutation = { __typename?: 'Mutation', uploadProfileImage?: { __typename?: 'UserPayload', success: boolean } | null };

export type GetOrgCollectionSitesQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
}>;


export type GetOrgCollectionSitesQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', collectionSites?: Array<{ __typename?: 'CollectionSite', id: string, name: string, urlSlug: string, materialQualifierFormat: MaterialQualifierFormat, mapCenterLongitude?: number | null, mapCenterLatitude?: number | null, mapZoomLevel?: number | null, public: boolean, publicAbout?: string | null, publicWebsite?: string | null, publicContactEmail?: string | null, publicCountryCode?: string | null, publicLocation?: string | null, publicDefaultBaseMapId?: string | null, ipenNumbersEnabled: boolean, tagNumbersEnabled: boolean, sexEnabled: boolean, identificationFieldsEnabled: boolean, publicCountry?: { __typename?: 'Country', codeId: string, name: string, countryCodeAlpha2?: string | null } | null, members?: Array<{ __typename?: 'User', id: string, initials: string, avatarUrl?: string | null, email: string }> | null, baseMap?: { __typename?: 'BaseMap', id: string, name: string, url: string, attribution?: string | null, minZoom?: number | null, maxZoom?: number | null } | null }> | null } | null };

export type GetCollectionSiteFromNamesQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
  collectionSiteSlug: Scalars['String']['input'];
}>;


export type GetCollectionSiteFromNamesQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', id: string, name: string, subdomain: string, avatarUrl?: string | null, taxaInterpretationEnabled: boolean, site?: { __typename?: 'CollectionSite', id: string, name: string, urlSlug: string, materialQualifierFormat: MaterialQualifierFormat, mapCenterLongitude?: number | null, mapCenterLatitude?: number | null, mapZoomLevel?: number | null, public: boolean, publicAbout?: string | null, publicWebsite?: string | null, publicContactEmail?: string | null, publicCountryCode?: string | null, publicLocation?: string | null, publicDefaultBaseMapId?: string | null, ipenNumbersEnabled: boolean, tagNumbersEnabled: boolean, sexEnabled: boolean, identificationFieldsEnabled: boolean, publicCountry?: { __typename?: 'Country', codeId: string, name: string, countryCodeAlpha2?: string | null } | null, members?: Array<{ __typename?: 'User', id: string, initials: string, avatarUrl?: string | null, email: string }> | null, baseMap?: { __typename?: 'BaseMap', id: string, name: string, url: string, attribution?: string | null, minZoom?: number | null, maxZoom?: number | null } | null } | null } | null };

export type GetOrganisationFromNameQueryVariables = Exact<{
  organisationSubdomain: Scalars['String']['input'];
}>;


export type GetOrganisationFromNameQuery = { __typename?: 'Query', org?: { __typename?: 'Organisation', id: string, name: string, subdomain: string, avatarUrl?: string | null, taxaInterpretationEnabled: boolean } | null };


















































































































export type Requester<C = {}, E = unknown> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R> | AsyncIterable<R>
export function getSdk<C, E>(requester: Requester<C, E>) {
  return {
    GetAccessionScientificNames(variables: GetAccessionScientificNamesQueryVariables, options?: C): Promise<GetAccessionScientificNamesQuery> {
      return requester<GetAccessionScientificNamesQuery, GetAccessionScientificNamesQueryVariables>(Operations.GetAccessionScientificNamesDocument, variables, options) as Promise<GetAccessionScientificNamesQuery>;
    },
    GetMultiRankScientificNames(variables?: GetMultiRankScientificNamesQueryVariables, options?: C): Promise<GetMultiRankScientificNamesQuery> {
      return requester<GetMultiRankScientificNamesQuery, GetMultiRankScientificNamesQueryVariables>(Operations.GetMultiRankScientificNamesDocument, variables, options) as Promise<GetMultiRankScientificNamesQuery>;
    },
    ReferAFriend(variables: ReferAFriendMutationVariables, options?: C): Promise<ReferAFriendMutation> {
      return requester<ReferAFriendMutation, ReferAFriendMutationVariables>(Operations.ReferAFriendDocument, variables, options) as Promise<ReferAFriendMutation>;
    },
    GetUserSettings(variables?: GetUserSettingsQueryVariables, options?: C): Promise<GetUserSettingsQuery> {
      return requester<GetUserSettingsQuery, GetUserSettingsQueryVariables>(Operations.GetUserSettingsDocument, variables, options) as Promise<GetUserSettingsQuery>;
    },
    UpdateUserSettings(variables: UpdateUserSettingsMutationVariables, options?: C): Promise<UpdateUserSettingsMutation> {
      return requester<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(Operations.UpdateUserSettingsDocument, variables, options) as Promise<UpdateUserSettingsMutation>;
    },
    GetMe(variables?: GetMeQueryVariables, options?: C): Promise<GetMeQuery> {
      return requester<GetMeQuery, GetMeQueryVariables>(Operations.GetMeDocument, variables, options) as Promise<GetMeQuery>;
    },
    GetEntitySuggestions(variables: GetEntitySuggestionsQueryVariables, options?: C): Promise<GetEntitySuggestionsQuery> {
      return requester<GetEntitySuggestionsQuery, GetEntitySuggestionsQueryVariables>(Operations.GetEntitySuggestionsDocument, variables, options) as Promise<GetEntitySuggestionsQuery>;
    },
    UpdatePlantMaterials(variables: UpdatePlantMaterialsMutationVariables, options?: C): Promise<UpdatePlantMaterialsMutation> {
      return requester<UpdatePlantMaterialsMutation, UpdatePlantMaterialsMutationVariables>(Operations.UpdatePlantMaterialsDocument, variables, options) as Promise<UpdatePlantMaterialsMutation>;
    },
    GetPublicOrganisation(variables: GetPublicOrganisationQueryVariables, options?: C): Promise<GetPublicOrganisationQuery> {
      return requester<GetPublicOrganisationQuery, GetPublicOrganisationQueryVariables>(Operations.GetPublicOrganisationDocument, variables, options) as Promise<GetPublicOrganisationQuery>;
    },
    GetMapConfig(variables: GetMapConfigQueryVariables, options?: C): Promise<GetMapConfigQuery> {
      return requester<GetMapConfigQuery, GetMapConfigQueryVariables>(Operations.GetMapConfigDocument, variables, options) as Promise<GetMapConfigQuery>;
    },
    GetCollectionLocationGeometry(variables: GetCollectionLocationGeometryQueryVariables, options?: C): Promise<GetCollectionLocationGeometryQuery> {
      return requester<GetCollectionLocationGeometryQuery, GetCollectionLocationGeometryQueryVariables>(Operations.GetCollectionLocationGeometryDocument, variables, options) as Promise<GetCollectionLocationGeometryQuery>;
    },
    GetCollectionGeometry(variables: GetCollectionGeometryQueryVariables, options?: C): Promise<GetCollectionGeometryQuery> {
      return requester<GetCollectionGeometryQuery, GetCollectionGeometryQueryVariables>(Operations.GetCollectionGeometryDocument, variables, options) as Promise<GetCollectionGeometryQuery>;
    },
    GetCollectionGeometryWithinCircle(variables: GetCollectionGeometryWithinCircleQueryVariables, options?: C): Promise<GetCollectionGeometryWithinCircleQuery> {
      return requester<GetCollectionGeometryWithinCircleQuery, GetCollectionGeometryWithinCircleQueryVariables>(Operations.GetCollectionGeometryWithinCircleDocument, variables, options) as Promise<GetCollectionGeometryWithinCircleQuery>;
    },
    MapListMaterials(variables: MapListMaterialsQueryVariables, options?: C): Promise<MapListMaterialsQuery> {
      return requester<MapListMaterialsQuery, MapListMaterialsQueryVariables>(Operations.MapListMaterialsDocument, variables, options) as Promise<MapListMaterialsQuery>;
    },
    GetAccessions(variables: GetAccessionsQueryVariables, options?: C): Promise<GetAccessionsQuery> {
      return requester<GetAccessionsQuery, GetAccessionsQueryVariables>(Operations.GetAccessionsDocument, variables, options) as Promise<GetAccessionsQuery>;
    },
    GetAccessionById(variables: GetAccessionByIdQueryVariables, options?: C): Promise<GetAccessionByIdQuery> {
      return requester<GetAccessionByIdQuery, GetAccessionByIdQueryVariables>(Operations.GetAccessionByIdDocument, variables, options) as Promise<GetAccessionByIdQuery>;
    },
    PlantMaterials(variables: PlantMaterialsQueryVariables, options?: C): Promise<PlantMaterialsQuery> {
      return requester<PlantMaterialsQuery, PlantMaterialsQueryVariables>(Operations.PlantMaterialsDocument, variables, options) as Promise<PlantMaterialsQuery>;
    },
    GetMeGarden(variables?: GetMeGardenQueryVariables, options?: C): Promise<GetMeGardenQuery> {
      return requester<GetMeGardenQuery, GetMeGardenQueryVariables>(Operations.GetMeGardenDocument, variables, options) as Promise<GetMeGardenQuery>;
    },
    GetSiteTaxa(variables: GetSiteTaxaQueryVariables, options?: C): Promise<GetSiteTaxaQuery> {
      return requester<GetSiteTaxaQuery, GetSiteTaxaQueryVariables>(Operations.GetSiteTaxaDocument, variables, options) as Promise<GetSiteTaxaQuery>;
    },
    GetOrgDonors(variables: GetOrgDonorsQueryVariables, options?: C): Promise<GetOrgDonorsQuery> {
      return requester<GetOrgDonorsQuery, GetOrgDonorsQueryVariables>(Operations.GetOrgDonorsDocument, variables, options) as Promise<GetOrgDonorsQuery>;
    },
    GetSiteDonors(variables: GetSiteDonorsQueryVariables, options?: C): Promise<GetSiteDonorsQuery> {
      return requester<GetSiteDonorsQuery, GetSiteDonorsQueryVariables>(Operations.GetSiteDonorsDocument, variables, options) as Promise<GetSiteDonorsQuery>;
    },
    GetAllMaterialTypes(variables?: GetAllMaterialTypesQueryVariables, options?: C): Promise<GetAllMaterialTypesQuery> {
      return requester<GetAllMaterialTypesQuery, GetAllMaterialTypesQueryVariables>(Operations.GetAllMaterialTypesDocument, variables, options) as Promise<GetAllMaterialTypesQuery>;
    },
    GetAllProvenanceCategories(variables?: GetAllProvenanceCategoriesQueryVariables, options?: C): Promise<GetAllProvenanceCategoriesQuery> {
      return requester<GetAllProvenanceCategoriesQuery, GetAllProvenanceCategoriesQueryVariables>(Operations.GetAllProvenanceCategoriesDocument, variables, options) as Promise<GetAllProvenanceCategoriesQuery>;
    },
    CreateAccession(variables: CreateAccessionMutationVariables, options?: C): Promise<CreateAccessionMutation> {
      return requester<CreateAccessionMutation, CreateAccessionMutationVariables>(Operations.CreateAccessionDocument, variables, options) as Promise<CreateAccessionMutation>;
    },
    GetCountries(variables?: GetCountriesQueryVariables, options?: C): Promise<GetCountriesQuery> {
      return requester<GetCountriesQuery, GetCountriesQueryVariables>(Operations.GetCountriesDocument, variables, options) as Promise<GetCountriesQuery>;
    },
    GetManualAccessionNumberErrors(variables: GetManualAccessionNumberErrorsQueryVariables, options?: C): Promise<GetManualAccessionNumberErrorsQuery> {
      return requester<GetManualAccessionNumberErrorsQuery, GetManualAccessionNumberErrorsQueryVariables>(Operations.GetManualAccessionNumberErrorsDocument, variables, options) as Promise<GetManualAccessionNumberErrorsQuery>;
    },
    UploadFile(variables: UploadFileMutationVariables, options?: C): Promise<UploadFileMutation> {
      return requester<UploadFileMutation, UploadFileMutationVariables>(Operations.UploadFileDocument, variables, options) as Promise<UploadFileMutation>;
    },
    GetDashboard(variables: GetDashboardQueryVariables, options?: C): Promise<GetDashboardQuery> {
      return requester<GetDashboardQuery, GetDashboardQueryVariables>(Operations.GetDashboardDocument, variables, options) as Promise<GetDashboardQuery>;
    },
    GetLocationByName(variables: GetLocationByNameQueryVariables, options?: C): Promise<GetLocationByNameQuery> {
      return requester<GetLocationByNameQuery, GetLocationByNameQueryVariables>(Operations.GetLocationByNameDocument, variables, options) as Promise<GetLocationByNameQuery>;
    },
    GetLocation(variables: GetLocationQueryVariables, options?: C): Promise<GetLocationQuery> {
      return requester<GetLocationQuery, GetLocationQueryVariables>(Operations.GetLocationDocument, variables, options) as Promise<GetLocationQuery>;
    },
    GetLocations(variables: GetLocationsQueryVariables, options?: C): Promise<GetLocationsQuery> {
      return requester<GetLocationsQuery, GetLocationsQueryVariables>(Operations.GetLocationsDocument, variables, options) as Promise<GetLocationsQuery>;
    },
    CreateLocation(variables: CreateLocationMutationVariables, options?: C): Promise<CreateLocationMutation> {
      return requester<CreateLocationMutation, CreateLocationMutationVariables>(Operations.CreateLocationDocument, variables, options) as Promise<CreateLocationMutation>;
    },
    UpdateLocation(variables: UpdateLocationMutationVariables, options?: C): Promise<UpdateLocationMutation> {
      return requester<UpdateLocationMutation, UpdateLocationMutationVariables>(Operations.UpdateLocationDocument, variables, options) as Promise<UpdateLocationMutation>;
    },
    ArchiveCollectionSiteLocation(variables: ArchiveCollectionSiteLocationMutationVariables, options?: C): Promise<ArchiveCollectionSiteLocationMutation> {
      return requester<ArchiveCollectionSiteLocationMutation, ArchiveCollectionSiteLocationMutationVariables>(Operations.ArchiveCollectionSiteLocationDocument, variables, options) as Promise<ArchiveCollectionSiteLocationMutation>;
    },
    GetCollectionSiteLocation(variables: GetCollectionSiteLocationQueryVariables, options?: C): Promise<GetCollectionSiteLocationQuery> {
      return requester<GetCollectionSiteLocationQuery, GetCollectionSiteLocationQueryVariables>(Operations.GetCollectionSiteLocationDocument, variables, options) as Promise<GetCollectionSiteLocationQuery>;
    },
    CreateObservation(variables: CreateObservationMutationVariables, options?: C): Promise<CreateObservationMutation> {
      return requester<CreateObservationMutation, CreateObservationMutationVariables>(Operations.CreateObservationDocument, variables, options) as Promise<CreateObservationMutation>;
    },
    UpdateObservation(variables: UpdateObservationMutationVariables, options?: C): Promise<UpdateObservationMutation> {
      return requester<UpdateObservationMutation, UpdateObservationMutationVariables>(Operations.UpdateObservationDocument, variables, options) as Promise<UpdateObservationMutation>;
    },
    ArchiveObservation(variables: ArchiveObservationMutationVariables, options?: C): Promise<ArchiveObservationMutation> {
      return requester<ArchiveObservationMutation, ArchiveObservationMutationVariables>(Operations.ArchiveObservationDocument, variables, options) as Promise<ArchiveObservationMutation>;
    },
    CreateMaterialImages(variables: CreateMaterialImagesMutationVariables, options?: C): Promise<CreateMaterialImagesMutation> {
      return requester<CreateMaterialImagesMutation, CreateMaterialImagesMutationVariables>(Operations.CreateMaterialImagesDocument, variables, options) as Promise<CreateMaterialImagesMutation>;
    },
    GetMeOrgWithSites(variables?: GetMeOrgWithSitesQueryVariables, options?: C): Promise<GetMeOrgWithSitesQuery> {
      return requester<GetMeOrgWithSitesQuery, GetMeOrgWithSitesQueryVariables>(Operations.GetMeOrgWithSitesDocument, variables, options) as Promise<GetMeOrgWithSitesQuery>;
    },
    GetCollectionSite(variables: GetCollectionSiteQueryVariables, options?: C): Promise<GetCollectionSiteQuery> {
      return requester<GetCollectionSiteQuery, GetCollectionSiteQueryVariables>(Operations.GetCollectionSiteDocument, variables, options) as Promise<GetCollectionSiteQuery>;
    },
    CreateCollectionSiteMembership(variables: CreateCollectionSiteMembershipMutationVariables, options?: C): Promise<CreateCollectionSiteMembershipMutation> {
      return requester<CreateCollectionSiteMembershipMutation, CreateCollectionSiteMembershipMutationVariables>(Operations.CreateCollectionSiteMembershipDocument, variables, options) as Promise<CreateCollectionSiteMembershipMutation>;
    },
    DeleteCollectionSiteMembership(variables: DeleteCollectionSiteMembershipMutationVariables, options?: C): Promise<DeleteCollectionSiteMembershipMutation> {
      return requester<DeleteCollectionSiteMembershipMutation, DeleteCollectionSiteMembershipMutationVariables>(Operations.DeleteCollectionSiteMembershipDocument, variables, options) as Promise<DeleteCollectionSiteMembershipMutation>;
    },
    GetUserPermissions(variables: GetUserPermissionsQueryVariables, options?: C): Promise<GetUserPermissionsQuery> {
      return requester<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>(Operations.GetUserPermissionsDocument, variables, options) as Promise<GetUserPermissionsQuery>;
    },
    GetAccession(variables: GetAccessionQueryVariables, options?: C): Promise<GetAccessionQuery> {
      return requester<GetAccessionQuery, GetAccessionQueryVariables>(Operations.GetAccessionDocument, variables, options) as Promise<GetAccessionQuery>;
    },
    UpdateAccession(variables: UpdateAccessionMutationVariables, options?: C): Promise<UpdateAccessionMutation> {
      return requester<UpdateAccessionMutation, UpdateAccessionMutationVariables>(Operations.UpdateAccessionDocument, variables, options) as Promise<UpdateAccessionMutation>;
    },
    UpdateAccessionData(variables: UpdateAccessionDataMutationVariables, options?: C): Promise<UpdateAccessionDataMutation> {
      return requester<UpdateAccessionDataMutation, UpdateAccessionDataMutationVariables>(Operations.UpdateAccessionDataDocument, variables, options) as Promise<UpdateAccessionDataMutation>;
    },
    UpdateCollectionData(variables: UpdateCollectionDataMutationVariables, options?: C): Promise<UpdateCollectionDataMutation> {
      return requester<UpdateCollectionDataMutation, UpdateCollectionDataMutationVariables>(Operations.UpdateCollectionDataDocument, variables, options) as Promise<UpdateCollectionDataMutation>;
    },
    DeaccessionAccession(variables: DeaccessionAccessionMutationVariables, options?: C): Promise<DeaccessionAccessionMutation> {
      return requester<DeaccessionAccessionMutation, DeaccessionAccessionMutationVariables>(Operations.DeaccessionAccessionDocument, variables, options) as Promise<DeaccessionAccessionMutation>;
    },
    ReinstateAccession(variables: ReinstateAccessionMutationVariables, options?: C): Promise<ReinstateAccessionMutation> {
      return requester<ReinstateAccessionMutation, ReinstateAccessionMutationVariables>(Operations.ReinstateAccessionDocument, variables, options) as Promise<ReinstateAccessionMutation>;
    },
    ArchiveAccession(variables: ArchiveAccessionMutationVariables, options?: C): Promise<ArchiveAccessionMutation> {
      return requester<ArchiveAccessionMutation, ArchiveAccessionMutationVariables>(Operations.ArchiveAccessionDocument, variables, options) as Promise<ArchiveAccessionMutation>;
    },
    ArchiveAccessions(variables: ArchiveAccessionsMutationVariables, options?: C): Promise<ArchiveAccessionsMutation> {
      return requester<ArchiveAccessionsMutation, ArchiveAccessionsMutationVariables>(Operations.ArchiveAccessionsDocument, variables, options) as Promise<ArchiveAccessionsMutation>;
    },
    RestoreAccession(variables: RestoreAccessionMutationVariables, options?: C): Promise<RestoreAccessionMutation> {
      return requester<RestoreAccessionMutation, RestoreAccessionMutationVariables>(Operations.RestoreAccessionDocument, variables, options) as Promise<RestoreAccessionMutation>;
    },
    CreateMaterial(variables: CreateMaterialMutationVariables, options?: C): Promise<CreateMaterialMutation> {
      return requester<CreateMaterialMutation, CreateMaterialMutationVariables>(Operations.CreateMaterialDocument, variables, options) as Promise<CreateMaterialMutation>;
    },
    AddTagToAccessions(variables: AddTagToAccessionsMutationVariables, options?: C): Promise<AddTagToAccessionsMutation> {
      return requester<AddTagToAccessionsMutation, AddTagToAccessionsMutationVariables>(Operations.AddTagToAccessionsDocument, variables, options) as Promise<AddTagToAccessionsMutation>;
    },
    RemoveTagFromAccessions(variables: RemoveTagFromAccessionsMutationVariables, options?: C): Promise<RemoveTagFromAccessionsMutation> {
      return requester<RemoveTagFromAccessionsMutation, RemoveTagFromAccessionsMutationVariables>(Operations.RemoveTagFromAccessionsDocument, variables, options) as Promise<RemoveTagFromAccessionsMutation>;
    },
    GetMaterialById(variables: GetMaterialByIdQueryVariables, options?: C): Promise<GetMaterialByIdQuery> {
      return requester<GetMaterialByIdQuery, GetMaterialByIdQueryVariables>(Operations.GetMaterialByIdDocument, variables, options) as Promise<GetMaterialByIdQuery>;
    },
    GetObservation(variables: GetObservationQueryVariables, options?: C): Promise<GetObservationQuery> {
      return requester<GetObservationQuery, GetObservationQueryVariables>(Operations.GetObservationDocument, variables, options) as Promise<GetObservationQuery>;
    },
    GetMaterial(variables: GetMaterialQueryVariables, options?: C): Promise<GetMaterialQuery> {
      return requester<GetMaterialQuery, GetMaterialQueryVariables>(Operations.GetMaterialDocument, variables, options) as Promise<GetMaterialQuery>;
    },
    UpdatePlantMaterial(variables: UpdatePlantMaterialMutationVariables, options?: C): Promise<UpdatePlantMaterialMutation> {
      return requester<UpdatePlantMaterialMutation, UpdatePlantMaterialMutationVariables>(Operations.UpdatePlantMaterialDocument, variables, options) as Promise<UpdatePlantMaterialMutation>;
    },
    UpdateMaterialImage(variables: UpdateMaterialImageMutationVariables, options?: C): Promise<UpdateMaterialImageMutation> {
      return requester<UpdateMaterialImageMutation, UpdateMaterialImageMutationVariables>(Operations.UpdateMaterialImageDocument, variables, options) as Promise<UpdateMaterialImageMutation>;
    },
    ArchiveMaterial(variables: ArchiveMaterialMutationVariables, options?: C): Promise<ArchiveMaterialMutation> {
      return requester<ArchiveMaterialMutation, ArchiveMaterialMutationVariables>(Operations.ArchiveMaterialDocument, variables, options) as Promise<ArchiveMaterialMutation>;
    },
    ArchiveMaterials(variables: ArchiveMaterialsMutationVariables, options?: C): Promise<ArchiveMaterialsMutation> {
      return requester<ArchiveMaterialsMutation, ArchiveMaterialsMutationVariables>(Operations.ArchiveMaterialsDocument, variables, options) as Promise<ArchiveMaterialsMutation>;
    },
    RestoreMaterial(variables: RestoreMaterialMutationVariables, options?: C): Promise<RestoreMaterialMutation> {
      return requester<RestoreMaterialMutation, RestoreMaterialMutationVariables>(Operations.RestoreMaterialDocument, variables, options) as Promise<RestoreMaterialMutation>;
    },
    SetPrimaryImage(variables: SetPrimaryImageMutationVariables, options?: C): Promise<SetPrimaryImageMutation> {
      return requester<SetPrimaryImageMutation, SetPrimaryImageMutationVariables>(Operations.SetPrimaryImageDocument, variables, options) as Promise<SetPrimaryImageMutation>;
    },
    UnsetPrimaryImage(variables: UnsetPrimaryImageMutationVariables, options?: C): Promise<UnsetPrimaryImageMutation> {
      return requester<UnsetPrimaryImageMutation, UnsetPrimaryImageMutationVariables>(Operations.UnsetPrimaryImageDocument, variables, options) as Promise<UnsetPrimaryImageMutation>;
    },
    UploadMaterialImage(variables: UploadMaterialImageMutationVariables, options?: C): Promise<UploadMaterialImageMutation> {
      return requester<UploadMaterialImageMutation, UploadMaterialImageMutationVariables>(Operations.UploadMaterialImageDocument, variables, options) as Promise<UploadMaterialImageMutation>;
    },
    ArchiveMaterialImage(variables: ArchiveMaterialImageMutationVariables, options?: C): Promise<ArchiveMaterialImageMutation> {
      return requester<ArchiveMaterialImageMutation, ArchiveMaterialImageMutationVariables>(Operations.ArchiveMaterialImageDocument, variables, options) as Promise<ArchiveMaterialImageMutation>;
    },
    AddTagToMaterials(variables: AddTagToMaterialsMutationVariables, options?: C): Promise<AddTagToMaterialsMutation> {
      return requester<AddTagToMaterialsMutation, AddTagToMaterialsMutationVariables>(Operations.AddTagToMaterialsDocument, variables, options) as Promise<AddTagToMaterialsMutation>;
    },
    RemoveTagFromMaterials(variables: RemoveTagFromMaterialsMutationVariables, options?: C): Promise<RemoveTagFromMaterialsMutation> {
      return requester<RemoveTagFromMaterialsMutation, RemoveTagFromMaterialsMutationVariables>(Operations.RemoveTagFromMaterialsDocument, variables, options) as Promise<RemoveTagFromMaterialsMutation>;
    },
    UpdateCollectionSite(variables: UpdateCollectionSiteMutationVariables, options?: C): Promise<UpdateCollectionSiteMutation> {
      return requester<UpdateCollectionSiteMutation, UpdateCollectionSiteMutationVariables>(Operations.UpdateCollectionSiteDocument, variables, options) as Promise<UpdateCollectionSiteMutation>;
    },
    GetOrganisationMembers(variables: GetOrganisationMembersQueryVariables, options?: C): Promise<GetOrganisationMembersQuery> {
      return requester<GetOrganisationMembersQuery, GetOrganisationMembersQueryVariables>(Operations.GetOrganisationMembersDocument, variables, options) as Promise<GetOrganisationMembersQuery>;
    },
    SiteMembers(variables: SiteMembersQueryVariables, options?: C): Promise<SiteMembersQuery> {
      return requester<SiteMembersQuery, SiteMembersQueryVariables>(Operations.SiteMembersDocument, variables, options) as Promise<SiteMembersQuery>;
    },
    InviteMembers(variables: InviteMembersMutationVariables, options?: C): Promise<InviteMembersMutation> {
      return requester<InviteMembersMutation, InviteMembersMutationVariables>(Operations.InviteMembersDocument, variables, options) as Promise<InviteMembersMutation>;
    },
    GetSubscription(variables: GetSubscriptionQueryVariables, options?: C): Promise<GetSubscriptionQuery> {
      return requester<GetSubscriptionQuery, GetSubscriptionQueryVariables>(Operations.GetSubscriptionDocument, variables, options) as Promise<GetSubscriptionQuery>;
    },
    UpdateUserAccessRole(variables: UpdateUserAccessRoleMutationVariables, options?: C): Promise<UpdateUserAccessRoleMutation> {
      return requester<UpdateUserAccessRoleMutation, UpdateUserAccessRoleMutationVariables>(Operations.UpdateUserAccessRoleDocument, variables, options) as Promise<UpdateUserAccessRoleMutation>;
    },
    UpdateOrganisation(variables: UpdateOrganisationMutationVariables, options?: C): Promise<UpdateOrganisationMutation> {
      return requester<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>(Operations.UpdateOrganisationDocument, variables, options) as Promise<UpdateOrganisationMutation>;
    },
    UploadOrganisationLogo(variables: UploadOrganisationLogoMutationVariables, options?: C): Promise<UploadOrganisationLogoMutation> {
      return requester<UploadOrganisationLogoMutation, UploadOrganisationLogoMutationVariables>(Operations.UploadOrganisationLogoDocument, variables, options) as Promise<UploadOrganisationLogoMutation>;
    },
    DeactivateUser(variables: DeactivateUserMutationVariables, options?: C): Promise<DeactivateUserMutation> {
      return requester<DeactivateUserMutation, DeactivateUserMutationVariables>(Operations.DeactivateUserDocument, variables, options) as Promise<DeactivateUserMutation>;
    },
    ReactivateUser(variables: ReactivateUserMutationVariables, options?: C): Promise<ReactivateUserMutation> {
      return requester<ReactivateUserMutation, ReactivateUserMutationVariables>(Operations.ReactivateUserDocument, variables, options) as Promise<ReactivateUserMutation>;
    },
    GetMeWithSites(variables?: GetMeWithSitesQueryVariables, options?: C): Promise<GetMeWithSitesQuery> {
      return requester<GetMeWithSitesQuery, GetMeWithSitesQueryVariables>(Operations.GetMeWithSitesDocument, variables, options) as Promise<GetMeWithSitesQuery>;
    },
    UpdateProfile(variables: UpdateProfileMutationVariables, options?: C): Promise<UpdateProfileMutation> {
      return requester<UpdateProfileMutation, UpdateProfileMutationVariables>(Operations.UpdateProfileDocument, variables, options) as Promise<UpdateProfileMutation>;
    },
    VerifyEmail(variables?: VerifyEmailMutationVariables, options?: C): Promise<VerifyEmailMutation> {
      return requester<VerifyEmailMutation, VerifyEmailMutationVariables>(Operations.VerifyEmailDocument, variables, options) as Promise<VerifyEmailMutation>;
    },
    CreateCollectionSite(variables: CreateCollectionSiteMutationVariables, options?: C): Promise<CreateCollectionSiteMutation> {
      return requester<CreateCollectionSiteMutation, CreateCollectionSiteMutationVariables>(Operations.CreateCollectionSiteDocument, variables, options) as Promise<CreateCollectionSiteMutation>;
    },
    CollectionSiteTags(variables: CollectionSiteTagsQueryVariables, options?: C): Promise<CollectionSiteTagsQuery> {
      return requester<CollectionSiteTagsQuery, CollectionSiteTagsQueryVariables>(Operations.CollectionSiteTagsDocument, variables, options) as Promise<CollectionSiteTagsQuery>;
    },
    OrganisationTags(variables: OrganisationTagsQueryVariables, options?: C): Promise<OrganisationTagsQuery> {
      return requester<OrganisationTagsQuery, OrganisationTagsQueryVariables>(Operations.OrganisationTagsDocument, variables, options) as Promise<OrganisationTagsQuery>;
    },
    UpdateRecordTag(variables: UpdateRecordTagMutationVariables, options?: C): Promise<UpdateRecordTagMutation> {
      return requester<UpdateRecordTagMutation, UpdateRecordTagMutationVariables>(Operations.UpdateRecordTagDocument, variables, options) as Promise<UpdateRecordTagMutation>;
    },
    ArchiveRecordTag(variables: ArchiveRecordTagMutationVariables, options?: C): Promise<ArchiveRecordTagMutation> {
      return requester<ArchiveRecordTagMutation, ArchiveRecordTagMutationVariables>(Operations.ArchiveRecordTagDocument, variables, options) as Promise<ArchiveRecordTagMutation>;
    },
    CreateRecordTag(variables: CreateRecordTagMutationVariables, options?: C): Promise<CreateRecordTagMutation> {
      return requester<CreateRecordTagMutation, CreateRecordTagMutationVariables>(Operations.CreateRecordTagDocument, variables, options) as Promise<CreateRecordTagMutation>;
    },
    GetTaxa(variables: GetTaxaQueryVariables, options?: C): Promise<GetTaxaQuery> {
      return requester<GetTaxaQuery, GetTaxaQueryVariables>(Operations.GetTaxaDocument, variables, options) as Promise<GetTaxaQuery>;
    },
    GetOrgLifeForms(variables: GetOrgLifeFormsQueryVariables, options?: C): Promise<GetOrgLifeFormsQuery> {
      return requester<GetOrgLifeFormsQuery, GetOrgLifeFormsQueryVariables>(Operations.GetOrgLifeFormsDocument, variables, options) as Promise<GetOrgLifeFormsQuery>;
    },
    GetSiteLifeForms(variables: GetSiteLifeFormsQueryVariables, options?: C): Promise<GetSiteLifeFormsQuery> {
      return requester<GetSiteLifeFormsQuery, GetSiteLifeFormsQueryVariables>(Operations.GetSiteLifeFormsDocument, variables, options) as Promise<GetSiteLifeFormsQuery>;
    },
    GetOrgRedListStatusCounts(variables: GetOrgRedListStatusCountsQueryVariables, options?: C): Promise<GetOrgRedListStatusCountsQuery> {
      return requester<GetOrgRedListStatusCountsQuery, GetOrgRedListStatusCountsQueryVariables>(Operations.GetOrgRedListStatusCountsDocument, variables, options) as Promise<GetOrgRedListStatusCountsQuery>;
    },
    GetSiteRedListStatusCounts(variables: GetSiteRedListStatusCountsQueryVariables, options?: C): Promise<GetSiteRedListStatusCountsQuery> {
      return requester<GetSiteRedListStatusCountsQuery, GetSiteRedListStatusCountsQueryVariables>(Operations.GetSiteRedListStatusCountsDocument, variables, options) as Promise<GetSiteRedListStatusCountsQuery>;
    },
    CreateTaxon(variables: CreateTaxonMutationVariables, options?: C): Promise<CreateTaxonMutation> {
      return requester<CreateTaxonMutation, CreateTaxonMutationVariables>(Operations.CreateTaxonDocument, variables, options) as Promise<CreateTaxonMutation>;
    },
    GetSharedScientificNames(variables?: GetSharedScientificNamesQueryVariables, options?: C): Promise<GetSharedScientificNamesQuery> {
      return requester<GetSharedScientificNamesQuery, GetSharedScientificNamesQueryVariables>(Operations.GetSharedScientificNamesDocument, variables, options) as Promise<GetSharedScientificNamesQuery>;
    },
    GetOrgSharedScientificNames(variables: GetOrgSharedScientificNamesQueryVariables, options?: C): Promise<GetOrgSharedScientificNamesQuery> {
      return requester<GetOrgSharedScientificNamesQuery, GetOrgSharedScientificNamesQueryVariables>(Operations.GetOrgSharedScientificNamesDocument, variables, options) as Promise<GetOrgSharedScientificNamesQuery>;
    },
    GetSiteSharedScientificNames(variables: GetSiteSharedScientificNamesQueryVariables, options?: C): Promise<GetSiteSharedScientificNamesQuery> {
      return requester<GetSiteSharedScientificNamesQuery, GetSiteSharedScientificNamesQueryVariables>(Operations.GetSiteSharedScientificNamesDocument, variables, options) as Promise<GetSiteSharedScientificNamesQuery>;
    },
    GetTaxon(variables: GetTaxonQueryVariables, options?: C): Promise<GetTaxonQuery> {
      return requester<GetTaxonQuery, GetTaxonQueryVariables>(Operations.GetTaxonDocument, variables, options) as Promise<GetTaxonQuery>;
    },
    GetSharedScientificName(variables: GetSharedScientificNameQueryVariables, options?: C): Promise<GetSharedScientificNameQuery> {
      return requester<GetSharedScientificNameQuery, GetSharedScientificNameQueryVariables>(Operations.GetSharedScientificNameDocument, variables, options) as Promise<GetSharedScientificNameQuery>;
    },
    ArchiveTaxon(variables: ArchiveTaxonMutationVariables, options?: C): Promise<ArchiveTaxonMutation> {
      return requester<ArchiveTaxonMutation, ArchiveTaxonMutationVariables>(Operations.ArchiveTaxonDocument, variables, options) as Promise<ArchiveTaxonMutation>;
    },
    RestoreTaxon(variables: RestoreTaxonMutationVariables, options?: C): Promise<RestoreTaxonMutation> {
      return requester<RestoreTaxonMutation, RestoreTaxonMutationVariables>(Operations.RestoreTaxonDocument, variables, options) as Promise<RestoreTaxonMutation>;
    },
    UpdateTaxon(variables: UpdateTaxonMutationVariables, options?: C): Promise<UpdateTaxonMutation> {
      return requester<UpdateTaxonMutation, UpdateTaxonMutationVariables>(Operations.UpdateTaxonDocument, variables, options) as Promise<UpdateTaxonMutation>;
    },
    ValidateArchiveTaxa(variables: ValidateArchiveTaxaQueryVariables, options?: C): Promise<ValidateArchiveTaxaQuery> {
      return requester<ValidateArchiveTaxaQuery, ValidateArchiveTaxaQueryVariables>(Operations.ValidateArchiveTaxaDocument, variables, options) as Promise<ValidateArchiveTaxaQuery>;
    },
    BatchArchiveTaxa(variables: BatchArchiveTaxaMutationVariables, options?: C): Promise<BatchArchiveTaxaMutation> {
      return requester<BatchArchiveTaxaMutation, BatchArchiveTaxaMutationVariables>(Operations.BatchArchiveTaxaDocument, variables, options) as Promise<BatchArchiveTaxaMutation>;
    },
    AddTagToTaxa(variables: AddTagToTaxaMutationVariables, options?: C): Promise<AddTagToTaxaMutation> {
      return requester<AddTagToTaxaMutation, AddTagToTaxaMutationVariables>(Operations.AddTagToTaxaDocument, variables, options) as Promise<AddTagToTaxaMutation>;
    },
    RemoveTagFromTaxa(variables: RemoveTagFromTaxaMutationVariables, options?: C): Promise<RemoveTagFromTaxaMutation> {
      return requester<RemoveTagFromTaxaMutation, RemoveTagFromTaxaMutationVariables>(Operations.RemoveTagFromTaxaDocument, variables, options) as Promise<RemoveTagFromTaxaMutation>;
    },
    GetOrganisationMember(variables: GetOrganisationMemberQueryVariables, options?: C): Promise<GetOrganisationMemberQuery> {
      return requester<GetOrganisationMemberQuery, GetOrganisationMemberQueryVariables>(Operations.GetOrganisationMemberDocument, variables, options) as Promise<GetOrganisationMemberQuery>;
    },
    UploadProfileImage(variables: UploadProfileImageMutationVariables, options?: C): Promise<UploadProfileImageMutation> {
      return requester<UploadProfileImageMutation, UploadProfileImageMutationVariables>(Operations.UploadProfileImageDocument, variables, options) as Promise<UploadProfileImageMutation>;
    },
    GetOrgCollectionSites(variables: GetOrgCollectionSitesQueryVariables, options?: C): Promise<GetOrgCollectionSitesQuery> {
      return requester<GetOrgCollectionSitesQuery, GetOrgCollectionSitesQueryVariables>(Operations.GetOrgCollectionSitesDocument, variables, options) as Promise<GetOrgCollectionSitesQuery>;
    },
    GetCollectionSiteFromNames(variables: GetCollectionSiteFromNamesQueryVariables, options?: C): Promise<GetCollectionSiteFromNamesQuery> {
      return requester<GetCollectionSiteFromNamesQuery, GetCollectionSiteFromNamesQueryVariables>(Operations.GetCollectionSiteFromNamesDocument, variables, options) as Promise<GetCollectionSiteFromNamesQuery>;
    },
    GetOrganisationFromName(variables: GetOrganisationFromNameQueryVariables, options?: C): Promise<GetOrganisationFromNameQuery> {
      return requester<GetOrganisationFromNameQuery, GetOrganisationFromNameQueryVariables>(Operations.GetOrganisationFromNameDocument, variables, options) as Promise<GetOrganisationFromNameQuery>;
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;